import React, { useState, useEffect, Fragment } from 'react';

//*MUI
import {
	Box,
	Card,
	Checkbox,
	Divider,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormHelperText,
	Popover,
	Tab,
	Tabs,
	Tooltip,
	Typography,
} from '@mui/material';
import Radio from '@mui/material/Radio';
import { makeStyles } from '@mui/styles';
//*redux
import { useDispatch } from 'react-redux';
import action from '../../../Redux Store/actions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import DoneIcon from "@mui/icons-material/Done";
//*files
import cssClasses from './ProjectDetails.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import JsFileDownloader from 'js-file-downloader';
import LaunchesIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import { getProjectByProjectName } from '../../../Services/SustenanceService';
import Datagrid from '../../../Subcomponents/Datagrid';
import Button from '../../../Subcomponents/Button';
import PlusIcon from '../../Icons/PlusIcon';
import Info from '../../Icons/InfoIcon';
import * as XLSX from 'xlsx';
import UnitIcon from '../../../Assets/Images/Sustenance/UnitIcon.svg';

import {
	getAllProjectsCollateral,
	getPaymentPlansFromDb,
	getProjectPricingByProjectId,
	RemoveBasePriceFromTable,
	RemoveCollateralFromTable,
	RemovePaymentPlanFromLaunch,
	RemovePaymentPlanFromTable,
	updateFlagsToProjectTable,
	ShowBasePrice,
	updateProject,
	getDefaultBasePricing,
	getDefaultBasePricingByProjectId,
	RemoveCPFromCollateralRelations,
	deleteCollateralFromStorage,
	addBookingAmounts,
	getBookingAmounts,
	CheckBookingAmounts,
	UpdateBookingAmounts,
	getAdditionalConfig,
	CheckAdditionalConfig,
	addAdditionalConfig,
	UpdateAdditionalConfig,
	UploadEmailDoc,
	addProjectLogsForSdrPercent,
	deleteUploadedEmailDoc,
	getParkingInventory,
	getParkingTypes,
	getParkingTypesFromInventory,
	addProjectToDb,
	addWing,
	getJdProjectsByParentId,
} from '../../../Services/Project';
import {
	getAllInventory,
	getProjectInventory,
	getInventoryMerge,
	insertIntoInventoryMerge,
	updateInventory,
	updateProjectInventoryRelations,
	deleteInventoryMerge,
	insertIntoProjectInventoryRelations,
	deleteInventoryRelationsOfProject,
	getProjectInventoryWithLeadData,
	getProjectForPaymentPlan,
	getInventoryStatus,
	getUnitsForSdrPercentage,
	getJdInventoryByProject,
	getProjectInventoryByType,
} from '../../../Services/Inventory';

//*Collateral-Icons
import AddCollateral from '../../../Modals/AddCollateral/AddCollateral';
import AddPriceList from '../../../Modals/AddPriceList/AddPriceList';
import AddPaymentPlan from '../../../Modals/AddPaymentPlan/AddPaymentPlan';
import ViewCollateralDetails from '../../../Modals/ViewCollateralDetails/ViewCollateralDetails';
import ConfirmationAlert from '../../../Subcomponents/ConfirmationAlert';
import SelectInventory from '../../SelectInventory/SelectInventory';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import _, {
	cloneDeep,
	differenceWith,
	groupBy,
	isEqual,
	orderBy,
	sortBy,
	uniqBy,
} from 'lodash';
import { errorTost, infoTost, successTost } from '../../../Services/Toast';
import CreateFloorPlan from '../../../Modals/CreateFloorPlan/CreateFloorPlan';
import CustomSwitch from '../../../Subcomponents/CustomSwitch';
import UploadingDataModal from '../../../Modals/UploadingDataModal/UploadingDataModal';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import {
	AllotmentDiv,
	BlockDiv,
} from '../../../Subcomponents/FloorComponent/FloorComponents';
import WingsCard from '../../../Subcomponents/WingsCard/WingsCard';
import WingsIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import DropDown from '../../../Subcomponents/DropDown';
import {
	deleteFloorPlan,
	deleteUploadedImage,
	getAllFloorPlan,
	updateInventoryForFloorPlans,
} from '../../../Services/FloorPlans';
import { ArrowBack } from '@mui/icons-material';
import CustomInput from '../../../Subcomponents/CustomInput';
import LeadStatusChip from '../../../Subcomponents/LeadStatusChip';
import Dot from '../../Icons/Dot';
import EditUnitInfo from '../../../Modals/EditUnitInfo/EditUnitInfo';
import ChangeUnitStatus from '../../../Modals/ChangeUnitStatus/ChangeUnitStatus';
import ChangeBulkUnitStatus from '../../../Modals/ChangeBulkUnitStatus/ChangeBulkUnitStatus';
import { getAllUser } from '../../../Services/LoginService';
import { useSelector } from 'react-redux';
import { supabase } from '../../../supabaseClient';
import ClockIcon from '../../Icons/ClockIcon';
import attendanceConfigurationImg from '../../../Assets/Images/Common/attendanceConfiguration.svg';
import Timer from '../../../Subcomponents/CountDownTimer';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getAllPlansByProjectFromFarvision } from '../../../Services/PaymentPlans';
import axios from 'axios';
import ViewToggleSwitch from '../../../Subcomponents/ViewSwitch/ViewToggleSwitch';
import WingSettings from '../../WingSettings/WingSettings';
import CustomToggle from '../../../Subcomponents/Toggle/CustomToggle';
import { MuiColorInput } from 'mui-color-input';
import DigitalCostSheet from '../../DigitalCostSheet/DigitalCostSheet';
import Drive from '../../DriveComponent/Drive';
import AddIcon from '@mui/icons-material/Add';
import DocumentPDFIcon from '../../../Assets/Images/CollateralIcons/documentPDF.svg';
import CustomRadio from '../../../Subcomponents/CustomRadio';
import ThreeDotsMenu from '../../../Subcomponents/ThreeDotsMenu';
import UploadParkingModal from '../../../Modals/UploadParkingModal/UploadParkingModal';
import SdrChangeUnitsModal from '../../../Modals/SdrChangeUnitsModal/SdrChangeUnitsModal';
import TemplateMapping from '../../TemplateMapping/TemplateMapping';
import DeemedCancellationConfigSection from './DeemedCancellationConfigSection'; // Phase 5

const useStyles = makeStyles((theme) => ({
	Tooltip: {
		'&.MuiTooltip-tooltip': {
			fontSize: '1.2rem',
		},
	},
}));
function ProjectDetails() {
	let loggedInUser = useSelector((state) => state.Auth.user);
	let projectFlag = useSelector((state) => state.ProjectFlag.projectFlag);
	// console.log({ loggedInUser });
	const dispatch = useDispatch();
	const classes = useStyles();
	//*common
	const { projectId } = useParams();
	const [tabValue, setTabValue] = useState(
		sessionStorage.getItem('ProjectName') ? 'Settings' : 'Inventory'
	);
	const [ProjectData, setProjectData] = useState([]);
	const [SdrPercentage, setSdrPercentage] = useState(null);
	const [LegalChargesVal, setLegalChargesVal] = useState(null);
	const [registrationVal, setRegistrationVal] = useState(null);
	const [classificationVal, setClassificationVal] = useState(null);

	const [Applicants, setApplicants] = useState([
		{ label: '1st Applicant Female', value: '0' },
		{ label: '1st & 2nd Applicant Female', value: '1' },
		{ label: 'All Applicant Female', value: '2' }
	]);

	//*Base-Price
	const [PriceData, setPriceData] = useState([]);
	const [pageMaintain, setPageMaintain] = useState(0);
	const [pageNumber, setPageNumber] = useState(0);
	const [pageSize, setPageSize] = useState(15);

	//*Payment-Plan
	const [PaymentData, setPaymentData] = useState([]);
	const [pagePaymentPlanMaintain, setPagePaymentPlanMaintain] = useState(0);
	const [pagePaymentPlanNumber, setPagePaymentPlanNumber] = useState(0);
	const [pagePaymentPlanSize, setPagePaymentPlanSize] = useState(15);

	//*modals-Payment-Plan
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	//*Edit-Payment-plan
	const [EditOpen, setEditOpen] = useState(false);
	const handleEditOpen = () => setEditOpen(true);
	const handleEditClose = () => setEditOpen(false);
	const [EditPaymentPlanData, setEditPaymentPlanData] = useState([]);

	//*Delete-modal-payment-plan
	const [DeletePaymentPlanOpen, setDeletePaymentPlanOpen] = useState(false);
	const [DeletePaymentPlanId, setDeletePaymentPlanId] = useState("");

	//*modals-Collateral
	const [CollateralOpen, setCollateralOpen] = useState(false);
	const handleCollateralOpen = () => setCollateralOpen(true);
	const handleCollateralClose = () => setCollateralOpen(false);

	const [CollateralModalType, setCollateralModalType] = useState("");
	const [CollateralData, setCollateralData] = useState([]);

	//*modal-view-Collateral
	const [ViewCollateralOpen, setViewCollateralOpen] = useState(false);
	const handleViewCollateralOpen = () => setViewCollateralOpen(true);
	const handleViewCollateralClose = () => setViewCollateralOpen(false);
	const [viewCollateralDetails, setViewCollateralDetails] = useState([]);

	//*Delete-modal-Collateral
	const [DeleteCollateralOpen, setDeleteCollateralOpen] = useState(false);
	const [DeleteCollateralId, setDeleteCollateralId] = useState([]);

	//*modals-PriceList
	const [PriceListOpen, setPriceListOpen] = useState(false);
	const handlePriceListOpen = () => setPriceListOpen(true);
	const handlePriceListClose = () => setPriceListOpen(false);

	const [PriceListDetails, setPriceListDetails] = useState([]);
	const [allInventory, setAllInventory] = useState([]);
	const [allChildInventory, setAllChildInventory] = useState([]);
	const [unitsToMerge, setUnitsToMerge] = useState([]);
	const [allUnitsToMerge, setAllUnitsToMerge] = useState([]);
	const [showMerge, setShowMerge] = useState(false);
	const [totalFloorsSelected, setTotalFloorsSelected] = useState(0);
	const [totalUnitsSelected, setTotalUnitsSelected] = useState(0);
	const [floorsSelected, setFloorsSelected] = useState([]);
	const [Value, setValue] = useState("");
	const [checked, setChecked] = useState(false);

	// *Assign floorPlan array
	const [addFloorPlan, setAddFloorPlan] = useState(false);
	const [allAssignFloorPlan, setAllAssignFloorPlan] = useState([]);
	const [floorPlanModalType, setFloorPlanModalType] = useState("");
	const [floorPlanData, setFloorPlanData] = useState([]);
	// **
	const [openConfirmationAlert, setOpenConfirmationAlert] = useState(false);
	const [displayDeleteTitle, setDisplayDeleteTitle] = useState("");
	const [displayDeleteSubTitle, setDisplayDeleteSubTitle] = useState("");

	//*Preview Inventory
	const navigate = useNavigate();
	const [UnitStatus, setUnitStatus] = useState([]);
	const [AllWings, setAllWings] = useState([]);
	// Wings shown in the Wing Settings tab for JD projects only (VJ projects keep using AllWings)
	const [jdWingSettingsWings, setJdWingSettingsWings] = useState([]);
	const [mode, setMode] = useState("Card View");
	const [NoWingsFound, setNoWingsFound] = useState(null);
	const [TotalUnits, setTotalUnits] = useState(0);
	const [TotalWings, setTotalWings] = useState(0);
	const [SelectedWing, setSelectedWing] = useState(false);
	const [SelectedUnit, setSelectedUnit] = useState(false);
	const [ShowUnits, setShowUnits] = useState("");
	const [Units, setUnits] = useState([]);
	const [ChipStyle, setChipStyle] = useState(null);
	const [pricingDetails, setPricingDetails] = useState([]);
	const [FloorRiseValue, setFloorRiseValue] = useState(0);
	const [plcValue, setPlcValue] = useState(0);
	const [mergeIdData, setMergeIdData] = useState(false);
	const [mergeID, setMergeID] = useState("");
	const [Unit1, setUnit1] = useState("");
	const [Unit2, setUnit2] = useState("");
	const [EditUnitData, setEditUnitData] = useState([]);

	const [ChangeUnitStatusOpen, setChangeUnitStatusOpen] = useState(false);
	const [EditUnitInfoOpen, setEditUnitInfoOpen] = useState(false);

	const [PreviewUnits, setPreviewUnits] = useState([]);
	const [PreviewSingleUnit, setPreviewSingleUnit] = useState([]);
	const [PreviewTotalUnits, setPreviewTotalUnits] = useState(0);
	const [PreviewSelectedWing, setPreviewSelectedWing] = useState("");
	const [TotalBsp, setTotalBsp] = useState([]);
	const [CsvData, setCsvData] = useState([]);
	const [csvFlag, setCsvFlag] = useState(false);
	const [SelectedUnitData, setSelectedUnitData] = useState([]);
	const [PriceNotAdded, setPriceNotAdded] = useState(false);
	const [UnitsPriceNotAdded, setUnitsPriceNotAdded] = useState(false);
	const [afterCancelUnitPrice, setAfterCancelUnitPrice] = useState(false);
	const [CsvButton, setCsvButton] = useState(true);
	const [uploadExcelFile, setUploadExcelFile] = useState(null);

	const [uploadParkingExcel, setUploadParkingExcel] = useState(null);
	const [AllParkingForCsv, setAllParkingForCsv] = useState([]);
	const [AllParkingTypes, setAllParkingTypes] = useState([]);

	// JD Projects
	const [jdProjects, setJdProjects] = useState([]);
	const [jdBURows, setJdBURows] = useState([]);
	const [jdBURowsAll, setJdBURowsAll] = useState([]);
	const [selectedJdBu, setSelectedJdBu] = useState(null);
	const [jdSearchText, setJdSearchText] = useState("");
	const [jdBankSelections, setJdBankSelections] = useState({});
	// ! vedashree changes => change unit status
	const [wingSelected, setWingSelected] = useState(null);

	const [openChangeStatus, setOpenChangeStatus] = useState(false);
	const [selectedUnitsForStatusChange, setSelectedUnitsForStatusChange] = useState([]);
	const [allUnitsForCsv, setAllUnitsForCsv] = useState([]);
	const [projectBanks, setProjectBanks] = useState([]);
	const [femaleDiscount, setFemaleDiscount] = useState(false);
	const [projectJdBanks, setProjectJdBanks] = useState([]);
	const [settingsHelperText, setSettingsHelperText] = useState({
		shortCode: "",
		ocr: "",
		sdr: "",
		gst: "",
		total: "",
		displayInventoryType: "",
		customerDisplayInventoryType: "",
		sustenancePaymentMethod: "",
		sdrPercentage: "",
		legalCharges: "",
		registrationCharges: '',
	});

	//*booking-config
	const [NoBookingInventoryFound, setNoBookingInventoryFound] = useState(false);

	//*SDR %
	const [SdrChangeUnitModalOpen, setSdrChangeUnitModalOpen] = useState(false);
	const [unitsForSdrChange, setUnitsForSdrChange] = useState([]);


	const [FlagForUnit, setFlagForUnit] = useState(false);

	//! **For tab validations
	const [tabValidation, setTabValidation] = useState({
		inventory: true,
		priceList: false,
		paymentPlans: false,
		settings: false,
		BookingConfiguration: false,
	});
	function handleChangeStatusOpen() {
		setOpenChangeStatus(true);
	}
	const handleChangeStatusClose = () => {
		setOpenChangeStatus(false);
		setSelectedUnitsForStatusChange([]);
		ShowParticularWingUnits(wingSelected);
	};

	const [anchorEl, setAnchorEl] = useState(null);
	const handleClick = (event) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};
	const IconOpen = Boolean(anchorEl);

	const id = IconOpen ? "simple-popover" : undefined;
	const handleIconClose = (e) => {
		e.stopPropagation();
		setAnchorEl(null);
	};

	const [BookingAmountDetails, setBookingAmountDetails] = useState([
		{
			wingId: "",
			wingName: "",
			typeOptions: [
				{
					UnitTypeName: "",
					UnitTypeId: "",
					ocrValue: "",
					sdrValue: "",
					gstValue: "",
					flag: false,
					TotalValue: "",
				},
			],
		},
	]);
    const [inventoryLogs, setInventoryLogs] = useState([]);

	useEffect(() => { }, [BookingAmountDetails]);

	//*snapShot
	useEffect(() => {
		if (ProjectData && ProjectData.length > 0) {
			axios
				.get(`${process.env.REACT_APP_PROJECTS_URL}bankMapping?buId=${ProjectData[0].buId}`)
				.then((resp) => {
					if (resp?.data?.result?.length > 0) {
						resp.data.result.forEach((ele) => {
							ele.label = `Description : ${ele.Description}\nBank Account No : ${ele.BankAccountNo}\nIFSCode : ${ele.IFSCCode}`;
							ele.value = ele?.BankAccountNo;
						});
						setProjectBanks(resp?.data?.result);
					}
				})
				.catch((err) => {
					console.log(err);
				});
			// JD projects are the JD BU themselves (jdBuid is null), so use their own buId
			const jdBankBuId = ProjectData[0].isVJ === false ? ProjectData[0].buId : ProjectData[0].jdBuid;
			if (jdBankBuId) {
				axios
					.get(`${process.env.REACT_APP_JDPROJECTS_URL}bankMapping?buId=${jdBankBuId}`)
					.then((resp) => {
						if (resp?.data?.result?.length > 0) {
							resp.data.result.forEach((ele) => {
								ele.label = `Description : ${ele.Description}\nBank Account No : ${ele.BankAccountNo}\nIFSCode : ${ele.IFSCCode}`;
								ele.value = `Description : ${ele.Description}\nBank Account No : ${ele.BankAccountNo}\nIFSCode : ${ele.IFSCCode}`;
							});
							setProjectJdBanks(resp?.data?.result);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			}
			let updateUnitListener = supabase
				.from(`Inventory:projectId=eq.${ProjectData[0].projectId}`)
				.on("UPDATE", (handleRecordUpdated) => {
					console.log(handleRecordUpdated);
					if (handleRecordUpdated.eventType === "UPDATE") {
						if (FlagForUnit && projectFlag?.projectFlag === true) {
							ShowParticularUnit(PreviewSingleUnit[0]);
						}
					}
				})
				.subscribe((status) => {
					// console.log("status: ", status);
				});
			return () => {
				if (updateUnitListener) {
					supabase.removeSubscription(updateUnitListener);
					updateUnitListener = null;
				}
			};
		}
	}, [ProjectData]);

	useEffect(() => {
		dispatch(action.activeMenu("leads"));
		let tempSideMenuArray = [];
		tabs.forEach((el, index) => {
			if (Object.keys(loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]).includes(el)) {
				if (loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.[el]?.isAccessible) {
					tempSideMenuArray.push(el);
				}
			}
		});
		setTab([
			...tempSideMenuArray,
			"Additional Configuration",
			"Email Template",
			"Deemed Cancellation Config",
			"Digital Cost-Sheet",
			"Wing Settings",
			"Template Mapping",
			...(ProjectData?.[0]?.salesParentProjectId ? [] : ["JD Projects"]),
		]);
	}, [loggedInUser, ProjectData]);

	function openSelectExcelFile() {
		let htmlElement = document.createElement("input");
		htmlElement.type = "file";
		htmlElement.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
		htmlElement.multiple = false;
		htmlElement.click();
		htmlElement.onchange = onChangeSelectExcel;
	}

	function onChangeSelectExcel(e) {
		let _file = e.target.files[0];
		if (_file) {
			setUploadExcelFile(_file);
		} else {
			errorTost('Please select valid excel file.');
		}
	}

	function openSelectParkingExcelFile() {
		let htmlElement = document.createElement('input');
		htmlElement.type = 'file';
		htmlElement.accept =
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
		htmlElement.multiple = false;
		htmlElement.click();
		htmlElement.onchange = onChangeSelectParkingExcel;
	}

	function onChangeSelectParkingExcel(e) {
		let _file = e.target.files[0];
		if (_file) {
			setUploadParkingExcel(_file);
		} else {
			errorTost('Please select valid excel file.');
		}
	}

	//*Delete-modal-Price-List
	const [DeletePriceListOpen, setDeletePriceListOpen] = useState(false);
	const [DeleteId, setDeleteId] = useState("");
	const [flag, setFlag] = useState("change");

	//*Collaterals
	const [CollateralCount, setCollateralCount] = useState("");
	const [ProjectCollateralsData, setProjectCollateralsData] = useState([]);
	const [UnitsDetails, setUnitDetails] = useState([]);
	const [allUser, setAllUser] = useState([]);

	//** Floor Plan column
	const floorPlanColumn = [
		{
			field: "action",
			headerName: "Action",
			width: 140,
			renderCell: (params) => {
				return (
					<div
						style={{
							textAlign: "center",
							display: "flex",
							gap: "1rem",
						}}
					>
						{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Floor Plans"]?.Edit?.isAccessible && (
							<EditIcon
								sx={{ fontSize: "2rem", cursor: "pointer" }}
								onClick={() => {
									setAddFloorPlan(true);
									setFloorPlanModalType("edit");
									setFloorPlanData(params.row);
								}}
							/>
						)}
						{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Floor Plans"]?.Delete?.isAccessible && (
							<DeleteIcon
								id="isDelete"
								style={{
									width: "2.5rem",
									height: "2.5rem",
									color: "#B42318",
									cursor: "pointer",
								}}
								onClick={() => {
									setFloorPlanData(params.row);
									setOpenConfirmationAlert(true);
									setDisplayDeleteTitle("Delete Floor Plan");
									setDisplayDeleteSubTitle(`Are you sure you want to delete ${params.row.name}`);
								}}
							/>
						)}
					</div>
				);
			},
		},
		{
			field: "name",
			headerName: "name",
			width: 400,
			renderCell: (params) => {
				return (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "1rem",
							cursor: "pointer",
						}}
					>
						{params.row.floorPlanImgUrl && (
							<img
								style={{
									width: "4rem",
									height: "4rem",
									objectFit: "cover",
									borderRadius: "50%",
								}}
								src={process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + params.row.floorPlanImgUrl + `?${Date.now()}`}
								alt=""
							/>
						)}
						<div>
							<Tooltip
								className={classes.Tooltip}
								placement="bottom-start"
								title={<p style={{ fontSize: "1.2rem" }}>{params.row.name}</p>}
							>
								<p style={{ fontSize: "1.4rem" }}>{params.row.name}</p>
							</Tooltip>
						</div>
					</div>
				);
			},
		},

		{
			field: "Floors",
			headerName: "Floors",
			width: 450,
			renderCell: (params) => {
				return <div>{params.value.toLocaleString()}</div>;
			},
		},
		{
			field: "wingName",
			headerName: "Wing",
			width: 250,
		},
	];

	useEffect(() => {
		dispatch(action.activeMenu("project"));
		getProjectDetails();
		getParkingData();
		AccessToInventory();
		defineChipColor();
		getPriceListData(false);
		getCollateralData();
		getPaymentPlanData(false);
		setSettingsHelperText((pre) => {
			pre = {
				shortCode: "",
				ocr: "",
				sdr: "",
				gst: "",
				total: "",
				userId: "",
			};
			return { ...pre };
		});
		getAllUser()
			.then((resp) => {
				console.log(resp);
				setAllUser(resp);
			})
			.catch((err) => {
				console.log("getAllUser", err);
			});
	}, []);
	// ! called multiple times
	// useEffect(() => {
	//   let updateProjectListener = supabase
	//   .from(`Inventory`)
	//   .on("UPDATE", (handleRecordUpdated) => {
	//     console.log(handleRecordUpdated);
	//     if (handleRecordUpdated) {
	//       getInventoryProjectPrices()
	//       getInventoryFromServer();
	//       getProjectDetails();
	//     }
	//   })
	//   .subscribe((status) => {
	//     console.log("status: ", status);
	//   });

	// useEffect(() => {
	// 	let updateProjectListener = supabase
	// 		.from(`Inventory`)
	// 		.on("UPDATE", (handleRecordUpdated) => {
	// 			console.log(handleRecordUpdated);
	// 			if (handleRecordUpdated) {
	// 				getInventoryProjectPrices();
	// 				getInventoryFromServer();
	// 				getProjectDetails();
	// 			}
	// 		})
	// 		.subscribe((status) => {
	// 			console.log("status: ", status);
	// 		});

	// 	return () => {
	// 		if (updateProjectListener) {
	// 			supabase.removeSubscription(updateProjectListener);
	// 			updateProjectListener = null;
	// 		}
	// 	};
	// }, []);

	useEffect(() => {
		defineChipColor();
	}, [PreviewSingleUnit, BookingAmountDetails]);

	useEffect(() => {
		if (tabValue === "Inventory") {
			if (allInventory.length === 0) {
				getInventoryProjectPrices();
			} else {
				let obj = cloneDeep(allInventory);
				setAllChildInventory({ ...obj });
			}
		} else if (tabValue === "Floor Plans") {
			getAllFloorPlans();
		}
	}, [tabValue, allUnitsToMerge]);

	useEffect(() => {
		getInventoryFromServer();
		getProjectDetails();
	}, [allChildInventory, SdrPercentage]);

	function getInventoryProjectPrices() {
		getAllInventory(projectId)
			.then((resp) => {
				// console.log(resp);
				getProjectInventory(projectId).then((res) => {
					getInventoryMerge(projectId).then((merge) => {
						setAllUnitsToMerge([...merge]);
						let arr = cloneDeep([...merge]);
						setUnitsToMerge([...arr]);
					}).catch((err) => {
						console.error("getInventoryMerge", err)
					});
					if (res.length > 0) {
						resp.forEach((ele) => {
							ele.wingName = ele.wingId.wingName;
							ele.isSelected = false;
							ele.showCheckbox = true;
							ele.projectId = projectId;
							// ! vedashree changes ==> for farvision status filter in edit
							ele.show = true;
						});
						resp = groupBy(resp, 'wingName');
						Object.keys(resp).forEach((ele) => {
							resp[ele] = {
								isSelected: false,
								floors: groupBy(resp[ele], 'floorNo'),
							};
							Object.keys(resp[ele].floors).forEach((e) => {
								resp[ele].floors[e] = {
									isSelected: false,
									units: sortBy(resp[ele].floors[e], 'unitNo'),
								};
							});
						});
						res.forEach((el) => {
							if (
								resp[el?.wingId?.wingName]?.floors?.[el?.unitId?.floorNo].units[resp[el.wingId.wingName]?.floors?.[el?.unitId?.floorNo].units.findIndex((e) => e.unitId === el.unitId.unitId)]
							)
								resp[el?.wingId?.wingName].floors[el?.unitId?.floorNo].units[
									resp[el?.wingId?.wingName].floors?.[
										el?.unitId?.floorNo
									].units.findIndex((e) => e.unitId === el.unitId.unitId)
								].isSelected = true;
							// if (resp[el.wingId.wingName].floors[el.unitId.floorNo].units.length === resp[el.wingId.wingName].floors[el.unitId.floorNo].units.filter((e) => e.isSelected === true).length) {
							if (
								resp[el?.wingId?.wingName]?.floors[
									el?.unitId?.floorNo
								].units.filter((e) => e.isSelected === true).length > 0
							) {
								resp[el?.wingId?.wingName].floors[
									el?.unitId?.floorNo
								].isSelected = true;
							}
							// if (Object.keys(resp[el.wingId.wingName].floors).length === Object.keys(resp[el.wingId.wingName].floors).filter((e) => { return resp[el.wingId.wingName].floors[e].isSelected === true }).length) {
							if (resp[el?.wingId?.wingName]) {
								if (
									Object.keys(resp[el?.wingId?.wingName]?.floors).filter((e) => {
										return (
											resp[el?.wingId?.wingName].floors[e].isSelected === true
										);
									}).length > 0
								) {
									resp[el?.wingId?.wingName].isSelected = true;
								}
							}
						});
						let newarr = cloneDeep(resp);
						setAllInventory(newarr);
						// console.log('resp: ', resp);
						setAllChildInventory(resp);
					} else {
						let allunits = cloneDeep(resp);
						allunits.forEach((ele) => {
							ele.wingName = ele.wingId.wingName;
							ele.isSelected = false;
							ele.showCheckbox = false;
							ele.projectId = projectId;
							ele.show = true;
						});
						allunits = groupBy(allunits, 'wingName');
						Object.keys(allunits).forEach((ele) => {
							allunits[ele] = {
								isSelected: false,
								floors: groupBy(allunits[ele], 'floorNo'),
							};
							Object.keys(allunits[ele].floors).forEach((e) => {
								allunits[ele].floors[e] = {
									isSelected: false,
									units: sortBy(allunits[ele].floors[e], 'unitNo'),
								};
							});
						});
						let newarr1 = cloneDeep(allunits);
						setAllInventory(newarr1);
						resp.forEach((ele) => {
							ele.wingName = ele.wingId.wingName;
							ele.isSelected = true;
							ele.showCheckbox = true;
							ele.projectId = projectId;
							ele.show = true;
						});
						resp = groupBy(resp, 'wingName');
						Object.keys(resp).forEach((ele) => {
							resp[ele] = {
								isSelected: true,
								floors: groupBy(resp[ele], 'floorNo'),
							};
							Object.keys(resp[ele].floors).forEach((e) => {
								resp[ele].floors[e] = {
									isSelected: true,
									units: sortBy(resp[ele].floors[e], 'unitNo'),
								};
							});
						});
						let newarr = cloneDeep(resp);
						// setAllInventory(newarr)
						setAllChildInventory(newarr);
					}
				}).catch((err) => {
					console.error("getProjectInventory", err)
				});
			})
			.catch((err) => {
				console.error('getAllInventory', err);
			});
	}

	function getInventoryFromServer() {
		setAllUnitsForCsv([]);

		let totalFloorsCount = 0;
		let totalUnitsCount = 0;
		Object.keys(allChildInventory).forEach((wing) => {
			Object.keys(allChildInventory[wing]).forEach((floor) => {
				totalFloorsCount =
					totalFloorsCount +
					Object.keys(allChildInventory[wing][floor]).filter((element) => {
						totalUnitsCount =
							totalUnitsCount +
							allChildInventory[wing][floor][element].units.filter((unit) => {
								return unit.isSelected === true;
							}).length;
						if (allChildInventory[wing][floor][element].isSelected === true) {
							// console.log('allChildInventory[wing][floor][element]: ', allChildInventory[wing][floor][element]);
							setFloorsSelected((pre) => {
								pre.push(element);
								return [...pre];
							});
							setAllUnitsForCsv((pre) => {
								pre = pre.concat(
									allChildInventory[wing][floor][element].units.filter((unit) => {
										return unit.isSelected === true;
									})
								);
								return [...pre];
							});
						}
						return allChildInventory[wing][floor][element].isSelected === true;
					}).length;
				setTotalFloorsSelected(totalFloorsCount);
				if (totalFloorsCount > 0) {
					setCsvButton(false);
				}
				setTotalUnitsSelected(totalUnitsCount);
			});
		});
		console.log("allChildInventory: ", allChildInventory);
	}


	function defineChipColor() {
		let obj = {};
		if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Available") {
			obj.chipColor = "#027A48";
			obj.chipBackgroundColor = "#D1FADF";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "On Hold") {
			obj.chipColor = "#B54708";
			obj.chipBackgroundColor = "#FEF0C7";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Payment Pending") {
			obj.chipColor = "#B42318";
			obj.chipBackgroundColor = "#FEE4E2";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Reserved") {
			obj.chipColor = "#6941C6";
			obj.chipBackgroundColor = "#F4EBFF";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Locked") {
			obj.chipColor = "#344054";
			obj.chipBackgroundColor = "#F2F4F7";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Kyc Pending") {
			obj.chipColor = "#0E7090";
			obj.chipBackgroundColor = "#ECFDFF";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Kyc Done") {
			obj.chipColor = "#2E90FA";
			obj.chipBackgroundColor = "#D1E9FF";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "SDR Payment Pending") {
			obj.chipColor = "#B54708";
			obj.chipBackgroundColor = "#FFFAEB";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Preselected") {
			obj.chipColor = "#FF4405";
			obj.chipBackgroundColor = "#FFE6D5";
		} else if (PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Sold") {
			obj.chipColor = "rgb(181 14 1)";
			obj.chipBackgroundColor = "rgb(249 171 165)";
		}
		setChipStyle(obj);
	}

	function getAllFloorPlans() {
		getAllFloorPlan(projectId)
			.then((allFloorPlan) => {
				console.log(allFloorPlan);
				// ??to filtering projectId
				let allFloorPlanArr = allFloorPlan.data.filter(({ Inventory }) => Inventory.length > 0);
				allFloorPlanArr = allFloorPlanArr.map((el, index) => ({
					...el,
					id: index,
				}));
				allFloorPlanArr.forEach((el) => {
					el.Floors = [];
					let uniqueFloor = sortBy(uniqBy(el.Inventory, "floorNo"), "floorNo");
					uniqueFloor.forEach((inventory) => {
						el.Floors.push(inventory.floorNo);
						el.wingName = inventory.wingId.wingName;
						el.wingId = inventory.wingId.wingId;
					});
				});
				setAllAssignFloorPlan([...allFloorPlanArr]);
			})
			.catch((err) => {
				console.log(err);
			});
	}
	// Refetches whenever ProjectData reloads (including after Wing Settings save via getProjectDetails)
	useEffect(() => {
		if (ProjectData?.[0]?.isVJ !== false) return;
		getProjectInventoryByType(projectId)
			.then((rows) => setJdWingSettingsWings(uniqBy(rows.filter((r) => r.wingId), "wingId.wingId")))
			.catch((err) => console.log("JD-Wing-Settings-err", err));
	}, [ProjectData, projectId]);

	function getProjectDetails() {
		let _projectDataResp = [];
		getProjectByProjectName(projectId)
			.then((resp) => {
				setProjectData(resp.data);
				setFemaleDiscount(resp.data[0].isFemaleDiscountApplicable);
				setSdrPercentage(resp.data[0].sdrPercentage);
				setLegalChargesVal(resp.data[0].legalCharges);
				setRegistrationVal(resp.data[0].registrationCharges);
				setClassificationVal(resp.data[0].classificationId);
				_projectDataResp = resp.data;
				if (resp.data[0].useCsvPrice === true && resp.data[0].csvUploaded === true) {
					setChecked(true);
				}
			})
			.catch((err) => {
				console.log("Project-Data-err", err);
			});

		getProjectInventory(projectId)
			.then((response44) => {
				// console.log("getProjectInventory" , response44)
				const Data = uniqBy(response44, "wingId.wingId");
				const ForBooking = groupBy(response44, "wingId.wingId");
				const BhkType = uniqBy(response44, "unitId.inventoryTypeId.inventoryTypeId");
				setTotalUnits(response44.length);
				setUnitStatus(response44);
				setTotalWings(Data.length);
				setAllWings(Data);

				getBookingAmounts(projectId)
					.then((response77) => {
						// FIXED (performance): building ForBooking[ele] only needs one pass per wing —
						// each wing's slice of the data is independent, so this loop is fine.
						Object.keys(ForBooking).forEach((ele, i) => {
							ForBooking[ele] = {
								wingId: ForBooking[ele].find((e) => {
									return e.wingId.wingId === ele;
								}),
								units: uniqBy(ForBooking[ele], "unitId.inventoryTypeId.inventoryTypeId"),
							};
						});

						// FIXED (performance): this whole block — regrouping response77 and building the
						// final per-wing list — used to be recomputed once PER WING inside the loop above
						// (redoing the same full-project work N times for N wings, and saving to the screen
						// N times too). It doesn't depend on any single wing, so it now runs exactly once,
						// after every wing's booking data has been gathered above.
						const BookingAmtRespObj = groupBy(response77, "wingId.wingId");
						Object.keys(BookingAmtRespObj).forEach((elem, i) => {
							BookingAmtRespObj[elem] = {
								wingId: BookingAmtRespObj[elem].find((e) => {
									return e.wingId.wingId === elem;
								}),
								units: uniqBy(BookingAmtRespObj[elem], "inventoryTypeId.inventoryTypeId"),
							};
						});

							let outputArr = [];
							const uniqueWings = [...new Set([Object.keys(BookingAmtRespObj), Object.keys(ForBooking)].flat())];

							uniqueWings.forEach((uniqueWingKeyItem, i) => {
								let _obj = {
									wingId: uniqueWingKeyItem,
									wingName: "",
									typeOptions: [],
								};

								if (BookingAmtRespObj[uniqueWingKeyItem] && BookingAmtRespObj[uniqueWingKeyItem]?.units?.length > 0) {
									_obj.wingName = BookingAmtRespObj?.[uniqueWingKeyItem][i]?.wingId?.wingName;
									BookingAmtRespObj?.[uniqueWingKeyItem].units.forEach((_item1) => {
										_obj.typeOptions.push({
											UnitTypeName: _item1?.inventoryTypeId?.type,
											UnitTypeId: _item1?.inventoryTypeId?.inventoryTypeId,
											ocrValue: _item1?.OCR,
											sdrValue: _item1?.SDR,
											flag: _item1.bookingAmountId ? true : false,
											gstValue: _item1?.GST,
											TotalValue: _item1?.TOTAL,
										});
									});
								}

								if (ForBooking[uniqueWingKeyItem] && ForBooking[uniqueWingKeyItem]?.units?.length > 0) {
									_obj.wingName = ForBooking?.[uniqueWingKeyItem]?.wingId?.wingId?.wingName;
									ForBooking?.[uniqueWingKeyItem].units?.forEach((_item2) => {
										if (!_obj.typeOptions.find((tp) => tp.UnitTypeId === _item2?.unitId?.inventoryTypeId?.inventoryTypeId)?.flag)
											_obj.typeOptions.push({
												UnitTypeName: _item2?.unitId?.inventoryTypeId?.type,
												UnitTypeId: _item2?.unitId?.inventoryTypeId?.inventoryTypeId,
												ocrValue: "",
												sdrValue: "",
												gstValue: "",
												TotalValue: "",
											});
									});
								}
								outputArr.push(_obj);
							});

							const FilterData = outputArr.filter((f) => f.wingName);
							setBookingAmountDetails(FilterData);

						if (Object.keys(ForBooking).length === 0) {
							setNoBookingInventoryFound(true);
						}
					})
					.catch((err) => {
						console.error("Booking-Amount-err", err);
					});
			})
			.catch((err) => {
				console.error("getProjectInventory", err);
			});
		console.log("CsV-Button", totalFloorsSelected);

		getProjectInventory(projectId)
			.then((resp) => {
				// let arr = []
				console.log("getProjectInventory", resp);
				const ProjectConfigInventory = uniqBy(resp, "unitId.inventoryTypeId.inventoryTypeId");
				console.log("uniq-project-Config", ProjectConfigInventory);
				getInventoryStatus()
					.then((response) => {
						let arr = [];
						console.log("Inventory-Status", response);
						ProjectConfigInventory.forEach((ele, index) => {
							let obj = {
								unitType: ele.unitId.inventoryTypeId.type,
								display:
									_projectDataResp[0]?.unitTypeDisplay?.find((f) => f.unitType === ele.unitId.inventoryTypeId.type)?.display ||
									false,
								unitStatusDisplay: [],
							};
							response.forEach((elem, index) => {
								// console.log("elm" , elem)
								obj.unitStatusDisplay.push({ unitStatus: elem.status, display: false, color: "", textColor: "" });
							});
							obj.unitStatusDisplay = obj?.unitStatusDisplay.map((m) => ({
								...m,
								display:
									_projectDataResp[0]?.unitTypeDisplay
										?.find((f) => f.unitType === obj.unitType)
										?.unitStatusDisplay?.find((f) => f?.unitStatus === m?.unitStatus)?.display || "",
								color:
									_projectDataResp[0]?.unitTypeDisplay
										?.find((f) => f.unitType === obj.unitType)
										?.unitStatusDisplay?.find((f) => f?.unitStatus === m?.unitStatus)?.color || "",
								textColor:
									_projectDataResp[0]?.unitTypeDisplay
										?.find((f) => f.unitType === obj.unitType)
										?.unitStatusDisplay?.find((f) => f?.unitStatus === m?.unitStatus)?.textColor || "",
							}));
							arr.push(obj);
						});

						console.log("arr", arr);
						console.log("_projectDataResp", _projectDataResp);
						let setData = _projectDataResp;
						console.log("setData", [...arr]);
						setData[0].unitTypeDisplay = [...arr];
						setProjectData([...setData]);
					})
					.catch((err) => {
						errorTost(err.message)
						console.error('getInventoryStatus', err);
					});
			})
			.catch((err) => {
				console.error("getProjectInventory-live-inventory", err);
			});
		getUnitsForSdrPercentage(projectId).then((sdrResp) => {
			const filtering_units = sdrResp.filter((f) => CrmAllotmentFilter(f))
			setUnitsForSdrChange(filtering_units)
		}).catch((err) => {
			console.error('getUnitsForSdrPercentage', err);
		});

	}

	function CrmAllotmentFilter(arr) {
		const allotment_payment =
			arr.AllotmentPayment?.length > 0
				? orderBy(arr?.AllotmentPayment, 'created_at', ['desc'])[0]
				: [];

		return (
			(arr.AllotmentPayment?.length > 0 &&
				(allotment_payment?.status !== 'Released' || allotment_payment?.status !== 'Agreement Done')
				&&
				(allotment_payment?.CRM?.length === 0 || (allotment_payment?.CRM?.length &&
					!allotment_payment?.CRM[0]?.sentForAgreement && !allotment_payment?.CRM[0]?.skipCreateDraft))) || arr.AllotmentPayment?.length === 0
		);
	}

	async function fetchJdProjects() {
		presentLoader();
		try {
			const currentBuId = ProjectData[0]?.buId;
			const [savedRes, buRes] = await Promise.all([
				getJdProjectsByParentId(projectId),
				axios.post(`${process.env.REACT_APP_JDPROJECTS_URL}getJDBusinessUnitsByVJDbuId`, { buid: currentBuId }),
			]);
			const saved = (savedRes ?? []).map((r, i) => ({ ...r, id: i }));
			const rows = (buRes.data.result ?? []).map((e, i) => ({ ...e, id: i }));
			setJdBURowsAll(rows);
			setJdBURows(rows);
			setSelectedJdBu(null);
			setJdSearchText("");

			if (saved.length > 0) {
				const bankResults = await Promise.all(
					saved.map((p) =>
						axios.get(`${process.env.REACT_APP_JDPROJECTS_URL}bankMapping?buId=${p.buId}`)
							.then((r) => {
								console.log(`[JD bankMapping] buId=${p.buId} raw response:`, r.data);
								return { projectId: p.projectId, buId: p.buId, banks: r.data?.result ?? [] };
							})
							.catch((err) => {
								console.error(`[JD bankMapping] buId=${p.buId} FAILED:`, err);
								return { projectId: p.projectId, buId: p.buId, banks: [] };
							})
					)
				);
				console.log("[JD bankResults]", bankResults);
				const selectionsMap = {};
				const enrichedSaved = saved.map((p) => {
					const found = bankResults.find((r) => r.projectId === p.projectId);
					const banks = (found?.banks ?? []).map((b) => {
						const desc = Array.isArray(b.Description) ? b.Description[0] : b.Description;
						return {
							...b,
							label: `Description : ${desc}\nBank Account No : ${b.BankAccountNo}\nIFSCode : ${b.IFSCCode}`,
							value: b.BankAccountNo,
						};
					});
					selectionsMap[p.projectId] = {
						OCRBank: p.OCRBank ?? null,
						GSTBank: p.GSTBank ?? null,
					};
					return { ...p, banks };
				});
				console.log("[JD enrichedSaved]", enrichedSaved.map((p) => ({ projectId: p.projectId, buId: p.buId, bankCount: p.banks?.length })));
				setJdProjects(enrichedSaved);
				setJdBankSelections(selectionsMap);
			} else {
				setJdProjects(saved);
			}
		} catch (err) {
			console.error("fetchJdProjects:", err);
			errorTost("Failed to load JD Projects");
		} finally {
			dismissLoader();
		}
	}

	async function saveJdBankConfig(jdProject) {
		const selection = jdBankSelections[jdProject.projectId];
		if (!selection?.OCRBank && !selection?.GSTBank) {
			errorTost("Please select at least one bank");
			return;
		}
		presentLoader();
		try {
			const updateObj = { projectId: jdProject.projectId };

			if (selection.OCRBank && !jdProject.OCRLedger) {
				const payload = {
					projectOwner: jdProject.type,
					buId: jdProject.buId,
					shortCode: jdProject.projectShortCode,
					projectName: jdProject.projectName,
					bankDetails: {
						bankAccountNo: selection.OCRBank.BankAccountNo,
						beneficiaryName: `${jdProject.projectName}-OCR`,
						ifscCode: selection.OCRBank.IFSCCode,
						bankAccountType: selection.OCRBank.BankAccountType,
						accountName: selection.OCRBank.bankName || "",
					},
					type: "OCR",
				};
				const res = await axios.post(`${process.env.REACT_APP_BANKTRANSACTIONS_URL}createProjectGeneralLedger`, payload);
				if (res.data?.outputList) { updateObj.OCRBank = selection.OCRBank; updateObj.OCRLedger = res.data.outputList; }
				else errorTost("OCR Ledger creation failed");
			}

			if (selection.GSTBank && !jdProject.GSTLedger) {
				const payload = {
					projectOwner: jdProject.type,
					buId: jdProject.buId,
					shortCode: jdProject.projectShortCode,
					projectName: jdProject.projectName,
					bankDetails: {
						bankAccountNo: selection.GSTBank.BankAccountNo,
						beneficiaryName: `${jdProject.projectName}-GST`,
						ifscCode: selection.GSTBank.IFSCCode,
						bankAccountType: selection.GSTBank.BankAccountType,
						accountName: selection.GSTBank.bankName || "",
					},
					type: "GST",
				};
				const res = await axios.post(`${process.env.REACT_APP_BANKTRANSACTIONS_URL}createProjectGeneralLedger`, payload);
				if (res.data?.outputList) { updateObj.GSTBank = selection.GSTBank; updateObj.GSTLedger = res.data.outputList; }
				else errorTost("GST Ledger creation failed");
			}

			await updateProject(updateObj);
			successTost("Bank configuration saved");
			fetchJdProjects();
		} catch (err) {
			console.error("saveJdBankConfig:", err);
			errorTost("Failed to save bank configuration");
		} finally {
			dismissLoader();
		}
	}

	async function saveJdProject() {
		if (!selectedJdBu) { errorTost("Please select a JD Business Unit"); return; }
		presentLoader();
		try {
			let obj = cloneDeep(selectedJdBu);
			delete obj.key;
			delete obj.id;
			delete obj.show;
			delete obj.addressLine4;
			obj.reraNumber = obj.reraNo || null;
			delete obj.reraNo;
			obj.isVJ = false;
			obj.salesParentProjectId = projectId;
			obj.VjBuParentId = ProjectData[0].buId;
			obj.type = "Landowner";

			const newProject = await addProjectToDb(obj);
			const newProjectId = newProject[0].projectId;

			// fetch JD wings and save them in one shot
			try {
				const wingsRes = await axios.post(
					`${process.env.REACT_APP_JDPROJECTS_URL}getJdWingsByJdBuId`,
					{ buid: obj.buId }
				);
				const wings = wingsRes.data?.result ?? [];
				if (wings.length > 0) {
					await Promise.all(
						wings.map((wing) =>
							addWing({
								wingName: wing.HierarchyName,
								displayName: wing.HierarchyName,
								projectId: newProjectId,
								farvisionWingId: String(wing.Id),
							})
						)
					);
				}
			} catch (wingErr) {
				console.error("saveJdProject wings:", wingErr);
				errorTost("Project saved but wings could not be added. Please retry.");
			}

			successTost("JD Project added successfully");
			setSelectedJdBu(null);
			fetchJdProjects();
		} catch (err) {
			console.error("saveJdProject:", err);
			errorTost("Failed to add JD Project");
		} finally {
			dismissLoader();
		}
	}

	function getParkingData() {
		getParkingTypes().then((parkingTypeRes) => {
			setAllParkingTypes(parkingTypeRes.data)
		}).catch((err) => {
			console.log("getParkingTypes", err)
		})
		getParkingTypesFromInventory(projectId)
			.then((parkingRes) => {
				setAllParkingForCsv(parkingRes.data);
			})
			.catch((err) => {
				console.error('getParkingTypesFromInventory', err);
			});

	}
	function numberWithCommas(x) {
		return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
	}

	function getPriceListData(pageNumber, merge) {
		getProjectPricingByProjectId(projectId, pageNumber * pageSize, pageNumber * pageSize + pageSize - 1)
			.then((response22) => {
				const PriceListData = response22.data.map((el, index) => ({
					...el,
					key: `${el}_${index}`,
					id: el?.projectPricingId,
					index: index,
					title: el?.title,
					Wings: el?.wingId.wingName,
					StartDate: el.startDateTime
						? [
							new Date(el.startDateTime).toDateString(),
							new Date(el.startDateTime).toLocaleTimeString([], {
								hour: "2-digit",
								minute: "2-digit",
							}),
						]
						: "Default",
					EndDate: el.endDateTime
						? [
							new Date(el.endDateTime).toDateString(),
							new Date(el.endDateTime).toLocaleTimeString([], {
								hour: "2-digit",
								minute: "2-digit",
							}),
						]
						: "Default",
				}));

				if (merge) {
					setPriceData((pre) => [...pre, ...PriceListData]);
				} else {
					setPriceData([...PriceListData]);
				}
			})
			.catch((err) => {
				console.log("Base-Price-Error", err);
			});
	}

	function getMoreData(passPageNumber) {
		setPageNumber(passPageNumber);
		getPriceListData(passPageNumber, true);
	}

	function pageChanged(e) {
		console.log(e);
		console.log("page---", e);
		setPageMaintain(e);
		if (pageNumber < e) {
			getMoreData(e);
			setPageNumber(e);
		}
	}

	const PriceListColumns = [
		{
			field: "action",
			headerName: "Action",
			width: 140,
			renderCell: (params) => {
				return (
					<div
						style={{
							textAlign: "center",
							display: "flex",
							gap: "1rem",
						}}
					>
						{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Price List"]?.Edit?.isAccessible && (
							<EditIcon
								sx={{ fontSize: "2rem", cursor: "pointer" }}
								onClick={() => {
									setValue("Edit");
									setPriceListDetails(params.row);
									handlePriceListOpen();
								}}
							/>
						)}
						{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Price List"]?.Delete?.isAccessible && (
							<DeleteIcon
								id="isDelete"
								style={{
									width: "2.5rem",
									height: "2.5rem",
									color: "#B42318",
									cursor: "pointer",
								}}
								onClick={() => {
									setDeletePriceListOpen(true);
									setDeleteId(params.row.projectPricingId);
								}}
							/>
						)}
					</div>
				);
			},
		},
		{
			field: "title",
			headerName: "Title",
			width: 300,
		},
		{
			field: "Wings",
			headerName: "Wing Name",
			width: 250,
		},
		{
			field: "StartDate",
			headerName: "Start Date Time",
			width: 300,
		},
		{
			field: "EndDate",
			headerName: "End Date Time",
			width: 300,
		},
	];

	function AccessToInventory() {
		const arr = [];
		const arr1 = [];
		//*check project wings-unitType match with Booking amount wings-unitType
		getProjectInventory(projectId)
			.then((TypeItem) => {
				let UniqueData = groupBy(TypeItem, "wingId.wingId");
				Object.keys(UniqueData).forEach((em) => {
					UniqueData[em] = {
						selectedWing: UniqueData[em].find((e) => {
							return e.wingId.wingId == em;
						}),
						SelectedUnitType: uniqBy(UniqueData[em], "unitId.inventoryTypeId.inventoryTypeId"),
					};
					UniqueData[em].SelectedUnitType.forEach((m) => {
						arr.push({
							wingId: UniqueData[em].selectedWing?.wingId.wingId,
							inventoryTypeId: m.unitId.inventoryTypeId.inventoryTypeId,
						});
					});
				});
				//*booking-Amount-Data
				getBookingAmounts(projectId)
					.then((response) => {
						const BookingData = groupBy(response, "wingId.wingId");
						Object.keys(BookingData).forEach((el) => {
							BookingData[el] = {
								wingID: BookingData[el].find((e) => {
									return e.wingId.wingId === el;
								}),
								inventoryTypeID: uniqBy(BookingData[el], "inventoryTypeId.inventoryTypeId"),
							};
							BookingData[el].inventoryTypeID.forEach((item) => {
								arr1.push({
									WingData: BookingData[el].wingID?.wingId.wingId,
									InventoryData: item.inventoryTypeId.inventoryTypeId,
								});
							});
							const FinalCheck = arr.map((m) => arr1.some((s) => s.WingData === m.wingId && s.InventoryData === m.inventoryTypeId));
							let BooleanCheck = FinalCheck.every(Boolean);
							if (BooleanCheck === true) {
								setTabValidation((pre) => {
									pre.BookingConfiguration = true;
									return { ...pre };
								});
							}

						});
					})
					.catch((err) => {
						console.error("getBookingAmounts", err);
					});
			})
			.catch((err) => {
				console.error("getProjectInventory-AccessToInventory", err);
			});
	}

	function DeleteResp(e) {
		setDeletePriceListOpen(false);
		console.info("delete->>", e);
		console.info("deleted=ID", DeleteId);
		if (e === "confirmed") {
			RemoveBasePriceFromTable(DeleteId)
				.then((res) => {
					console.info("Successfully Removed", res);
					getPriceListData(false);
					successTost("Successfully Deleted!");
				})
				.catch((err) => {
					console.error("Price-List-err", err);
					if (err.message.includes('update or delete on table "ProjectPricing" violates foreign key constraint')) {
						errorTost("This Project Pricing is already used in allotment.Cannot able to delete it now.");
					} else {
						errorTost(err.message);
					}
				});
		}
	}

	function getPaymentPlanData(pageNumber, merge) {
		getPaymentPlansFromDb(projectId, pageNumber * pagePaymentPlanSize, pageNumber * pagePaymentPlanSize + pagePaymentPlanSize - 1)
			.then((response44) => {
				const PaymentPlanData = response44.data.map((el, index) => ({
					...el,
					key: `${el}_${index}`,
					id: el?.paymentPlanId,
					index: index,
					Key: el?.key,
					Wings: el?.wingId.wingName,
					Title: el?.title,
					UnitType: el?.displayUnitType,
					Discount:
						el.operation === "Discount"
							? "-  " + (el.type === "Fixed" ? "₹ " + numberWithCommas(el?.discount) : el?.discount + "%")
							: "+  " + (el.type === "Fixed" ? "₹ " + numberWithCommas(el?.discount) : el?.discount + "%"),
				}));
				if (merge) {
					setPaymentData((pre) => [...pre, ...PaymentPlanData]);
				} else {
					setPaymentData([...PaymentPlanData]);
				}
			})
			.catch((err) => {
				console.log("Payment-Plan-err", err);
			});
	}

	function getMorePaymentPlanData(passPageNumber) {
		setPagePaymentPlanNumber(passPageNumber);
		getPaymentPlanData(passPageNumber, true);
	}

	function UnitsTableUpdate(respValue) {
		if (respValue === true) {
			getInventoryProjectPrices();
			getInventoryFromServer();
			getProjectDetails();
		}
	}
	function ParkingTableUpdate(respValue) {
		if (respValue === true) {
			getParkingData()
		}
	}
	async function SdrUnitsTableUpdate(val) {
		console.log('SdrUnitsTableUpdate', val);
		if (val === true) {
			console.log(ProjectData[0], ProjectData[0]?.paymentModes === null);
			console.log(
				'isFemaleDiscountApplicable',
				ProjectData[0].isFemaleDiscountApplicable
			);
			if (
				ProjectData[0]?.userId === null ||
				ProjectData[0]?.displayInventoryType?.length === 0 ||
				ProjectData[0]?.displayInventoryType === null ||
				ProjectData[0]?.customerDisplayInventoryType?.length === 0 ||
				ProjectData[0]?.customerDisplayInventoryType === null ||
				ProjectData[0]?.paymentModes?.length === 0 ||
				ProjectData[0]?.paymentModes === null
			) {
				if (
					ProjectData[0]?.displayInventoryType?.length === 0 ||
					ProjectData[0]?.displayInventoryType === null
				)
					setSettingsHelperText((pre) => {
						pre.displayInventoryType =
							'Please select At least one display unit';
						return { ...pre };
					});

				if (ProjectData[0]?.userId === null) {
					setSettingsHelperText((pre) => {
						pre.userId = 'Please select Project Head';
						return { ...pre };
					});
				}
				if (
					ProjectData[0]?.paymentModes?.length === 0 ||
					ProjectData[0]?.paymentModes === null
				) {
					setSettingsHelperText((pre) => {
						pre.sustenancePaymentMethod =
							'Please select At least one payment Method';
						return { ...pre };
					});
				}
				if (
					ProjectData[0]?.customerDisplayInventoryType?.length === 0 ||
					ProjectData[0]?.customerDisplayInventoryType === null
				) {
					setSettingsHelperText((pre) => {
						pre.customerDisplayInventoryType =
							'Please select At least one display unit';
						return { ...pre };
					});
				}
			} else {
				if (settingsHelperText.shortCode === '') {
					const obj = cloneDeep(ProjectData[0]);
					console.log('obj', obj);

					presentLoader();
					if (obj.OCRBank) {
					  let ocrobj = {
					    projectOwner: obj.type,
					    buId: obj.buId,
					    shortCode: obj.projectShortCode,
					    projectName: ProjectData[0].projectName,
					    bankDetails: {
					      bankAccountNo: obj.OCRBank.BankAccountNo,
					      beneficiaryName: `${ProjectData[0].projectName}-OCR`,
					      ifscCode: obj.OCRBank.IFSCCode,
					      bankAccountType: obj.OCRBank.BankAccountType,
					      accountName: obj.OCRBank.bankName || ""
					    },
					    type: 'OCR'
					  }
					  await axios.post(`${process.env.REACT_APP_BANKTRANSACTIONS_URL}createProjectGeneralLedger`, ocrobj).then((resp) => {
					    if (resp.data.outputList) {
					      setProjectData((pre) => {
					        pre[0].OCRLedger = resp.data.outputList
					        return [...pre]
					      })
					      obj.OCRLedger = resp.data.outputList
					    } else {
					      obj.OCRBank = null
					      errorTost("Something went wrong while saving OCR Bank")
					    }
					  }).catch((err) => {
					    errorTost("Something went wrong while saving OCR Bank")
					  })
					}
					if (obj.GSTBank) {
					  let gstobj = {
					    projectOwner: obj.type,
					    buId: obj.buId,
					shortCode: obj.projectShortCode,
					    projectName: ProjectData[0].projectName,
					    bankDetails: {
					      bankAccountNo: obj.GSTBank.BankAccountNo,
					      beneficiaryName: `${ProjectData[0].projectName}-GST`,
					      ifscCode: obj.GSTBank.IFSCCode,
					      bankAccountType: obj.GSTBank.BankAccountType,
					      accountName: obj.GSTBank.bankName || ""
					    },
					    type: 'GST'
					  }
					  await axios.post(`${process.env.REACT_APP_BANKTRANSACTIONS_URL}createProjectGeneralLedger`, gstobj).then((resp) => {
					    if (resp.data.outputList) {
					      setProjectData((pre) => {
					        pre[0].GSTLedger = resp.data.outputList
					        return [...pre]
					      })
					      obj.GSTLedger = resp.data.outputList
					    } else {
					      obj.GSTBank = null
					      errorTost("Something went wrong while saving GST Bank")
					    }
					  }).catch((err) => {
					    errorTost("Something went wrong while saving GST Bank")
					  })
					}
					updateProject({
						projectShortCode: obj.projectShortCode,
						projectExtraInfo: obj.projectExtraInfo,
						OCRBank: obj.OCRBank || null,
						GSTBank: obj.GSTBank || null,
						OCRLedger: obj.OCRLedger || null,
						GSTLedger: obj.GSTLedger || null,
						projectId: obj.projectId,
						userId: obj.userId,
						displayInventoryType: obj.displayInventoryType,
						customerDisplayInventoryType: obj.customerDisplayInventoryType,
						paymentModes: obj.paymentModes,
						minOnlineAmt: obj.minOnlineAmt,
						panVerificationForSiteVisit: obj.panVerificationForSiteVisit,
						enablePaymentPlan: obj.enablePaymentPlan,
						unitTypeDisplay: obj.unitTypeDisplay,
						sdrPercentage: obj.sdrPercentage,
						applicantType: obj.applicantType,
						isFemaleDiscountApplicable: obj.isFemaleDiscountApplicable
							? obj.isFemaleDiscountApplicable
							: false,
						legalCharges: obj.legalCharges,
						classificationId: obj.classificationId,
						registrationCharges: obj.registrationCharges,
						enableCreateDraft: obj.enableCreateDraft,
						smAccess:obj.smAccess
					})
						.then((resp) => {
							successTost('Settings saved successfully!');
							if (parseInt(SdrPercentage) !== parseInt(obj.sdrPercentage)) {
								//? add an insert into projectLogs for SDR %
								let SdrObj = {
									projectId: obj.projectId,
									userId: loggedInUser?.userId,
									valueType: 'SDR Percentage Change',
									message: `SDR Percentage value changed from ${SdrPercentage} to ${obj.sdrPercentage}`,
								};
								addProjectLogsForSdrPercent(SdrObj)
									.then((projectLog) => {
										console.log(projectLog);
									})
									.catch((err) => {
										console.log('projectLog', err);
									});
								console.log('SDR % value changed');
							}
							if (parseInt(classificationVal) !== parseInt(obj.classificationId)) {
								//? add an insert into projectLogs for classificationId
								let ClassificationObj = {
									projectId: obj.projectId,
									userId: loggedInUser?.userId,
									valueType: 'ClassificationId Change',
									message: `ClassificationId value changed from ${classificationVal} to ${obj.classificationId}`,
								};
								addProjectLogsForSdrPercent(ClassificationObj)
									.then((projectLog) => {
										console.log(projectLog);
									})
									.catch((err) => {
										console.log('projectLog', err);
									});
								console.log('classificationId value changed');
							}
							dismissLoader();
						})
						.catch((err) => {
							console.log('err: ', err);
							dismissLoader();
						});
				}
			}
		}
	}

	function pagePaymentPlanChanged(e) {
		console.log(e);
		console.log("page---", e);
		setPagePaymentPlanMaintain(e);
		if (pagePaymentPlanNumber < e) {
			getMorePaymentPlanData(e);
			setPagePaymentPlanNumber(e);
		}
	}

	function getCollateralData() {
		getAllProjectsCollateral(projectId)
			.then((resp) => {
				setCollateralCount(resp.count);
				setProjectCollateralsData(resp.data);
			})
			.catch((err) => {
				console.log("Collateral-Data-err", err);
			});
	}

	function DeleteCollateralResp(e) {
		setDeleteCollateralOpen(false);
		console.info("delete->>", e);
		console.info("deleted-data", DeleteCollateralId);
		if (e === "confirmed") {
			let selectedCollateral = [DeleteCollateralId].map((m) => m.projectCollateralId[0].projectCollateralId);
			let selectCpId = [DeleteCollateralId].map((m) => m.projectCollateralId.map((el) => ({ id: el.id })));
			console.log("selectCpId", selectCpId);
			console.log("selectedCollateral", selectedCollateral);

			let CollateralImgUrl = [DeleteCollateralId].map((m) => m.collateralUrl);
			let deleteCount = 0;
			for (let index = 0; index < selectCpId.length; index++) {
				const CpIdElement = selectCpId[index];
				// eslint-disable-next-line no-loop-func
				CpIdElement.map((ele) => {
					RemoveCPFromCollateralRelations(ele.id)
						.then((res) => {
							console.info("SuccessFully Removed", res);
							RemoveCollateralFromTable(selectedCollateral)
								.then((resp) => {
									console.info("SuccessFully Removed", resp);
									deleteCollateralFromStorage(CollateralImgUrl)
										.then((response) => {
											console.log("removed from storage", response);
											deleteCount++;
											// ! considering index here will give incorrect o/p
											// if (index === selectCpId.length - 1) {
											if (deleteCount === selectCpId.length) {
												getCollateralData();
												successTost("SuccessFully Deleted!");
											}
										})
										.catch((err) => {
											console.error("storage-err", err);
										});
								})
								.catch((err) => {
									console.error("collateral-err", err);
								});
						})
						.catch((err) => {
							console.error("cp-err", err);
						});
				});
			}
		}
	}

	const [tabs, setTab] = useState([
		"Inventory",
		"Price List",
		"Payment Plans",
		"Collateral",
		"Floor Plans",
		"Settings",
		"Booking Configuration",
		"Additional Configuration",
		"Email Template",
		"Digital Cost-Sheet",
		"Wing Settings",
		"Template Mapping"
	]);
	const tabChange = (event, newValue) => {
		if (newValue === "JD Projects") {
			setTabValue(newValue);
			fetchJdProjects();
			return;
		}
		if (ProjectData[0].useCsvPrice) {
			if (newValue === "Price List") {
				successTost("CSV pricing is used");
			} else {
				setTabValue(newValue);
			}
		} else {
			setTabValue(newValue);
		}
	};

	const PaymentColumns = [
		{
			field: "action",
			headerName: "Action",
			width: 140,
			renderCell: (params) => {
				return (
					<div
						style={{
							textAlign: "center",
							display: "flex",
							gap: "1rem",
						}}
					>
						{loggedInUser?.roleId?.accessibleTabs?.Project?.[
							'View Project Details'
						]?.['Payment Plans']?.Edit?.isAccessible && (
								<EditIcon
									sx={{ fontSize: '2rem', cursor: 'pointer' }}
									onClick={() => {
										console.log('Edit');
										setEditPaymentPlanData(params.row);
										handleEditOpen();
									}}
								/>
							)}
						{loggedInUser?.roleId?.accessibleTabs?.Project?.[
							'View Project Details'
						]?.['Payment Plans']?.Delete?.isAccessible && (
								<DeleteIcon
									id='isDelete'
									style={{
										width: '2.5rem',
										height: '2.5rem',
										color: '#B42318',
										cursor: 'pointer',
									}}
									onClick={() => {
										console.log('Delete');
										setDeletePaymentPlanOpen(true);
										setDeletePaymentPlanId(params.row.paymentPlanId);
									}}
								/>
							)}
					</div>
				);
			},
		},
		{
			field: "Title",
			headerName: "Title",
			width: 200,
		},
		{
			field: "isDisabled",
			headerName: "Status",
			width: 200,
			renderCell: (params) => {
				return (
					<div
						style={{
							textAlign: "center",
							display: "flex",
							gap: "1rem",
						}}
					>
						{params?.row?.isDisabled === true ? (
							<LeadStatusChip
								label={"disabled"}
								icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
								style={{
									color: "#B54708",
									backgroundColor: "#FFFAEB",
								}}
							/>
						) : (
							<LeadStatusChip
								label={"enabled"}
								icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
								style={{
									color: "rgb(2, 122, 72)",
									backgroundColor: "rgb(236, 253, 243)",
								}}
							/>
						)}
					</div>
				);
			},
		},
		{
			field: "Wings",
			headerName: "Wings",
			width: 350,
		},
		{
			field: "Key",
			headerName: "Key",
			width: 300,
		},
		{
			field: "UnitType",
			headerName: "Unit Type",
			width: 150,
		},
		// {
		//   field: "Discount",
		//   headerName: "Discount",
		//   width: 200,
		// },
	];

	function DeletePaymentResp(e) {
		setDeletePaymentPlanOpen(false);
		console.info("payment-Delete->", e);
		console.info("payment-delete-id", DeletePaymentPlanId);
		if (e === "confirmed") {
			RemovePaymentPlanFromTable(DeletePaymentPlanId)
				.then((resp) => {
					if (resp) {
						RemovePaymentPlanFromLaunch(DeletePaymentPlanId)
							.then((response) => {
								console.info("Successfully Removed", response);
								getPaymentPlanData(false);
								successTost("Successfully Deleted!");
							})
							.catch((err) => {
								console.error("launch-payment-error", err);
								if (
									err.message.includes(
										'update or delete on table'
									)
								) {
									errorTost("This PaymentPlans is already used in allotment.");
								} else {
									errorTost(err.message);
								}
							});
					}
				})
				.catch((err) => {
					console.error("Payment-Plan-err", err);
					if (
						err.message.includes(
							'update or delete on table'
						)
					) {
						errorTost("This PaymentPlan is already used in allotment.");
					} else {
						errorTost(err.message);
					}
				});
		}
	}
	const tabList = tabs.map((each, index) => {
		return (
			<Tab
				label={
					each === 'Inventory' ||
						each === 'Settings' ||
						each === 'Booking Configuration'
						? each + '*'
						: each
				}
				key={index}
				value={each}
				sx={[
					{
						fontFamily: "Inter-Medium !important",
						fontStyle: "normal !important",
						fontWeight: "500 !important",
						fontSize: "1.4rem !important",
						lineHeight: "2rem !important",
						textTransform: "none !important",
					},
				]}
			/>
		);
	});

	function PaymentTableUpdate(respValue) {
		if (respValue === true) {
			getPaymentPlanData(false);
		}
	}

	function PriceListTable(respValue) {
		console.log("respValue", respValue);
		if (respValue === true) {
			getPriceListData(false);
		}
	}

	function CollateralTableUpdate(respValue) {
		if (respValue === true) {
			getCollateralData();
		}
	}

	function UnitDetailsUpdate(respValue) {
		if (respValue === true) {
			setFlagForUnit(true)
			ShowParticularUnit(PreviewSingleUnit[0]);
			setEditUnitData(PreviewSingleUnit[0]);
		}
	}

	const handleChange = (event) => {
		setChecked(event.target.checked);
		console.log("event.target.checked", event.target.checked);
		// ? check if csv is uploaded
		if (ProjectData[0]?.csvUploaded) {
			let obj = {
				useCsvPrice: event.target.checked,
			};
			updateFlagsToProjectTable(obj, projectId)
				.then((response) => {
					console.log("Error in switching to CSV ", response);
					if (event.target.checked) successTost("Prices from CSV will be shown!");
					else successTost("Prices from Price List function will be shown!");
				})
				.catch((err) => {
					console.error("Error in switching to CSV ", err);
					errorTost("Error in switching to CSV. Try again later!");
				});
		} else {
			infoTost("Please upload CSV to use prices from CSV!");
			setChecked(false);
		}
	};

	function downloadCollateral(el) {
		console.log("el", el);
		presentLoader();
		new JsFileDownloader({
			url: process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + el?.collateralUrl,
		})
			.then(function () {
				dismissLoader();
				// Called when download ended
			})
			.catch(function (error) {
				console.log(error);
				// Called when an error occurred
			});
	}

	function saveInventory() {
		if (showMerge) {
			let insertarr = differenceWith(unitsToMerge, allUnitsToMerge, isEqual);
			let deletearr = differenceWith(allUnitsToMerge, unitsToMerge, isEqual);
			console.log(deletearr);
			console.log(insertarr);
			if (insertarr.length > 0) {
				insertarr.forEach((element, index) => {
					insertIntoInventoryMerge({
						unit1Id: element.unit1Id,
						unit2Id: element.unit2Id,
						unit1No: element.unit1No,
						unit2No: element.unit2No,
						projectId: projectId,
					})
						.then((resp) => {
							updateInventory({ inventoryMergeId: resp.data[0].inventoryMergeId }, resp.data[0].unit1Id).then((i1) => {
								updateInventory({ inventoryMergeId: resp.data[0].inventoryMergeId }, resp.data[0].unit2Id).then((i2) => {
									updateProjectInventoryRelations({ mergeId: resp.data[0].inventoryMergeId }, projectId, resp.data[0].unit1Id).then(
										(unit1) => {
											updateProjectInventoryRelations(
												{ mergeId: resp.data[0].inventoryMergeId },
												projectId,
												resp.data[0].unit2Id
											).then((unit2) => {
												if (index === insertarr.length - 1) {
													if (deletearr.length > 0) {
														deletearr.forEach((ele, index2) => {
															deleteInventoryMerge(ele).then((res) => {
																if (index2 === deletearr.length - 1) {
																	setAllUnitsToMerge([]);
																	setAllInventory([]);
																	successTost("Merge/Demerge done successfully");
																	setShowMerge(false);
																}
															});
														});
													} else {
														setAllUnitsToMerge([]);
														setAllInventory([]);
														setShowMerge(false);
														successTost("Merge/Demerge done successfully");
													}
												}
											});
										}
									);
								});
							});
						})
						.catch((err) => {
							console.log(err);
						});
				});
			} else if (deletearr.length > 0) {
				deletearr.forEach((ele, index2) => {
					deleteInventoryMerge(ele).then((res) => {
						if (index2 === deletearr.length - 1) {
							setAllUnitsToMerge([]);
							setAllInventory([]);
							successTost("Merge/Demerge done successfully");
							setShowMerge(false);
						}
					});
				});
			} else {
				setShowMerge(false);
			}
		} else {
			let allUnitsArr = [];
			let allChildUnitsArr = [];
			Object.keys(allInventory).forEach((wing) => {
				Object.keys(allInventory[wing].floors).forEach((floor) => {
					allInventory[wing].floors[floor].units.forEach((unit) => {
						if (unit.isSelected === true) allUnitsArr.push(unit);
					});
				});
			});
			Object.keys(allChildInventory).forEach((wing) => {
				Object.keys(allChildInventory[wing].floors).forEach((floor) => {
					allChildInventory[wing].floors[floor].units.forEach((unit) => {
						if (unit.isSelected === true) allChildUnitsArr.push(unit);
					});
				});
			});
			if (allChildUnitsArr.length === 0) {
				let newarr = cloneDeep(allInventory);
				setAllChildInventory({ ...newarr });
				errorTost("Please select atleast one unit and then save");
				setTabValidation((pre) => {
					pre.inventory = false;
					return { ...pre };
				});
			} else {
				setTabValidation((pre) => {
					pre.inventory = true;
					return { ...pre };
				});
				let newarr = cloneDeep(allChildInventory);
				setAllInventory({ ...newarr });
				if (allChildUnitsArr.length > 0) {
					let deletearr = differenceWith(allUnitsArr, allChildUnitsArr, isEqual);
					let insertarr = differenceWith(allChildUnitsArr, allUnitsArr, isEqual);
					if (insertarr.length > 0) {
						insertarr.forEach((element, index) => {
							insertIntoProjectInventoryRelations({
								projectId: projectId,
								unitId: element.unitId,
								wingId: element.wingId.wingId,
							}).then((resp) => {
								if (index === insertarr.length - 1) {
									if (deletearr.length > 0) {
										deletearr.forEach((ele, index2) => {
											deleteInventoryRelationsOfProject(ele, projectId).then((res) => {
												if (index2 === deletearr.length - 1) {
													successTost("Inventory saved successfully");
													getProjectDetails();
												}
											});
										});
									} else {
										successTost("Inventory saved successfully");
										getProjectDetails();
									}
								}
							});
						});
					} else if (deletearr.length > 0) {
						deletearr.forEach((ele, index2) => {
							deleteInventoryRelationsOfProject(ele, projectId).then((res) => {
								if (index2 === deletearr.length - 1) {
									successTost("Inventory saved successfully");
									getProjectDetails();
								}
							});
						});
					} else {
						successTost("Inventory saved successfully");
						getProjectDetails();
					}
				}
			}
		}
	}
	const handleChangeCheckBoxSettings = (event) => {
		console.log({ ProjectData });
		console.log(event);
		if (event.target.checked) {
			setSettingsHelperText((pre) => {
				pre.displayInventoryType = "";
				return { ...pre };
			});

			if (
				ProjectData[0]?.displayInventoryType?.length === 0 ||
				ProjectData[0]?.displayInventoryType === null
			) {
				let type = [];
				type.push(event.target.name);
				setProjectData((pre) => {
					pre[0].displayInventoryType = type;
					return [...pre];
				});
			} else {
				let type = [];
				type = ProjectData[0].displayInventoryType;
				type.push(event.target.name);
				setProjectData((pre) => {
					pre[0].displayInventoryType = type;
					return [...pre];
				});
			}
			console.log(ProjectData[0]);
		} else {
			let displayInventoryTypeArr = ProjectData[0]?.displayInventoryType.filter(
				(el) => el !== event.target.name
			);
			console.log(displayInventoryTypeArr.length);
			if (displayInventoryTypeArr?.length !== 0) {
				console.log('hii');
				setProjectData((pre) => {
					pre[0].displayInventoryType = displayInventoryTypeArr;
					return [...pre];
				});
				setSettingsHelperText((pre) => {
					pre.displayInventoryType = '';
					return { ...pre };
				});
			} else {
				errorTost('Selection of display Unit Should be minimum one');
			}
			console.log(ProjectData[0].displayInventoryType);
		}
	};
	const handleChangeCheckBoxSettingsCustomer = (event) => {
		console.log({ ProjectData });
		console.log(event);
		if (event.target.checked) {
			setSettingsHelperText((pre) => {
				pre.customerDisplayInventoryType = '';
				return { ...pre };
			});
			if (
				ProjectData[0]?.customerDisplayInventoryType?.length === 0 ||
				ProjectData[0]?.customerDisplayInventoryType === null
			) {
				let type = [];
				type.push(event.target.name);
				setProjectData((pre) => {
					pre[0].customerDisplayInventoryType = type;
					return [...pre];
				});
			} else {
				let type = [];
				type = ProjectData[0].customerDisplayInventoryType;
				type.push(event.target.name);
				setProjectData((pre) => {
					pre[0].customerDisplayInventoryType = type;
					return [...pre];
				});
			}
			console.log(ProjectData[0]);
		} else {
			let customerDisplayInventoryTypeArr =
				ProjectData[0]?.customerDisplayInventoryType.filter(
					(el) => el !== event.target.name
				);
			console.log(customerDisplayInventoryTypeArr.length);
			if (customerDisplayInventoryTypeArr?.length !== 0) {
				console.log('hii');
				setProjectData((pre) => {
					pre[0].customerDisplayInventoryType = customerDisplayInventoryTypeArr;
					return [...pre];
				});
				setSettingsHelperText((pre) => {
					pre.customerDisplayInventoryType = '';
					return { ...pre };
				});
			} else {
				errorTost('Selection of display Unit Should be minimum one');
			}
			console.log(ProjectData[0].customerDisplayInventoryType);
		}
	};
	async function saveProjectSettings() {
		if (parseInt(SdrPercentage) !== parseInt(ProjectData[0]?.sdrPercentage)) {
			setSdrChangeUnitModalOpen(true);
		} else {
			SdrUnitsTableUpdate(true);
		}
	}

	function SaveBookingAmountValues() {
		let allBookingAmt = [];
		// ! vedashree changes ==> only 1 inventoryType per wing getting added
		BookingAmountDetails.forEach((wing, i) => {
			wing.typeOptions.forEach((unittype, index) => {
				let obj = {
					projectId: projectId,
					wingId: wing?.wingId,
					inventoryTypeId: unittype.UnitTypeId,
					OCR: unittype.ocrValue,
					GST: unittype.gstValue,
					SDR: unittype.sdrValue,
					TOTAL: unittype.TotalValue,
				};
				allBookingAmt.push(obj);
			});
		});
		for (let index = 0; index < allBookingAmt.length; index++) {
			const element = allBookingAmt[index];
			CheckBookingAmounts(element.projectId, element.wingId, element.inventoryTypeId)
				.then((response99) => {
					console.log("checking-Data", response99);
					AccessToInventory();
					if (response99?.length === 0) {
						if (
							element.OCR !== "" &&
							!isNaN(parseFloat(element.OCR)) &&
							element.OCR !== 0 &&
							element.GST !== "" &&
							!isNaN(parseFloat(element.GST)) &&
							element.SDR !== "" &&
							!isNaN(parseFloat(element.SDR)) &&
							element.TOTAL !== ""
						) {
							addBookingAmounts(element)
								.then((res) => {
									// console.log("added successfully", res);
									if (index === allBookingAmt.length - 1) {
										successTost("Booking Amounts saved successfully!");
										getProjectDetails();
									}
								})
								.catch((err) => {
									console.error("err-adding-to-table", err);
								});
						} else if (element.OCR === "" && element.GST === "" && element.SDR === "" && element.TOTAL === "") {
							if (index === allBookingAmt.length - 1) {
								errorTost("All Fields are mandatory! Please fill All the fields!");
							}
						} else if (isNaN(parseFloat(element.OCR)) && isNaN(parseFloat(element.GST)) && isNaN(parseFloat(element.SDR))) {
							if (index === allBookingAmt.length - 1) {
								errorTost("All Fields are mandatory! Please fill All the fields!");
							}
						} else if (element.OCR === 0) {
							if (index === allBookingAmt.length - 1) {
								errorTost("OCR cannot be zero! Please Enter OCR  greater than zero!");
							}
						}
					} else {
						if (element.OCR === 0) {
							if (index === allBookingAmt.length - 1) {
								errorTost("OCR cannot be zero! Please Enter OCR greater than zero!");
							}
						} else {
							UpdateBookingAmounts(element.projectId, element.wingId, element.inventoryTypeId, element)
								.then((response78) => {
									console.log("Updated-values", response78);
									if (index === allBookingAmt.length - 1) {
										successTost("Booking Amounts updated successfully");
										getProjectDetails();
									}
								})
								.catch((err) => {
									console.error("err-for-updating", err);
								});
						}
					}
				})
				.catch((err) => {
					console.error("err-for-checking", err);
				});
		}
	}

	async function downloadExcelTemplate() {
		presentLoader();
		let _list = [];

		const pricingResponse = await getDefaultBasePricingByProjectId(projectId);
		console.log("pricingResponse", pricingResponse.data);
		console.log("Available-Units-Only", allUnitsForCsv);
		const getAvailableUnitsOnly = allUnitsForCsv.filter(
			(f) =>
				f.inventoryStatusId.status === "Available" ||
				f.inventoryStatusId.status === "On Hold" ||
				f.inventoryStatusId.status === "Preselected" ||
				f.inventoryStatusId.status === "Kyc Pending" ||
				f.inventoryStatusId.status === "Kyc Done"
		);
		for (const _item of getAvailableUnitsOnly) {
			// if (pricingResponse.data) {
			console.log("_Item", _item);
			const pricingObjPerUnit = {
				Wing: _item.wingName,
				unitNo: _item.unitNo,
				UnitType: _item.inventoryTypeId.type,
				Area: _item.saleableArea,
				"Sales App Status": _item.inventoryStatusId.status,
				"FV Status": _item.farvisionStatus,
				// BSP: _item.BSP,
				// totalCost: _item.totalCost,
				// OCR: _item.OCR,
				// SDR: _item.SDR,
				"Agreement Value": _item.BSP,
				GST: _item.GST,
				SDR: _item.SDR,
				// Registration: '',
				TotalCost: _item.totalCost,
			};
			// ? 1. first, match wing & get price list obj
			// const selectedPriceForWing = _.find(pricingResponse.data, (d) => {
			//   return d.wingId === _item.wingId.wingId;
			// });
			//? 2. if pricing is added for that wing, get prices for units in that wing
			// if (selectedPriceForWing) {
			//   const basePrice = _.find(selectedPriceForWing.basePrices, (bp) => {
			//     return (
			//       bp.inventoryTypeId === _item.inventoryTypeId.inventoryTypeId &&
			//       bp.sqft === _item.saleableArea
			//     );
			//   });
			//   if (basePrice) {
			//     pricingObjPerUnit['Agreement Value'] = parseFloat(
			//       basePrice.BSPTotal
			//     );
			//     pricingObjPerUnit['GST'] = basePrice.GST;
			//     // pricingObjPerUnit['Registration'] = basePrice.REG;
			//     pricingObjPerUnit['TotalCost'] = basePrice.Total;
			//     pricingObjPerUnit['SDR'] = basePrice.SDR;
			//   }
			// } else {
			//? 2. if pricing is not added for that wing, empty prices for units in that wing => do nothing; push empty values
			// }
			console.log("pricingObjPerUnit", pricingObjPerUnit);
			_list.push(pricingObjPerUnit);
			// }
		}

		// console.log('list', _list);
		const worksheet = XLSX.utils.json_to_sheet(_list);
		const workBook = new XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workBook, worksheet, "Price list Units");
		XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
		XLSX.writeFile(workBook, ProjectData[0].projectName + ` Price list Units Template.xlsx`);
		dismissLoader();
		// }
		// })
		// .catch((err) => {
		//   console.error('Selected-Inventory-Data', err);
		// });
		// console.log('list', _list);
	}
	async function DownloadParkingExcelTemplate() {
		presentLoader();
		let parking_list = [];
		// const parking_arr = await getParkingInventory(projectId);
		// console.log("parking-arr" , parking_arr)
		// orderBy(parking_arr , 'created_at' , ['desc'])[0]?.
		// console.log('AllParkingForCsv', AllParkingForCsv);
		const sortByParkingType = orderBy(
			AllParkingForCsv,
			[(type) => type.parkingTypeId?.parkingType?.toLowerCase()],
			['asc']
		)
		const groupByParkingNo = groupBy(sortByParkingType, 'parkingNumber');

		for (const _ele of Object.values(groupByParkingNo)) {
			const db_val = orderBy(_ele, 'created_at', ['desc'])
			const arr = {
				'Parking Type': db_val[0]?.parkingTypeId?.parkingType,
				'Floor Number': db_val[0]?.floorNumber,
				'Parking Number': db_val[0]?.parkingNumber,
				'Parking Status': db_val[0]?.parkingStatusId.status,
				// 'Parking area': db_val[0]?.parkingArea,
				'Parking breadth': db_val[0]?.parkingBreadth,
				'Parking height': db_val[0]?.parkingHeight,
				'Parking length': db_val[0]?.parkingLength,
				'Description' : db_val[0]?.description
			};
			parking_list.push(arr);
		}
		for (const _ele of AllParkingTypes) {
			const arr = {
				'Parking Type': _ele.parkingType,
				'Floor Number': "",
				'Parking Number': "",
				// 'Parking area': "",
				'Parking breadth': "",
				'Parking height': "",
				'Parking length': "",
				'Description': ''
			}
			parking_list.push(arr)
		}

		const worksheet = XLSX.utils.json_to_sheet(parking_list);
		const ws_cols = [{ wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
		worksheet['!cols'] = ws_cols;
		const workBook = new XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workBook, worksheet, 'Parking');
		XLSX.write(workBook, { bookType: 'xlsx', type: 'buffer' });
		XLSX.writeFile(
			workBook,
			ProjectData[0]?.projectName + ` Parking Template.xlsx`
		);
		dismissLoader();
	}
	function publishProject(flag, showToast) {
		let flagCheck = validateAllTab();
		if (flagCheck.flag) {
			updateFlagsToProjectTable({ isPublished: flag, isCompleted: flag }, projectId).then((resp) => {
				getProjectDetails();
				if (showToast) successTost("Project published successfully!");
			});
			// }
		} else {
			errorTost("Cannot publish project as it is incomplete because " + flagCheck.reason + " !");
			// errorTost("Cannot publish project as it is incomplete! ");
		}
	}
	// **Validate all tab
	function validateAllTab() {
		var form = true;
		let reason = "";
		if (AllWings.length === 0 && _.size(allChildInventory) > 0) {
			setTabValidation((pre) => {
				pre.inventory = false;
				return { ...pre };
			});
			form = false;
			reason = "no wing selected";
		} else {
			// !!Settings Tab
			if (ProjectData[0].userId !== null) {
				setTabValidation((pre) => {
					pre.settings = true;
					return { ...pre };
				});
			}
			if (tabValidation.BookingConfiguration === false) {
				form = false;
				reason = reason + "booking amount not added";
			}
		}
		return {
			flag: form,
			reason: reason,
		};
	}
	function ShowParticularWingUnits(wing) {
		setSelectedWing(true);
		// ! vedashree changes => set selected wing
		setWingSelected(wing);
		// console.log("wing.wingId.wingId" ,wing)
		setShowUnits(wing);
		getProjectInventory(projectId)
			.then(async (response44) => {
				let ParticularWing = response44.filter((f) => f.wingId.wingId === wing.wingId.wingId);
				// ! get price of units
				// ? 1. check whether to get prices from csv
				// ? 2. If yes, price is already present in unit
				// ? 3. If no, then get ProjectPricing table
				if (ProjectData[0].useCsvPrice === true) {
					ParticularWing = ParticularWing.map((unit) => {
						unit.unitId.isSelectedForStatusChange = false;
						unit.unitId.price = unit.unitId.totalCost;
						return unit;
					});
				} else if (ProjectData[0].useCsvPrice === false) {
					// ? not used local array for price list because of pagination
					const projectPricingList = await getDefaultBasePricing(projectId, wing.wingId.wingId);
					// ? may get multiple price lists;
					// ! showing only default (where start date & end date is null)
					ParticularWing = ParticularWing.map((unit) => {
						unit.unitId.isSelectedForStatusChange = false;
						if (projectPricingList.data.length > 0) {
							const unitCost = projectPricingList.data[0].basePrices.find((p) => p.sqft === unit.unitId.saleableArea);
							unit.unitId.price = unitCost.Total;
						}
						return unit;
					});
				} else {
					setUnitsPriceNotAdded(true);
				}
				let _units = groupBy(ParticularWing, "unitId.floorNo");
				setPreviewTotalUnits(ParticularWing.length);
				setPreviewSelectedWing(wing.wingId.displayName ? wing.wingId.displayName : wing.wingId.wingName);
				setPreviewUnits(_units);
			})
			.catch((err) => {
				console.log("getProjectInventory", err);
				errorTost(err.message)
			});
	}

	function ShowParticularUnit(unit) {
		setSelectedUnit(true);
		setSelectedUnitData(unit);

		getProjectByProjectName(projectId)
			.then((response33) => {
				getProjectInventoryWithLeadData(projectId)
					.then((response77) => {
						if (unit && unit.wingId) {
							ShowBasePrice(projectId, unit?.wingId?.wingId)
								.then((response99) => {
									setPricingDetails(response99.data);
									if (unit?.unitId?.inventoryMergeId) {
										setMergeIdData(true);
										setMergeID(unit?.unitId?.inventoryMergeId?.inventoryMergeId);
										// setUnit1Name()
										setUnit1(unit?.unitId?.inventoryMergeId?.unit1Id);
										setUnit2(unit?.unitId?.inventoryMergeId?.unit2Id);
									}
									if (response33.data[0]?.useCsvPrice === false) {
										if (response99.data.length > 0) {
											response99.data[0]?.basePrices?.forEach((_Item) => {
												if (unit?.unitId?.inventoryTypeId?.inventoryTypeId === _Item.inventoryTypeId) {
													setTotalBsp(_Item);
													if (response99.data[0]?.floorRise[0]?.value) {
														response99.data[0]?.floorRise?.forEach((item) => {
															if (item.from <= unit?.unitId?.floorNo && item.to >= unit?.unitId?.floorNo) {
																if (item.type === "Percentage") {
																	if (unit?.unitId?.saleableArea === _Item.sqft) {
																		const floorRise_per_unit =
																			(parseInt(_Item.BSPTotal) * parseInt(item.value)) / 100;
																		setFloorRiseValue(floorRise_per_unit);
																	}
																} else if (item.type === "Value") {
																	const floorRise_per_unit_by_Value = parseInt(item.value);
																	setFloorRiseValue(floorRise_per_unit_by_Value);
																}
															}
														});
													}

													if (response99.data[0]?.plc) {
														response99.data[0]?.plc.forEach((item) => {
															if (unit?.unitId?.view === "") {
																if (item.type === "Percentage") {
																	if (unit?.unitId?.saleableArea === _Item.sqft) {
																		const plc_per_unit = (parseInt(_Item.BSPTotal) * parseInt(item.value)) / 100;

																		setPlcValue(plc_per_unit);
																	}
																} else if (item.type === "Value") {
																	const plc_per_unit_by_Value = parseInt(item.value);
																	setPlcValue(plc_per_unit_by_Value);
																}
															}
														});
													}
												}
											});
										} else {
											setPriceNotAdded(true);
										}
									} else if (response33.data[0]?.useCsvPrice === true) {
										setCsvFlag(true);
										setCsvData(unit?.unitId);
										if (
											unit?.unitId?.BSP === null ||
											(unit?.unitId?.BSP === 0 && unit?.unitId?.GST === 0 && unit?.unitId?.SDR === 0)
										) {
											setPriceNotAdded(true);
											if (unit?.unitId?.BSP === 0 && unit?.unitId?.GST === 0 && unit?.unitId?.SDR === 0) {
												setAfterCancelUnitPrice(true);
											}
										}
									} else if (response33.data[0]?.useCsvPrice === null) {
										setPriceNotAdded(true);
									}
								})
								.catch((err) => {
									console.error("ShowBasePrice", err);
									errorTost(err.message)
								});
							const ParticularUnit = response77.filter((f) => f.unitId.unitId === unit.unitId.unitId);
							setPreviewSingleUnit(ParticularUnit);
						}
					})
					.catch((err) => {
						console.log("getProjectInventory", err);
						errorTost(err.message)
					});
			})
			.catch((err) => {
				console.error("project-data-err", err);
				errorTost(err.message)
			});
	}

	//  ! vedashree changes => change unit status
	const handleOnChange = (unit) => {
		unit.isSelectedForStatusChange = !unit.isSelectedForStatusChange;

		let pre = [...selectedUnitsForStatusChange];

		if (pre.findIndex((f) => f.unitId === unit.unitId) === -1) {
			pre.push(unit);
		} else {
			pre.splice(
				pre.findIndex((f) => f.unitId === unit.unitId),
				1
			);
		}
		setSelectedUnitsForStatusChange([...pre]);
	};

	function DownloadUnits() {
		presentLoader();
		getProjectInventory(projectId)
			.then((response22) => {
				if (response22.length === 0) {
					errorTost("No Available Units were Found!");
					dismissLoader();
				} else {
					let _list = [];
					const Data = sortBy(response22, "unitId.wingId.wingName");
					Data.map((m, index) => {
						const obj = {
							Wing: m.wingId?.wingName,
							FloorNo: m.unitId?.floorNo ? m.unitId?.floorNo : "",
							unitNo: m.unitId?.unitNo,
							UnitType: m.unitId?.inventoryTypeId?.type,
							Area: m.unitId?.saleableArea ? m.unitId?.saleableArea : "",
							"Sales App Status": m.unitId?.inventoryStatusId?.status ? m.unitId?.inventoryStatusId?.status : "",
							"FV Status": m.unitId?.farvisionStatus ? m.unitId?.farvisionStatus : "",
							BSP: m.unitId?.BSP ? m.unitId?.BSP : "",
							GST: m.unitId?.GST ? m.unitId?.GST : "",
							SDR: m.unitId?.SDR ? m.unitId?.SDR : "",
							totalCost: m.unitId?.totalCost ? m.unitId?.totalCost : "",
						};
						_list.push(obj);
					});

					const worksheet = XLSX.utils.json_to_sheet(_list);
					const workBook = new XLSX.utils.book_new();
					XLSX.utils.book_append_sheet(workBook, worksheet, "All Units");
					XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
					XLSX.writeFile(workBook, `All Units Template.xlsx`);
					dismissLoader();
				}
			})
			.catch((err) => {
				console.error("Available-Inventory-Data", err);
				errorTost(err.message)
			});
	}

  useEffect(() => {
    // Function to fetch inventory logs for the given unitId
    const fetchInventoryLogs = async () => {
      try {
        // Fetch the data from the 'InventoryLogs' table
        const { data, error } = await supabase
          .from("InventoryLogs")
          .select(
            `
            *,
            Users:userId (
              name
            )
          `,
          )
          .eq("unitId", PreviewSingleUnit[0]?.unitId?.unitId) // Filter logs by unitId
          .order("created_at", { ascending: false }); // Order logs by creation date (optional)

        if (error) throw error; // If there's an error, throw it

        // Add userName to each log
        const logsWithUserNames = data.map((log) => ({
          ...log,
          userName: log.Users?.name || "Unknown User", // Add the userName or fallback to "Unknown User"
        }));

        // Set the fetched data into the state
        setInventoryLogs(logsWithUserNames);
      } catch (error) {
        console.error("Error fetching inventory logs:", error.message);
      }
    };

    // Call the function to fetch the inventory logs
    fetchInventoryLogs();
  }, [PreviewSingleUnit[0]?.unitId?.unitId]); // Re-run this effect when unitId changes

  const timeLine = inventoryLogs.map((timelineItem, timelineIndex) => {
    console.log("timelineItem", timelineItem);
    console.log("timelineIndex", timelineIndex);
    return (
      <Timeline
        key={`Timeline_${timelineIndex}`}
        position="right"
        sx={[
          {
            padding: "0rem !important",
            [`& .MuiTimeline-root `]: {
              padding: "0rem !important",
            },
            "& . MuiTypography-root": {
              padding: "19px 16px !important",
            },
            [`& .MuiTimelineItem-root:before`]: {
              flex: "0rem !important",
              padding: "0rem !important",
              "-webkitFlex": "none !important",
            },
          },
        ]}
      >
        <TimelineItem
          key={`TimelineItem_${timelineIndex}`}
          color={timelineIndex === 0 ? "primary" : "grey"}
        >
          <TimelineSeparator>
            <TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
              {timelineItem.isCompleted ? (
                <DoneIcon />
              ) : (
                <DoneIcon
                  className={
                    timelineIndex === 0 ? cssClasses.active : cssClasses.all
                  }
                />
              )}
            </TimelineDot>
            {timelineIndex !== inventoryLogs.length - 1 && (
              <TimelineConnector />
            )}
          </TimelineSeparator>

          <TimelineContent>
            <Typography
              fontSize={"1.4rem"}
              style={{
                paddingTop: "1rem",
                textDecoration: timelineItem.isCompleted
                  ? "line-through"
                  : "none",
              }}
            >
              <span
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#000000",
                  lineHeight: "2rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                {timelineItem.status === "Unclaimed" ||
                timelineIndex === inventoryLogs[inventoryLogs.length - 1]?.index
                  ? "Lead Created"
                  : timelineItem.status}
              </span>
            </Typography>
            <Typography>
              {/* <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#667085",
                  lineHeight: "2rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                {timelineItem?.message && convertNewlinesToBr(timelineItem.message)}
              </div> */}

              <div
                style={{
                  display: "flex", // Flexbox to align the items horizontally
                  flexDirection: "row", // Arrange items in a row
                  gap: "2rem", // Adds space between each element
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467", // Default color for other elements
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  marginTop: "0.5rem",
                  alignItems: "center", // Vertically center the items
                }}
              >
                <div>
                  {/* Format the date and time */}
                  {new Date(timelineItem.created_at).toDateString()},{" "}
                  {new Date(timelineItem.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>|
                <div>
                  {/* User Info with black color */}
                  User:{" "}
                  <span style={{ color: "black" }}>
                    {timelineItem.userName || "Unknown User"} 
                  </span> 
                </div>|
                <div>
                  {/* Hold Reason */}
                  Hold Reason:{" "}
                  <span style={{ color: "black" }}>
                    {timelineItem.holdReason || "NA"} 
                  </span> 
                </div>
                
              </div>
			  <div style={{ marginTop: "0.5rem" }}>
                  {/* Note */}
                  <span style={{ color:"#475467" , fontSize:"1.4rem",}}>Note:{" "}</span>
                  <span style={{ color: "#96989c" , fontSize:"1.4rem" }}>
                    {timelineItem.unitStatusChangeReason || "NA"}
                  </span>
                </div>
            </Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    );
  }); 

	return (
		<Box className={cssClasses.Container}>
			<Box mb={2}>
				<Box className={cssClasses.SubContainer}>
					<Box className={cssClasses.DivContainer}>
						<Box className={cssClasses.HeaderTitle}>{ProjectData[0]?.projectName}</Box>
						<Box className={cssClasses.SubTitle}>
							{ProjectData[0]?.addressLine1},{ProjectData[0]?.addressLine2} {ProjectData[0]?.addressLine3}
						</Box>
					</Box>

					<Box className={cssClasses.SubContainer} marginLeft={"auto"} mb={2}>
						<>
							{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Price List Radio"]?.isAccessible && (
								<Box width={"fit-content"} margin={"1rem 2rem"} display={"flex"} flexDirection={"row"}>
									<Box mr={1} mt={0.3} className={cssClasses.Title1}>
										Price List
									</Box>
									<CustomSwitch checked={checked} onChange={handleChange} />
									<Box ml={1} mt={0.3} className={cssClasses.Title1}>
										CSV
									</Box>
								</Box>
							)}
							{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Download CSV"]?.isAccessible && (
								<Box width={"fit-content"} margin={"0 2rem"}>
									<Button
										style={{
											fontSize: "1.4rem",
											lineHeight: "2rem",
											color: "#344054",
											backgroundColor: "#FFFFFF",
											borderRadius: "0.8rem",
										}}
										disable={CsvButton}
										padding={"0.8rem 2.7rem"}
										btnName={"Download CSV"}
										clicked={() => downloadExcelTemplate()}
									/>
								</Box>
							)}
							{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Upload CSV"]?.isAccessible && (
								<Box width={"fit-content"} margin={"0 2rem"}>
									<Button
										style={{
											fontSize: "1.4rem",
											lineHeight: "2rem",
											color: "#FFF",
											backgroundColor: "#1570EF",
											borderRadius: "0.8rem",
										}}
										disable={CsvButton}
										padding={"0.8rem 3.7rem"}
										btnName={"Upload CSV"}
										clicked={() => {
											openSelectExcelFile();
											getProjectDetails();
										}}
									/>
								</Box>
							)}
							{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Publish"]?.isAccessible && (
								<Box width={"fit-content"} margin={"0 2rem"}>
									<Button
										style={{
											fontSize: "1.4rem",
											lineHeight: "2rem",
											color: "#FFF",
											backgroundColor: "#1570EF",
											borderRadius: "0.8rem",
										}}
										disable={CsvButton}
										padding={"0.8rem 3.7rem"}
										btnName={ProjectData[0]?.isPublished ? "Unpublish" : "Publish"}
										clicked={() => {
											if (ProjectData[0]?.isPublished === false) {
												// if (ProjectData[0].OCRLedger && ProjectData[0].GSTLedger) {
												publishProject(!ProjectData[0].isPublished, true);
												// } else {
												//   errorTost("Please select OCR & GST bank and save")
												// }
											} else {
												updateFlagsToProjectTable({ isPublished: false, isCompleted: false }, projectId).then((resp) => {
													successTost("Project unpublished successfully!");
													getProjectDetails();
												});
											}
										}}
									/>
								</Box>
							)}
							<Box>
								<ThreeDotsMenu
									list={['Upload parking CSV', 'Download parking CSV']}
									selectedValue={(e) => {
										console.log('e', e);
										if (e === 'Upload parking CSV') {
											openSelectParkingExcelFile();
											getParkingData();
										} else if (e === 'Download parking CSV') {
											DownloadParkingExcelTemplate();
											getParkingData();
										}
									}}
								/>
							</Box>
						</>
					</Box>
				</Box>
			</Box>

			<Divider />

			<Box margin={"2rem 0"}>
				<Tabs
					value={tabValue}
					onChange={tabChange}
					variant="scrollable"
					scrollButtons="auto"
					aria-label="scrollable auto tabs"
					sx={[
						{
							borderBottom: "1px solid #EAECF0 !important",
						},
					]}
				>
					{tabList}
				</Tabs>
			</Box>

			{uploadExcelFile && (
				<UploadingDataModal
					open={uploadExcelFile ? true : false}
					handleClose={(flag) => {
						console.log("flag: ", flag);
						setUploadExcelFile(null);
						// if (flag) {
						ProjectData[0].csvUploaded = flag;
						setTabValue("Inventory");
						setSelectedWing(false);
						setSelectedUnit(false);
						// }
					}}
					uploadExcelFile={uploadExcelFile}
					allUnits={allUnitsForCsv}
					respValue={UnitsTableUpdate}
					sdrPercent={SdrPercentage}
					legalChargeVal={LegalChargesVal}
					registrationCharges={registrationVal}
				/>
			)}
			{uploadParkingExcel && (
				<UploadParkingModal
					open={uploadParkingExcel ? true : false}
					handleClose={(flag) => {
						console.log('flag: ', flag);
						setUploadParkingExcel(null);
						setTabValue('Inventory');
						setSelectedWing(false);
						setSelectedUnit(false);
					}}
					uploadExcelFile={uploadParkingExcel}
					allParking={AllParkingForCsv}
					allParkingTypes={AllParkingTypes}
					resVal={ParkingTableUpdate}
				/>
			)}

			{SdrChangeUnitModalOpen && (
				<SdrChangeUnitsModal
					open={SdrChangeUnitModalOpen}
					handleClose={() => {
						setSdrChangeUnitModalOpen(false);
					}}
					data={unitsForSdrChange}
					oldSdrPercent={parseInt(SdrPercentage)}
					newSdrPercent={parseInt(ProjectData[0]?.sdrPercentage)}
					responseValue={SdrUnitsTableUpdate}
					legalChargesVal={LegalChargesVal}
					registrationChargesVal={registrationVal}
				/>
			)}
			{tabValue === "Inventory" && (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						justifyContent: "space-between",
						height: "100%",
					}}
				>
					{/* setOpenAlert={setOpenAlert} */}
					<div style={{ width: "100%" }}>
						{!SelectedWing && (
							<div style={{ width: "100%" }}>
								<SelectInventory
									flag={flag}
									setFlag={setFlag}
									allInventory={allInventory}
									allUnitsToMerge={allUnitsToMerge}
									showMerge={showMerge}
									setShowMerge={setShowMerge}
									unitsToMerge={unitsToMerge}
									setUnitsToMerge={setUnitsToMerge}
									allChildInventory={allChildInventory}
									mode={"edit"}
									setAllChildInventory={setAllChildInventory}
									totalFloorsSelected={totalFloorsSelected}
									totalUnitsSelected={totalUnitsSelected}
								/>
							</div>
						)}
						{flag !== "hide preview" && (
							<div style={{ width: "100%" }}>
								<>
									{SelectedWing === false && (
										<>
											{AllWings.length > 0 && (
												<>
													<Box className={cssClasses.SubContainer}>
														<Box className={cssClasses.SubContainer} marginLeft={"auto"}>
															<Box mt={1.5}>
																<Button
																	style={{
																		color: "#155EEF",
																		backgroundColor: "#FFF",
																		border: "1px solid #155EEF",
																		fontSize: "1.4rem",
																		lineHeight: "2rem",
																	}}
																	//  padding={'0.8rem 0.3rem'}
																	btnName={"Download All Units"}
																	clicked={() => DownloadUnits()}
																/>
															</Box>
															<Box margin={"1rem 2rem"}>
																<ViewToggleSwitch setMode={setMode} />
															</Box>
														</Box>
													</Box>
													<Divider />
													<Box className={cssClasses.BoxDiv} mt={2}>
														<AllotmentDiv
															style={{ backgroundColor: "#D1FADF" }}
															content={"Available"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Available")
																		.length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#FEF0C7" }}
															content={"On Hold"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "On Hold")
																		.length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#FEE4E2" }}
															content={"Payment Pending"}
															// content={"Alloted"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Payment Pending"
																	).length
																	: "0"
															}
														/>

														<AllotmentDiv
															style={{ backgroundColor: "#FFE6D5" }}
															content={"Preselected"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Preselected")
																		.length
																	: "0"
															}
														/>

														<AllotmentDiv
															style={{ backgroundColor: "#EFF8FF" }}
															content={"Kyc Pending"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Kyc Pending")
																		.length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#D1E9FF" }}
															content={"Kyc Done"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Kyc Done")
																		.length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#FFFAEB" }}
															content={"SDR Payment Pending"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "SDR Payment Pending"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#F4EBFF" }}
															content={"Reserved"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Reserved")
																		.length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#F2F4F7" }}
															content={"Locked"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Locked").length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "rgb(249 171 165)" }}
															content={"Sold"}
															Quantity={
																UnitStatus
																	? UnitStatus?.filter((f) => f.unitId.inventoryStatusId.status === "Sold").length
																	: "0"
															}
														/>
													</Box>
													<Divider />
												</>
											)}

											{mode === "Card View" && (
												<>
													<Box className={cssClasses.MainDiv}>
														<Box className={cssClasses.FlexRow}>
															{sortBy(AllWings, "wingId.wingName")?.map((wing, index) => (
																<Box component={"span"} key={`${wing}_${index}`}>
																	<WingsCard
																		clicked={() => {
																			if (
																				loggedInUser?.roleId?.accessibleTabs?.Project?.[
																					"View Project Details"
																				]?.Inventory?.["Preview Inventory"]?.isAccessible
																			) {
																				ShowParticularWingUnits(wing);
																			}
																		}}
																		wingName={
																			wing.wingId.displayName ? wing.wingId.displayName : wing.wingId.wingName
																		}
																	// wingName={wing.wingId.wingName}
																	/>
																</Box>
															))}
														</Box>
													</Box>

													{NoWingsFound === false && (
														<Box mt={2}>
															<Box className={cssClasses.noDataMsg}>
																<Box className={cssClasses.emptyIcon}>
																	<img src={WingsIcon} alt="No Wings Available" />
																</Box>
																<Box className={cssClasses.emptyTitle}>No Wings were Found</Box>
															</Box>
														</Box>
													)}
												</>
											)}

											{mode === "Table View" && (
												<Box margin={"1rem"}>
													{sortBy(AllWings, "wingId.wingName")?.map((wing, index) => (
														<Box mb={2}>
															<Card
																onClick={() => {
																	if (
																		loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]
																			?.Inventory?.["Preview Inventory"]?.isAccessible
																	) {
																		ShowParticularWingUnits(wing);
																	}
																}}
																sx={{
																	padding: "2rem",
																	// color: "#344054",
																	fontSize: "1.6rem",
																	fontFamily: "Inter-Regular",
																	lineHeight: "2.4rem",
																	width: "100%",
																	display: "flex",
																	flexDirection: "row",
																	flexWrap: "wrap",
																	// justifyContent: "space-between",
																	alignItems: "center",
																	boxShadow:
																		"0px 1px 3px rgb(16 24 40 / 10%), 0px 1px 2px rgb(16 24 40 / 6%) !important",
																	borderRadius: "0.8rem !important",
																	border: " 1px solid rgba(0, 0, 0, 0.12) !important",
																	gap: "1rem",
																	cursor: "pointer",
																}}
																key={`${wing}_${index}`}
															>
																<Box>
																	Wing {wing.wingId.displayName ? wing.wingId.displayName : wing.wingId.wingName}
																</Box>
																{/* <Box>Wing {wing.wingId.wingName}</Box> */}
															</Card>
														</Box>
													))}

													{NoWingsFound === false && (
														<Box>
															<Box className={cssClasses.noDataMsg}>
																<Box className={cssClasses.emptyIcon}>
																	<img src={WingsIcon} alt="No Wings" />
																</Box>
																<Box className={cssClasses.emptyTitle}>No Wings found</Box>
															</Box>
														</Box>
													)}
												</Box>
											)}
										</>
									)}

									{SelectedWing === true && SelectedUnit === false && (
										<>
											<Box className={cssClasses.SubContainer} paddingBottom={"1rem"}>
												<Box className={cssClasses.DivContainer1}>
													{/* // ! vedashree changes */}
													{/* <Box margin={'2rem 0'}> */}
													<Box className={cssClasses.DivContainer1}>
														<Box className={cssClasses.Title}>
															<Button
																style={{
																	fontSize: "1.6rem",
																	lineHeight: "2.4rem",
																	color: "#5f6368",
																	backgroundColor: "#FFFFFF",
																	border: "none",
																	boxShadow: "none",
																	justifyContent: "flex-start",
																}}
																padding={"0"}
																btnIcon={
																	<ArrowBack
																		style={{
																			width: "2rem",
																			height: "2rem",
																			color: "#5f6368",
																		}}
																	/>
																}
																iconPosition={"left"}
																btnName={"Preview Inventory"}
																clicked={() => setSelectedWing(false)}
															/>
														</Box>
														<Box className={cssClasses.Title}>
															Wing :
															<Box component={"span"} className={cssClasses.NumberTitle} ml={2}>
																{PreviewSelectedWing}
															</Box>{" "}
														</Box>
														<Box className={cssClasses.Title}>
															Total Units :
															<Box component={"span"} className={cssClasses.NumberTitle} ml={2}>
																{PreviewTotalUnits}
															</Box>{" "}
														</Box>
														{/* </Box>
                          <Box> */}
														<Box className={cssClasses.SubContainer}>
															{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.Inventory?.[
																"Preview Inventory"
															]?.["Change Unit Status"]?.isAccessible && (
																	<Box width={"fit-content"}>
																		<Button
																			style={{
																				fontSize: "1.4rem",
																				lineHeight: "2rem",
																				color: "#1570EF",
																				backgroundColor: "#FFFFFF",
																				borderRadius: "0.4rem",
																				border: "0",
																				boxShadow: "none",
																			}}
																			iconPosition={"left"}
																			btnIcon={<EditIcon color={"#1570EF"} fill={"none"} />}
																			padding={"0"}
																			btnName={"Change Unit Status"}
																			// clicked={handleChangeStatusOpen}
																			clicked={() => {
																				setOpenChangeStatus(true);
																			}}
																		/>
																	</Box>
																)}
														</Box>
													</Box>
												</Box>
											</Box>
											<Divider />
											{sortBy(Object.keys(PreviewUnits), (fl) => {
												return isNaN(parseInt(fl.split(" ")[1])) ? 0 : parseInt(fl.split(" ")[1]);
											}).map((unitKey, unitKeyIndex) => (
												<Box mb={4} key={`${unitKey}_${unitKeyIndex}`}>
													<Box className={cssClasses.firstTitle}>
														{unitKey}
														{/* FLOOR {unitKey} */}
													</Box>

													<Divider />
													<Box className={cssClasses.BoxDiv}>
														<AllotmentDiv
															style={{ backgroundColor: "#D1FADF" }}
															content={"Available"}
															Quantity={
																PreviewUnits[unitKey]?.filter(
																	(f) => f.unitId.inventoryStatusId.status === "Available"
																)
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Available"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#FEF0C7" }}
															content={"On Hold"}
															Quantity={
																PreviewUnits[unitKey]?.filter((f) => f.unitId.inventoryStatusId.status === "On Hold")
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "On Hold"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#FEE4E2" }}
															// content={"Alloted"}
															content={"Payment Pending"}
															Quantity={
																PreviewUnits[unitKey]?.filter(
																	(f) => f.unitId.inventoryStatusId.status === "Payment Pending"
																)
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Payment Pending"
																	).length
																	: "0"
															}
														/>

														<AllotmentDiv
															style={{ backgroundColor: "#FFE6D5" }}
															content={"Preselected"}
															Quantity={
																PreviewUnits[unitKey]
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Preselected"
																	).length
																	: "0"
															}
														/>

														<AllotmentDiv
															style={{ backgroundColor: "#EFF8FF" }}
															content={"Kyc Pending"}
															Quantity={
																PreviewUnits[unitKey]
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Kyc Pending"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#D1E9FF" }}
															content={"Kyc Done"}
															Quantity={
																PreviewUnits[unitKey]
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Kyc Done"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#FFFAEB" }}
															content={"SDR Payment Pending"}
															Quantity={
																PreviewUnits[unitKey]
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "SDR Payment Pending"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#F4EBFF" }}
															content={"Reserved"}
															Quantity={
																PreviewUnits[unitKey]?.filter((f) => f.unitId.inventoryStatusId.status === "Reserved")
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Reserved"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "#F2F4F7" }}
															content={"Locked"}
															Quantity={
																PreviewUnits[unitKey]?.filter((f) => f.unitId.inventoryStatusId.status === "Locked")
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Locked"
																	).length
																	: "0"
															}
														/>
														<AllotmentDiv
															style={{ backgroundColor: "rgb(249 171 165)" }}
															content={"Sold"}
															Quantity={
																PreviewUnits[unitKey]?.filter((f) => f.unitId.inventoryStatusId.status === "Sold")
																	? PreviewUnits[unitKey]?.filter(
																		(f) => f.unitId.inventoryStatusId.status === "Sold"
																	).length
																	: "0"
															}
														/>
													</Box>
													<Divider />

													<Box className={cssClasses.MainDiv}>
														<Box className={cssClasses.flexRow3}>
															<>
																{sortBy(PreviewUnits[unitKey], "unitId.unitNo")?.map((unit, index) => (
																	<BlockDiv
																		key={`${unit}_${index}`}
																		clicked={() => {
																			ShowParticularUnit(unit);
																			setEditUnitData(unit);
																		}}
																		Sale={false}
																		paired={unit.unitId.inventoryMergeId ? true : false}
																		RefreshUnit={true}
																		UnitInfo={unit}
																		pairedInfo={
																			unit?.unitId.unitId === unit?.unitId.inventoryMergeId?.unit1Id
																				? `Paired with ${unit?.unitId.inventoryMergeId?.unit2No}`
																				: `Paired with ${unit?.unitId.inventoryMergeId?.unit1No}`
																		}
																		// Name={""}
																		// NameTitle={""}
																		// **Check User Access

																		CheckBox={
																			loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]
																				?.Inventory?.["Preview Inventory"]?.["Change Unit Status"]
																				?.isAccessible &&
																				(unit.unitId.inventoryStatusId.status === "Available" ||
																					unit.unitId.inventoryStatusId.status === "On Hold")
																				? loggedInUser?.roleId?.accessibleTabs?.Project?.[
																					"View Project Details"
																				]?.Inventory?.["Preview Inventory"]?.["Change Unit Status"]
																					?.isAccessible
																				: false
																		}
																		isSelected={unit.unitId.isSelectedForStatusChange}
																		changeUnit={() => {
																			handleOnChange(unit.unitId);
																		}}
																		align={true}
																		style={
																			unit.unitId.inventoryStatusId.status === "Sold"
																				? {
																					color: "rgb(181 14 1)",
																					backgroundColor: "rgb(249 171 165)",
																				}
																				: unit.unitId.inventoryStatusId.status === "Available"
																					? {
																						color: "#027A48",
																						backgroundColor: "#D1FADF",
																					}
																					: "" || unit.unitId.inventoryStatusId.status === "On Hold"
																						? {
																							color: "#B54708",
																							backgroundColor: "#FEF0C7",
																						}
																						: "" || unit.unitId.inventoryStatusId.status === "Payment Pending"
																							? {
																								color: "#B42318",
																								backgroundColor: "#FEE4E2",
																							}
																							: "" || unit.unitId.inventoryStatusId.status === "Reserved"
																								? {
																									color: "#6941C6",
																									backgroundColor: "#F4EBFF",
																								}
																								: "" || unit.unitId.inventoryStatusId.status === "Locked"
																									? {
																										color: "#344054",
																										backgroundColor: "#F2F4F7",
																									}
																									: "" || unit.unitId.inventoryStatusId.status === "Preselected"
																										? {
																											color: "#FF4405",
																											backgroundColor: "#FFE6D5",
																										}
																										: "" || unit.unitId.inventoryStatusId.status === "Kyc Pending"
																											? {
																												color: "#0E7090",
																												backgroundColor: "#ECFDFF",
																											}
																											: "" || unit.unitId.inventoryStatusId.status === "Kyc Done"
																												? {
																													color: "#2E90FA",
																													backgroundColor: "#D1E9FF",
																												}
																												: "" || unit.unitId.inventoryStatusId.status === "SDR Payment Pending"
																													? {
																														color: "#B54708",
																														backgroundColor: "#FFFAEB",
																													}
																													: {
																														color: "#000",
																														backgroundColor: "#fff",
																														border: "1px solid rgb(102, 112, 133)",
																													}
																		}
																		//  ! vedashree changes
																		time={
																			unit.unitId.inventoryStatusId.status === "On Hold" &&
																			unit.unitId.unitHoldTime && (
																				<Fragment>
																					<Box className={cssClasses.Clock} mr={1}>
																						<Box component={"span"}>
																							<ClockIcon color="#B54708" fill={"none"} />
																						</Box>
																						<Timer
																							startFrom={unit.unitId.unitHoldTime}
																							onComplete={() => { }}
																							timeFormatter={(time) => {
																								return (
																									<span>
																										{`0${Math.floor(
																											Math.abs(
																												new Date().getTime() -
																												new Date(
																													unit.unitId.unitHoldTime
																												).getTime()
																											) /
																											(1000 * 60 * 60)
																										)}`.slice(-2)}
																										:
																										{`0${Math.floor(
																											Math.abs(
																												new Date().getTime() -
																												new Date(
																													unit.unitId.unitHoldTime
																												).getTime()
																											) /
																											(1000 * 60)
																										) % 60
																											}`.slice(-2)}
																										:
																										{`0${Math.floor(
																											Math.abs(
																												new Date().getTime() -
																												new Date(
																													unit.unitId.unitHoldTime
																												).getTime()
																											) / 1000
																										) % 60
																											}`.slice(-2)}
																									</span>
																								);
																							}}
																						/>
																					</Box>
																				</Fragment>
																			)
																		}
																		// !!Changes from project settings
																		Size={unit.unitId.inventoryTypeId.type}
																		flatNo={unit.unitId.unitNo}
																		UnitOf={unit.unitId.unitOf}
																		displayUnitType={unit.unitId.displayUnitType}
																		Price={
																			UnitsPriceNotAdded
																				? ""
																				: unit.unitId.price === 0
																					? "0"
																					: unit.unitId.price
																		}
																	/>
																))}
															</>
														</Box>
													</Box>

													<Divider />
												</Box>
											))}
											{openChangeStatus && (
												<ChangeBulkUnitStatus
													open={openChangeStatus}
													handleClose={() => {
														setOpenChangeStatus(false);
													}}
													RespValue={handleChangeStatusClose}
													units={selectedUnitsForStatusChange}
												/>
											)}
										</>
									)}

									{SelectedUnit === true && SelectedWing === true && (
										<>
											{/* // ! vedashree changes => single unit details */}
											<Box className={cssClasses.DivContainer}>
												<Box className={cssClasses.navWrap}>
													<Box className={cssClasses.Title1}>
														<Button
															style={{
																fontSize: "1.7rem",
																lineHeight: "2.4rem",
																color: "#5f6368",
																backgroundColor: "#FFFFFF",
																border: "none",
																boxShadow: "none",
															}}
															padding={"0"}
															btnIcon={
																<ArrowBack
																	style={{
																		width: "2rem",
																		height: "2rem",
																		color: "#5f6368",
																	}}
																/>
															}
															iconPosition={"left"}
															btnName={"Preview Inventory"}
															clicked={() => setSelectedUnit(false)}
														/>
													</Box>
													{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.Inventory?.[
														"Preview Inventory"
													]?.["Edit Unit Info"]?.isAccessible && (
															<Box>
																<Button
																	style={{
																		fontSize: "1.4rem",
																		lineHeight: "2rem",
																		color: "#1570EF",
																		backgroundColor: "#FFFFFF",
																		borderRadius: "0.4rem",
																		border: "0",
																		boxShadow: "none",
																	}}
																	iconPosition={"left"}
																	btnIcon={<EditIcon color={"#1570EF"} fill={"none"} />}
																	padding={"0"}
																	btnName={"Edit Unit Info"}
																	clicked={() => {
																		setEditUnitInfoOpen(true);
																		setEditUnitData(PreviewSingleUnit[0]);
																		ShowParticularUnit(PreviewSingleUnit[0]);
																	}}
																/>
															</Box>
														)}

													{EditUnitInfoOpen && (
														<EditUnitInfo
															open={EditUnitInfoOpen}
															unitId={EditUnitData}
															// setUnitId={setEditUnitData}
															respValue={UnitDetailsUpdate}
															handleClose={() => setEditUnitInfoOpen(false)}
														/>
													)}
												</Box>

												<Box className={cssClasses.BoxDiv1}>
													<Box className={cssClasses.Title}>
														Unit :
														<Box component={"span"} className={cssClasses.NumberTitle} ml={2}>
															{PreviewSingleUnit[0]?.unitId?.unitNo}{" "}
														</Box>
														<Box component={"span"} className={cssClasses.NumberTitle}>
															{" "}
															| {PreviewSingleUnit[0]?.unitId?.inventoryTypeId?.type} (
															{PreviewSingleUnit[0]?.unitId?.displayUnitType}) |{" "}
															{PreviewSingleUnit[0]?.unitId?.saleableArea} sq.ft.
														</Box>
													</Box>
													<Box className={cssClasses.Title}>
														Wing :
														<Box component={"span"} className={cssClasses.NumberTitle} ml={2}>
															{PreviewSelectedWing}
														</Box>{" "}
													</Box>
													<Box className={cssClasses.Title}>
														Floor :
														<Box component={"span"} className={cssClasses.NumberTitle} ml={2}>
															{PreviewSingleUnit[0]?.unitId?.floorNo}
														</Box>{" "}
													</Box>
													<Box className={cssClasses.Title}>
														<LeadStatusChip
															style={{
																color: ChipStyle?.chipColor,
																backgroundColor: ChipStyle?.chipBackgroundColor,
															}}
															label={PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status}
															icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
														/>
													</Box>
													{!PriceNotAdded && (
														<Box className={cssClasses.Title}>
															{csvFlag ? (
																<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																	₹{" "}
																	{mergeIdData && CsvData?.totalCost
																		? numberWithCommas(
																			parseFloat(CsvData?.totalCost) + parseFloat(CsvData?.totalCost)
																		)
																		: numberWithCommas(parseFloat(CsvData?.totalCost))}
																</Box>
															) : (
																<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																	₹{" "}
																	{mergeIdData && TotalBsp.BSPTotal
																		? numberWithCommas(
																			(
																				parseFloat(TotalBsp.BSPTotal) +
																				parseFloat(TotalBsp.BSPTotal) +
																				// parseFloat(TotalBsp.REG) +
																				parseFloat(TotalBsp.SDR) +
																				parseFloat(TotalBsp.GST) +
																				parseFloat(TotalBsp.GST)
																				// +
																				// FloorRiseValue
																			).toFixed(2)
																		)
																		: numberWithCommas(
																			(
																				parseFloat(TotalBsp.BSPTotal) +
																				// parseFloat(TotalBsp.REG) +
																				parseFloat(TotalBsp.SDR) +
																				parseFloat(TotalBsp.GST)
																				// +
																				// FloorRiseValue
																			).toFixed(2)
																		)}
																</Box>
															)}
														</Box>
													)}
												</Box>

												<Box className={cssClasses.flexRow} margin={"5rem 0"}>
													<Box className={cssClasses.flexRow}>
														<Box width={"15rem"}>
															<img src={UnitIcon} alt={""} height={"100%"} width={"100%"} />
														</Box>
														<Box className={cssClasses.unitDetails}>
															<Box className={cssClasses.flexRow} width={"50%!important"}>
																<Box margin={"0rem 2rem"} width={"100%"}>
																	<Box className={cssClasses.LeadInfo}>Price Details:</Box>
																	{PriceNotAdded ? (
																		<Box className={cssClasses.Title} display={"flex"} flexDirection={"row"}>
																			{" "}
																			<LeadStatusChip
																				style={{
																					color: "#000000",
																					backgroundColor: "#ececec",
																				}}
																				label={"Price not Added!"}
																				icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
																			/>
																			{afterCancelUnitPrice && (
																				<Box mt={0.2} ml={1}>
																					<InfoOutlinedIcon
																						onClick={handleClick}
																						style={{
																							width: "2rem",
																							height: "2rem",
																							color: "#344054",
																						}}
																					></InfoOutlinedIcon>
																					<Popover
																						id={id}
																						open={IconOpen}
																						anchorEl={anchorEl}
																						onClose={handleIconClose}
																						anchorOrigin={{
																							vertical: "bottom",
																							horizontal: "right",
																						}}
																					>
																						<Typography style={{ fontSize: "1.4rem" }} sx={{ p: 2 }}>
																							Unit is recently cancelled.Reprice is pending
																						</Typography>
																					</Popover>
																				</Box>
																			)}
																		</Box>
																	) : (
																		<Box className={cssClasses.unitPriceWrap}>
																			<Box className={cssClasses.Title}>
																				Agreement Value:{" "}
																				{csvFlag ? (
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{mergeIdData && CsvData?.BSP
																							? ` ₹ ${numberWithCommas(
																								parseFloat(CsvData?.BSP) +
																								parseFloat(CsvData?.BSP)
																							)}`
																							: ` ₹ ${numberWithCommas(CsvData?.BSP)}`}
																					</Box>
																				) : (
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{mergeIdData && TotalBsp?.BSPTotal
																							? ` ₹ ${numberWithCommas(
																								parseFloat(TotalBsp?.BSPTotal) +
																								parseFloat(TotalBsp?.BSPTotal)
																							)}`
																							: ` ₹ ${numberWithCommas(TotalBsp?.BSPTotal)}`}
																					</Box>
																				)}
																				{/* <Box
                                        component={"span"}
                                        ml={1}
                                        className={cssClasses.NumberTitle}
                                      >
                                        {mergeIdData && TotalBsp.BSPTotal ? ` ₹ ${numberWithCommas(parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.BSPTotal))}` : ` ₹ ${numberWithCommas(TotalBsp.BSPTotal)}`}
                                      </Box>{' '} */}
																			</Box>
																			<Box className={cssClasses.Title}>
																				GST:
																				{csvFlag ? (
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{mergeIdData && CsvData.GST
																							? ` ₹ ${numberWithCommas(
																								parseFloat(CsvData.GST) + parseFloat(CsvData.GST)
																							)}`
																							: ` ₹ ${numberWithCommas(+CsvData.GST)}`}
																					</Box>
																				) : (
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{mergeIdData && TotalBsp.GST
																							? ` ₹ ${numberWithCommas(
																								parseFloat(TotalBsp.GST) +
																								parseFloat(TotalBsp.GST)
																							)}`
																							: ` ₹ ${numberWithCommas(+TotalBsp.GST)}`}
																					</Box>
																				)}
																			</Box>

																			{/* <Box className={cssClasses.Title} >
                                      GST :{' '}
                                      <Box
                                        component={'span'}
                                        ml={1}
                                        className={cssClasses.NumberTitle}
                                      >
                                        {mergeIdData && TotalBsp.GST ? ` ₹ ${numberWithCommas(parseFloat(TotalBsp.GST) + parseFloat(TotalBsp.GST))}` : ` ₹ ${numberWithCommas(+TotalBsp.GST)}`}
                                      </Box>
                                    </Box> */}

																			{/* {csvFlag === false &&
                                      <Box className={cssClasses.Title}>
                                        REG :{' '}
                                        <Box
                                          component={'span'}
                                          ml={1}
                                          className={cssClasses.NumberTitle}
                                        >
                                          {TotalBsp.REG
                                            ? ` ₹ ${numberWithCommas(TotalBsp.REG)}`
                                            : '-'}
                                        </Box>
                                      </Box>} */}
																			{/* <Box className={cssClasses.Title} >
                                      REG :{' '}
                                      <Box
                                        component={"span"}
                                        ml={1}
                                        className={cssClasses.NumberTitle}
                                      >
                                        {TotalBsp.REG ? ` ₹ ${numberWithCommas(TotalBsp.REG)}` : "-"}
                                      </Box>
                                    </Box> */}

																			{csvFlag ? (
																				<Box className={cssClasses.Title}>
																					SDR :{" "}
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{CsvData.SDR ? ` ₹ ${numberWithCommas(CsvData?.SDR)}` : "-"}
																					</Box>
																				</Box>
																			) : (
																				<Box className={cssClasses.Title}>
																					SDR :{" "}
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{TotalBsp.SDR ? ` ₹ ${numberWithCommas(TotalBsp.SDR)}` : "-"}
																					</Box>
																				</Box>
																			)}
																			{/* <Box className={cssClasses.Title} >
                                      SDR :{' '}
                                      <Box
                                        component={'span'}
                                        ml={1}
                                        className={cssClasses.NumberTitle}
                                      >
                                        {TotalBsp.REG ? ` ₹ ${numberWithCommas(TotalBsp.SDR)}` : "-"}
                                      </Box>
                                    </Box> */}
																			{csvFlag === false && (
																				<Box className={cssClasses.Title}>
																					FloorRise :{" "}
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						₹{FloorRiseValue ? numberWithCommas(FloorRiseValue) : "-"}
																					</Box>
																				</Box>
																			)}
																			{/* <Box className={cssClasses.Title} >
                                      FloorRise :{' '}
                                      <Box
                                        component={'span'}
                                        ml={1}
                                        className={cssClasses.NumberTitle}
                                      >
                                        ₹
                                        {FloorRiseValue
                                          ? numberWithCommas(FloorRiseValue)
                                          : '-'}
                                      </Box>
                                    </Box> */}
																			{/* <Box className={cssClasses.Title} >
                                    Plc :{' '}
                                    <Box
                                      component={'span'}
                                      ml={1}
                                      className={cssClasses.NumberTitle}
                                    >
                                      ₹
                                      {plcValue
                                        ? numberWithCommas(plcValue)
                                        : '-'}
                                    </Box>
                                  </Box> */}
																			<Box className={cssClasses.Title}>
																				Total :{" "}
																				{csvFlag ? (
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						₹{" "}
																						{mergeIdData && CsvData?.totalCost
																							? numberWithCommas(
																								parseFloat(CsvData?.totalCost) +
																								parseFloat(CsvData?.totalCost)
																							)
																							: numberWithCommas(parseFloat(CsvData?.totalCost))}
																						{/* numberWithCommas((parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.REG) + parseFloat(TotalBsp.GST) + FloorRiseValue + plcValue).toFixed(2)) */}
																					</Box>
																				) : (
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						₹{" "}
																						{mergeIdData && TotalBsp.Total
																							? numberWithCommas(
																								(
																									parseFloat(TotalBsp.Total) +
																									parseFloat(TotalBsp.Total)
																								)
																									// +
																									// FloorRiseValue
																									.toFixed(2)
																							)
																							: numberWithCommas(
																								parseFloat(TotalBsp.Total)
																									// +
																									// FloorRiseValue
																									.toFixed(2)
																							)}
																						{/* numberWithCommas((parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.REG) + parseFloat(TotalBsp.GST) + FloorRiseValue + plcValue).toFixed(2)) */}
																					</Box>
																				)}
																				{/* <Box
                                        component={'span'}
                                        ml={1}
                                        className={cssClasses.NumberTitle}
                                      >
                                        ₹ {mergeIdData && TotalBsp.BSPTotal ?
                                          numberWithCommas((parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.REG) + parseFloat(TotalBsp.GST) + parseFloat(TotalBsp.GST) + FloorRiseValue).toFixed(2)) :
                                          numberWithCommas((parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.REG) + parseFloat(TotalBsp.GST) + FloorRiseValue).toFixed(2))}
                                        numberWithCommas((parseFloat(TotalBsp.BSPTotal) + parseFloat(TotalBsp.REG) + parseFloat(TotalBsp.GST) + FloorRiseValue + plcValue).toFixed(2))}
                                      </Box> */}
																			</Box>
																		</Box>
																	)}
																</Box>
															</Box>
															{(PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status ||
																PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "On Hold" ||
																PreviewSingleUnit[0]?.unitId?.inventoryStatusId?.status === "Payment Pending") && (
																	<>
																		<Box width={"50%!important"}>
																			<Box className={cssClasses.LeadInfo}>Lead Info:</Box>
																			<Box className={cssClasses.unitPriceWrap}>
																				<Box className={cssClasses.Title}>
																					Lead Name :{" "}
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{PreviewSingleUnit[0]?.unitId?.leadId?.personId?.name
																							? PreviewSingleUnit[0]?.unitId?.leadId?.personId?.name
																							: "-"}
																					</Box>{" "}
																				</Box>

																				<Box className={cssClasses.Title}>
																					Lead ID:{" "}
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{PreviewSingleUnit[0]?.unitId?.leadId?.leadDisplayId
																							? "VJ" +
																							PreviewSingleUnit[0]?.unitId?.leadId?.leadDisplayId.replace(
																								PreviewSingleUnit[0]?.unitId?.leadId?.leadDisplayId.substring(
																									8,
																									12
																								),
																								"-" +
																								PreviewSingleUnit[0]?.unitId?.leadId?.leadDisplayId.substring(
																									8,
																									12
																								)
																							)
																							: "-"}
																					</Box>
																				</Box>
																				{loggedInUser.roleId.level === 1 && (
																					<>
																						<Box className={cssClasses.Title}>
																							Lead Contact No :{" "}
																							<Box
																								component={"span"}
																								ml={1}
																								className={cssClasses.NumberTitle}
																							>
																								{PreviewSingleUnit[0]?.unitId?.leadId?.personId
																									?.contactNumber
																									? "+" +
																									PreviewSingleUnit[0]?.unitId?.leadId?.personId
																										?.contactNumber
																									: "-"}
																							</Box>
																						</Box>

																						<Box className={cssClasses.Title}>
																							Lead Mail-Id:{" "}
																							<Box
																								component={"span"}
																								ml={1}
																								className={cssClasses.NumberTitle}
																							>
																								{PreviewSingleUnit[0]?.unitId?.leadId?.personId?.email
																									? PreviewSingleUnit[0]?.unitId?.leadId?.personId
																										?.email
																									: "-"}
																							</Box>
																						</Box>
																					</>
																				)}

																				<Box className={cssClasses.Title}>
																					SM:{" "}
																					<Box component={"span"} ml={1} className={cssClasses.NumberTitle}>
																						{PreviewSingleUnit[0]?.unitId?.leadId?.userId?.name
																							? PreviewSingleUnit[0]?.unitId?.leadId?.userId?.name
																							: "-"}
																					</Box>
																				</Box>
																			</Box>
																		</Box>
																	</>
																)}

															{/* <Box className={cssClasses.Title} mt={3}>
                Show Price:{' '}
                <Box component={'span'} ml={1}>
                  <CustomSwitch 
                   checked={checked}
                   onChange={handleChange}
                   />
                </Box>
              </Box> */}
														</Box>
                             <div className={cssClasses.wrapperStatus}>
                              <div className={classes.statusTitle}>STATUS</div>
                              <div className={cssClasses.progressCardWrapper}>
                                {timeLine}
                              </div>
                            </div>
													</Box>
												</Box>
											</Box>
											{ChangeUnitStatusOpen && (
												<ChangeUnitStatus
													open={ChangeUnitStatusOpen}
													handleClose={() => setChangeUnitStatusOpen(false)}
													unit={PreviewSingleUnit[0]}
													RespValue={(updatedUnit) => {
														console.log("updatedUnit: ", updatedUnit);
														setPreviewSingleUnit([updatedUnit]);
													}}
												/>
											)}
										</>
									)}
								</>
							</div>
						)}
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
							width: "100%",
							gap: "2rem",
							padding: "1rem 0",
						}}
					>
						{/* {flag.includes('hide') &&
              <div>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: '#155EEF',
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.8rem 2.6rem'}
                  btnName={'Back'}
                  // btnIcon={<PlusIcon />}
                  // iconPosition={'left'}
                  clicked={() => { setFlag('change') }}
                />
              </div>
            } */}
						{flag === "hide preview" && (
							<div>
								<Button
									style={{
										fontSize: "1.6rem",
										lineHeight: "2.4rem",
										color: "#FFF",
										backgroundColor: "#155EEF",
										borderRadius: "0.8rem",
									}}
									padding={"0.8rem 2.6rem"}
									btnName={"Save Changes"}
									// btnIcon={<PlusIcon />}
									// iconPosition={'left'}
									clicked={saveInventory}
								/>
							</div>
						)}
					</div>
				</div>
			)}

			{tabValue === "Price List" && (
				<>
					<div className={cssClasses.wrapperHeader}>
						<Box className={cssClasses.SubHeaderTitle}>Base Price List</Box>
						{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Price List"]?.Add?.isAccessible && (
							<Box marginLeft={"auto"}>
								<Button
									style={{
										fontSize: "1.6rem",
										lineHeight: "2.4rem",
										color: "#FFF",
										backgroundColor: "#155EEF",
										borderRadius: "0.8rem",
									}}
									padding={"0.8rem 2.6rem"}
									btnName={"Add Price List"}
									btnIcon={<PlusIcon />}
									iconPosition={"left"}
									clicked={() => {
										setValue("add");
										handlePriceListOpen();
									}}
								/>
							</Box>
						)}
					</div>

					<Box className={cssClasses.GridWrapper}>
						<Datagrid rows={PriceData} columns={PriceListColumns} hideFooter={false} pageChanged={pageChanged} />
					</Box>

					{PriceListOpen && (
						<AddPriceList
							open={PriceListOpen}
							handleClose={handlePriceListClose}
							BasePriceResp={PriceListTable}
							data={PriceListDetails}
							ModalType={Value}
						/>
					)}

					{DeletePriceListOpen && (
						<ConfirmationAlert
							open={DeletePriceListOpen}
							close={() => setDeletePriceListOpen(false)}
							buttonTitle={"No"}
							title={"Warning"}
							subTitle={"Are you sure want to Delete?"}
							returnRespButton={"Yes"}
							confirm={(e) => {
								DeleteResp(e);
							}}
						/>
					)}
				</>
			)}

			{/* <----------------------------------------------------------------------------------------------------------------------------------> */}

			{tabValue === 'Payment Plans' && (
				<>
					<div className={cssClasses.wrapperHeader}>
						<Box className={cssClasses.SubHeaderTitle}>Payment Plans List</Box>
						{loggedInUser?.roleId?.accessibleTabs?.Project?.[
							'View Project Details'
						]?.['Payment Plans']?.Add?.isAccessible && (
								<Box marginLeft={'auto'}>
									<Button
										style={{
											fontSize: '1.6rem',
											lineHeight: '2.4rem',
											color: '#FFF',
											backgroundColor: '#155EEF',
											borderRadius: '0.8rem',
										}}
										padding={'0.8rem 2.6rem'}
										btnName={'Add Payment Plan'}
										btnIcon={<PlusIcon />}
										iconPosition={'left'}
										clicked={handleOpen}
									/>
								</Box>
							)}
					</div>

					<Box className={cssClasses.GridWrapper}>
						<Datagrid
							rows={PaymentData}
							columns={PaymentColumns}
							hideFooter={false}
							pageChanged={pagePaymentPlanChanged}
						/>
					</Box>

					{open && (
						<AddPaymentPlan
							open={open}
							handleClose={handleClose}
							PaymentAddedResp={PaymentTableUpdate}
							selectedWings={allInventory}
							allSelectedInventory={allUnitsForCsv}
							setOpen={setOpen}
						/>
					)}

					{EditOpen && (
						<AddPaymentPlan
							open={EditOpen}
							handleClose={handleEditClose}
							data={EditPaymentPlanData}
							ModalType={'Edit'}
							PaymentAddedResp={PaymentTableUpdate}
							selectedWings={allInventory}
							allSelectedInventory={allUnitsForCsv}
							setOpen={setOpen}
						/>
					)}

					{DeletePaymentPlanOpen && (
						<ConfirmationAlert
							open={DeletePaymentPlanOpen}
							close={() => setDeletePaymentPlanOpen(false)}
							buttonTitle={"No"}
							title={"Warning"}
							subTitle={"Are you sure want to Delete?"}
							returnRespButton={"Yes"}
							confirm={(e) => {
								DeletePaymentResp(e);
							}}
						/>
					)}
				</>
			)}

			{/* <-------------------------------------------------------------------------------------------------------------------------------------------> */}

			{tabValue === "Collateral" && (
				<Fragment>
					<Drive ProjectData={ProjectData} />
					{CollateralOpen && (
						<AddCollateral
							open={CollateralOpen}
							handleClose={handleCollateralClose}
							returnRespValue={CollateralTableUpdate}
							ModalType={CollateralModalType}
							CollateralArray={CollateralData}
						/>
					)}

					{ViewCollateralOpen && (
						<ViewCollateralDetails open={ViewCollateralOpen} handleClose={handleViewCollateralClose} data={viewCollateralDetails} />
					)}

					{DeleteCollateralOpen && (
						<ConfirmationAlert
							open={DeleteCollateralOpen}
							close={() => setDeleteCollateralOpen(false)}
							buttonTitle={"No"}
							title={"Warning"}
							subTitle={"Are you sure want to delete file '" + DeleteCollateralId?.collateralUrl?.split("/")[2] + "' ?"}
							returnRespButton={"Yes"}
							confirm={(e) => {
								DeleteCollateralResp(e);
							}}
						/>
					)}
				</Fragment>
			)}
			{/* <----------------------------------------------------------------------------------------------------------------------------------------------> */}

			{tabValue === "Floor Plans" && (
				<>
					<div className={cssClasses.wrapperHeader}>
						<Box className={cssClasses.SubHeaderTitle}>Floor Plan List</Box>
						{loggedInUser?.roleId?.accessibleTabs?.Project?.["View Project Details"]?.["Floor Plans"]?.Add?.isAccessible && (
							<Box marginLeft={"auto"}>
								<Button
									style={{
										fontSize: "1.6rem",
										lineHeight: "2.4rem",
										color: "#FFF",
										backgroundColor: "#155EEF",
										borderRadius: "0.8rem",
									}}
									padding={"0.8rem 2.6rem"}
									btnName={"Add floor Plan"}
									btnIcon={<PlusIcon />}
									iconPosition={"left"}
									clicked={() => {
										setAddFloorPlan(true);
										setFloorPlanModalType("add");
									}}
								/>
							</Box>
						)}
					</div>

					<Box className={cssClasses.GridWrapper}>
						<Datagrid
							rows={allAssignFloorPlan}
							columns={floorPlanColumn}
							hideFooter={false}
						//  pageChanged={}
						/>
					</Box>
					{addFloorPlan && (
						<CreateFloorPlan
							open={addFloorPlan}
							handleClose={() => {
								setAddFloorPlan(false);
							}}
							returnRes={(value) => {
								console.log({ value });
								if (value) {
									getAllFloorPlans();
								}
							}}
							modalType={floorPlanModalType}
							floorPlanData={floorPlanData}
							projectId={projectId}
						/>
					)}
				</>
			)}
			{/* {tabValue === 'Booking Configuration*' && */}
			{tabValue === "Settings" && (
				<div
					className={cssClasses.wrapperSettings}
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-end",
						height: "80%",
						justifyContent: "space-between",
					}}
				>
					<div className={cssClasses.wrapperSettingsContent}>
						<div
							style={{
								display: "flex",
								width: "100%",
								gap: "5rem",
								alignItems: "flex-start",
								flexDirection: "row",
							}}
						>
							<div className={cssClasses.projectInfoWrap}>
								<div>
									<CustomInput
										handleChange={(e) => {
											setProjectData((pre) => {
												pre[0].projectShortCode = e;
												return [...pre];
											});
											if (e && e !== "") {
												setSettingsHelperText((pre) => {
													pre.shortCode = "";
													return { ...pre };
												});
											} else {
												setSettingsHelperText((pre) => {
													pre.shortCode = "Project short code cannot be empty!";
													return { ...pre };
												});
											}
										}}
										label={"Project Short Code"}
										value={ProjectData[0]?.projectShortCode}
										placeholder={"Project Short Code"}
										inputType={"text"}
										helperText={settingsHelperText.shortCode}
										mandatory={true}
									/>
								</div>
								<div>
									<DropDown
										label={"Project Head"}
										mandatory={true}
										list={allUser.map((element, id) => {
											return {
												label: element?.name,
												value: element?.userId,
											};
										})}
										selectedValue={ProjectData[0]?.userId}
										onChangeSelect={(value) => {
											setProjectData((pre) => {
												pre[0].userId = value;
												return [...pre];
											});
											settingsHelperText.userId = "";
										}}
										helperText={settingsHelperText.userId}
									/>
								</div>
								<div>
									<CustomInput
										handleChange={(e) => {
											setProjectData((pre) => {
												pre[0].projectExtraInfo = e;
												return [...pre];
											});
										}}
										label={"Project Extra Info"}
										value={ProjectData[0]?.projectExtraInfo}
										placeholder={"Project Extra Info"}
										inputType={"TextArea"}
										rows={10}
									/>
								</div>

								<div style={{marginLeft:"5px"}}>
									<div className={cssClasses.toggleLabel}>
									Select SM Access
									</div>
									<CustomRadio
										value={ProjectData[0].smAccess}
										optionList={['Projects', 'Wings','Floors']}
										onChangeValue={(e) => {
												setProjectData((pre) => {
													pre[0].smAccess = e;
													return [...pre];
												});
										}}
									/>
								</div>
							</div>
							<div className={cssClasses.projectInfoWrap}>
								<div className={cssClasses.widthDiv}>
									<DropDown
										list={[1, 2, 3, 4, 5, 6, 7]}
										mandatory={true}
										label={'SDR %'}
										placeHolder={'SDR %'}
										selectedValue={ProjectData[0]?.sdrPercentage}
										onChangeSelect={(value) => {
											setProjectData((pre) => {
												pre[0].sdrPercentage = parseInt(value);
												return { ...pre };
											});
										}}
									/>
								</div>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<div className={cssClasses.toggleLabel}>Legal Charges</div>
									<div className={cssClasses.widthDiv}>
										<CustomInput
											value={ProjectData[0]?.legalCharges}
											inputType={'number'}
											placeholder={'Enter amount'}
											handleChange={(e) => {
												setProjectData((pre) => {
													pre[0].legalCharges = parseInt(e);
													return [...pre];
												});
												if (e <= 0 || 48 == e.keyCode) {
													setSettingsHelperText((pre) => {
														if (e < 0) {
															pre.legalCharges =
																'legal Charges must be positive value!';
														} else {
															pre.legalCharges =
																'legal Charges must be greater than 0!';
														}
														return { ...pre };
													});
												} else {
													setSettingsHelperText((pre) => {
														pre.legalCharges = '';
														return { ...pre };
													});
												}
											}}
											helperText={settingsHelperText.legalCharges}
										/>
									</div>
								</div>

								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<div className={cssClasses.toggleLabel}>Registration Charges</div>
									<div className={cssClasses.widthDiv}>
										<CustomInput
											value={ProjectData[0]?.registrationCharges}
											inputType={'number'}
											placeholder={'Enter amount'}
											handleChange={(e) => {
												setProjectData((pre) => {
													pre[0].registrationCharges = parseInt(e);
													return [...pre];
												});
												if (e <= 0 || 48 == e.keyCode) {
													setSettingsHelperText((pre) => {
														if (e < 0) {
															pre.registrationCharges =
																'registration Charges must be positive value!';
														} else {
															pre.registrationCharges =
																'registration Charges must be greater than 0!';
														}
														return { ...pre };
													});
												} else {
													setSettingsHelperText((pre) => {
														pre.registrationCharges = '';
														return { ...pre };
													});
												}
											}}
											helperText={settingsHelperText.registrationCharges}
										/>
									</div>
								</div>

								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<div className={cssClasses.widthDiv}>
										<DropDown
											list={[2, 3, 5]}
											mandatory={true}
											label={'ClassificationId'}
											placeHolder={'ClassificationId'}
											selectedValue={ProjectData[0]?.classificationId}
											onChangeSelect={(value) => {
												setProjectData((pre) => {
													pre[0].classificationId = parseInt(value);
													return [...pre];
												});
											}}
										/>
									</div>
								</div>

								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<div className={cssClasses.toggleLabel}>
										Female Discount %
									</div>
									<CustomRadio
										value={
											ProjectData[0]?.isFemaleDiscountApplicable === false
												? 'No'
												: 'Yes'
										}
										optionList={['Yes', 'No']}
										onChangeValue={(e) => {
											if (e === 'Yes') {
												setProjectData((pre) => {
													pre[0].isFemaleDiscountApplicable = true;
													return [...pre];
												});
											} else if (e === 'No') {
												setProjectData((pre) => {
													pre[0].isFemaleDiscountApplicable = false;
													return [...pre];
												});
											}
										}}
									/>
								</div>
								<div className={cssClasses.widthDiv}>
									<DropDown
										list={Applicants}
										label={'Applicant Config'}
										placeHolder={'Select Applicant'}
										selectedValue={ProjectData[0]?.applicantType}
										onChangeSelect={(value) => {
											console.log('value', value);
											setProjectData((pre) => {
												pre[0].applicantType = value;
												return [...pre];
											});
										}}
									/>
								</div>
								<div className={cssClasses.widthDiv}>
									<div className={cssClasses.toggleLabel} style={{ marginBottom: "1rem" }}>
										Create Draft Agreement
									</div>
									<CustomSwitch
										checked={ProjectData[0]?.enableCreateDraft}
										onChange={(event) => {
											setProjectData((pre) => {
												pre[0].enableCreateDraft = event.target.checked;
												return [...pre];
											});
										}}
									/>
								</div>
								{/* <div className={cssClasses.bookingAmtInput}>
                  <CustomInput
                    handleChange={(e) => {
                      setProjectData((pre) => {
                        pre[0].bookingOcr = parseInt(e);
                        // pre[0].bookingOcr = parseInt(e) ? parseInt(e) : 0
                        pre[0].bookingAmt =
                          pre[0].bookingSdr +
                          pre[0].bookingGst +
                          (parseInt(e) ? parseInt(e) : 0);
                        return [...pre];
                      });
                      if (e <= 0) {
                        setSettingsHelperText((pre) => {
                          if (e < 0) {
                            pre.ocr = 'OCR must be positive value!';
                          } else {
                            pre.ocr = 'OCR must be greater than 0!';
                          }
                          return { ...pre };
                        });
                      } else {
                        setSettingsHelperText((pre) => {
                          pre.ocr = '';
                          return { ...pre };
                        });
                      }
                    }}
                    label={'OCR'}
                    value={ProjectData[0].bookingOcr}
                    placeholder={'OCR'}
                    inputType={'number'}
                    helperText={settingsHelperText.ocr}
                    mandatory={true}
                  />
                </div>
                <div className={cssClasses.bookingAmtInput}>
                  <CustomInput
                    handleChange={(e) => {
                      setProjectData((pre) => {
                        pre[0]?.bookingGst = parseInt(e) ? parseInt(e) : 0;
                        pre[0]?.bookingAmt =
                          pre[0]?.bookingOcr +
                          pre[0]?.bookingSdr +
                          (parseInt(e) ? parseInt(e) : 0);
                        return [...pre];
                      });
                      if (e <= 0) {
                        setSettingsHelperText((pre) => {
                          if (e < 0) {
                            pre.gst = 'GST must be positive value!';
                          } else {
                            pre.gst = 'GST must be greater than 0!';
                          }
                          return { ...pre };
                        });
                      } else {
                        setSettingsHelperText((pre) => {
                          pre.gst = '';
                          return { ...pre };
                        });
                      }
                    }}
                    label={'GST'}
                    value={ProjectData[0].bookingGst}
                    placeholder={'GST'}
                    inputType={'number'}
                    mandatory={true}
                    helperText={settingsHelperText.gst}
                  />
                </div>
                <div className={cssClasses.bookingAmtInput}>
                  <CustomInput
                    handleChange={(e) => {
                      // console.log(ProjectData)
                      setProjectData((pre) => {
                        pre[0].bookingSdr = parseInt(e) ? parseInt(e) : 0;
                        pre[0].bookingAmt =
                          pre[0].bookingOcr +
                          pre[0].bookingGst +
                          (parseInt(e) ? parseInt(e) : 0);
                        return [...pre];
                      });
                      if (e <= 0) {
                        setSettingsHelperText((pre) => {
                          if (e < 0) {
                            pre.sdr = 'SDR must be positive value!';
                          } else {
                            pre.sdr = 'SDR must be greater than 0!';
                          }
                          return { ...pre };
                        });
                      } else {
                        setSettingsHelperText((pre) => {
                          pre.sdr = '';
                          return { ...pre };
                        });
                      }
                    }}
                    label={'SDR'}
                    mandatory={true}
                    value={ProjectData[0].bookingSdr}
                    placeholder={'SDR'}
                    inputType={'number'}
                    helperText={settingsHelperText.sdr}
                  />
                </div>
                <div className={cssClasses.bookingAmtInput}>
                  <CustomInput
                    label={'Booking Amount'}
                    disabled={true}
                    value={ProjectData[0].bookingAmt}
                    placeholder={'Booking Amt'}
                    inputType={'number'}
                    mandatory={true}
                  />
                </div> */}
								{/* Added DisplayUnitType to show where what to show inventoryTypeId.typeor displayUnitType or both */}
								<FormControl
									sx={{
										m: 3,
										fontFamily: "Inter-Medium",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										padding: "0rem !important",
										margin: "0rem !important",
									}}
								// component="fieldset"
								// variant="standard"
								>
									{/* <FormLabel
                  // component="legend"
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                  }}
                >
                  Display Inventory Type
                </FormLabel> */}
									<div> Display Inventory Type (In Sales App)</div>
									<FormGroup>
										<FormControlLabel
											sx={{
												"& .MuiTypography-root": {
													fontFamily: "Inter-Medium",
													fontSize: "1.4rem",
													lineHeight: "2rem",
												},
											}}
											control={
												<Checkbox
													sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
													checked={ProjectData[0]?.displayInventoryType?.includes("Inventory Type") ? true : false}
													onChange={handleChangeCheckBoxSettings}
													name="Inventory Type"
												/>
											}
											label="Inventory Type"
										/>
										<FormControlLabel
											sx={{
												"& .MuiTypography-root": {
													fontFamily: "Inter-Medium",
													fontSize: "1.4rem",
													lineHeight: "2rem",
												},
											}}
											style={{
												fontFamily: "Inter-Medium",
												fontSize: "1.4rem",
												lineHeight: "2rem",
											}}
											control={
												<Checkbox
													sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
													checked={ProjectData[0]?.displayInventoryType?.includes("Display Unit Type") ? true : false}
													onChange={handleChangeCheckBoxSettings}
													name="Display Unit Type"
												/>
											}
											label="Display Unit Type"
										/>
									</FormGroup>
									<FormHelperText
										sx={{
											fontSize: "1.4rem !important",
											fontFamily: "Inter-Medium !important",
											lineHeight: "1.8rem !important",
											color: "#d32f2f",
										}}
									>
										{settingsHelperText.displayInventoryType}
									</FormHelperText>
								</FormControl>
								<FormControl
									sx={{
										m: 3,
										fontFamily: "Inter-Medium",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										padding: "0rem !important",
										margin: "0rem !important",
									}}
								// component="fieldset"
								// variant="standard"
								>
									<div> Display Inventory Type (In Customer App)</div>
									<FormGroup>
										<FormControlLabel
											sx={{
												"& .MuiTypography-root": {
													fontFamily: "Inter-Medium",
													fontSize: "1.4rem",
													lineHeight: "2rem",
												},
											}}
											control={
												<Checkbox
													sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
													checked={ProjectData[0]?.customerDisplayInventoryType?.includes("Inventory Type") ? true : false}
													onChange={handleChangeCheckBoxSettingsCustomer}
													name="Inventory Type"
												/>
											}
											label="Inventory Type"
										/>
										<FormControlLabel
											sx={{
												"& .MuiTypography-root": {
													fontFamily: "Inter-Medium",
													fontSize: "1.4rem",
													lineHeight: "2rem",
												},
											}}
											style={{
												fontFamily: "Inter-Medium",
												fontSize: "1.4rem",
												lineHeight: "2rem",
											}}
											control={
												<Checkbox
													sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
													checked={
														ProjectData[0]?.customerDisplayInventoryType?.includes("Display Unit Type") ? true : false
													}
													onChange={handleChangeCheckBoxSettingsCustomer}
													name="Display Unit Type"
												/>
											}
											label="Display Unit Type"
										/>
									</FormGroup>
									<FormHelperText
										sx={{
											fontSize: "1.4rem !important",
											fontFamily: "Inter-Medium !important",
											lineHeight: "1.8rem !important",
											color: "#d32f2f",
										}}
									>
										{settingsHelperText?.customerDisplayInventoryType}
									</FormHelperText>
								</FormControl>
								<div style={{
									display: 'flex',
									alignItems: 'center',
									gap: '2rem',
									marginTop: '1rem'
								}}>
									<p className={cssClasses.toggleLabel} style={{ fontFamily: "inter-semiBold" }}>Payment Plan:</p>

									<CustomSwitch
										checked={ProjectData[0]?.enablePaymentPlan}
										onChange={(event) => {
											setProjectData((pre) => {
												pre[0].enablePaymentPlan = event.target.checked;
												return [...pre];
											});
										}}
									/>
								</div>
							</div>
						</div>
						<div
							style={{
								fontFamily: "Inter-Medium",
								fontSize: "1.6rem",
								lineHeight: "2rem",
								marginTop: "3rem",
							}}
						>
							Sustenance Payment Config:
						</div>
						<div
							style={{
								display: "flex",
								gap: "3rem",
								marginBottom: "2rem",
								alignItems: "center",
							}}
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "2rem",
									flex: "30%",
								}}
							>
								<p className={cssClasses.toggleLabel}>Sustenance Payment Method:</p>
							</div>
							<div
								style={{
									display: "flex",
									gap: "2rem",
									alignItems: "center",
									flex: "70%",
								}}
							>
								<div
									style={{
										display: "flex",
										alignItems: "stretch",
									}}
								>
									<div>
										<label className={cssClasses.container}>
											<input
												// disabled={true}
												className={cssClasses.checkbox}
												type="checkbox"
												name=""
												id=""
												onChange={(e) => {
													setSettingsHelperText((pre) => {
														pre.sustenancePaymentMethod = "";
														return { ...pre };
													});
													setProjectData((pre) => {
														pre[0].paymentModes = pre[0]?.paymentModes ? pre[0]?.paymentModes : [];
														if (pre[0]?.paymentModes.includes("Virtual Acc")) {
															pre[0]?.paymentModes.splice(
																pre[0]?.paymentModes.findIndex((e) => e === "Virtual Acc"),
																1
															);
															// if (!pre[0].paymentModes.includes('Cheque') && !pre[0].paymentModes.includes('Card')) {
															//     pre[0].minOnlineAmt = null
															// }
														} else {
															pre[0]?.paymentModes.push("Virtual Acc");
															// if (!pre[0].paymentModes.includes('Razorpay')) {
															//     pre[0].paymentModes.push('Razorpay')
															// }
														}
														return [...pre];
													});
												}}
												checked={ProjectData[0]?.paymentModes?.includes("Virtual Acc") ? true : false}
											/>
											<span className={cssClasses.checkmark}></span>
										</label>
									</div>
									<p className={cssClasses.toggleLabel}>Virtual Acc</p>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "stretch",
									}}
								>
									<div>
										<label className={cssClasses.container}>
											<input
												//  disabled={true}
												className={cssClasses.checkbox}
												type="checkbox"
												name=""
												id=""
												onChange={(e) => {
													setSettingsHelperText((pre) => {
														pre.sustenancePaymentMethod = "";
														return { ...pre };
													});
													setProjectData((pre) => {
														pre[0].paymentModes = pre[0]?.paymentModes ? pre[0]?.paymentModes : [];
														if (pre[0]?.paymentModes?.includes("Card")) {
															pre[0]?.paymentModes?.splice(
																pre[0]?.paymentModes?.findIndex((e) => e === "Card"),
																1
															);
															// if (!pre[0].paymentModes.includes('Cheque') && !pre[0].paymentModes.includes('Card')) {
															//     pre[0].minOnlineAmt = null
															// }
														} else {
															pre[0]?.paymentModes?.push("Card");
															// if (!pre[0].paymentModes.includes('Razorpay')) {
															//     pre[0].paymentModes.push('Razorpay')
															// }
														}
														return [...pre];
													});
												}}
												checked={ProjectData[0]?.paymentModes?.includes("Card") ? true : false}
											/>
											<span className={cssClasses.checkmark}></span>
										</label>
									</div>
									<p className={cssClasses.toggleLabel}>Card</p>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "stretch",
									}}
								>
									<div>
										<label className={cssClasses.container}>
											<input
												// disabled={true}
												className={cssClasses.checkbox}
												type="checkbox"
												name=""
												id=""
												onChange={(e) => {
													setSettingsHelperText((pre) => {
														pre.sustenancePaymentMethod = "";
														return { ...pre };
													});
													setProjectData((pre) => {
														pre[0].paymentModes = pre[0]?.paymentModes ? pre[0]?.paymentModes : [];
														if (pre[0]?.paymentModes?.includes("Razorpay")) {
															pre[0]?.paymentModes?.splice(
																pre[0]?.paymentModes?.findIndex((e) => e === "Razorpay"),
																1
															);
														} else {
															// console.log('Razor pay', pre[0].paymentModes.push("Razorpay"))
															pre[0]?.paymentModes?.push("Razorpay");
														}
														return [...pre];
													});
												}}
												checked={ProjectData[0]?.paymentModes?.includes("Razorpay") ? true : false}
											/>
											<span className={cssClasses.checkmark}></span>
										</label>
									</div>
									<p className={cssClasses.toggleLabel}>Razorpay</p>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "stretch",
									}}
								>
									<div>
										<label className={cssClasses.container}>
											<input
												className={cssClasses.checkbox}
												type="checkbox"
												name=""
												id=""
												onChange={(e) => {
													setSettingsHelperText((pre) => {
														pre.sustenancePaymentMethod = "";
														return { ...pre };
													});
													setProjectData((pre) => {
														pre[0].paymentModes = pre[0]?.paymentModes ? pre[0].paymentModes : [];
														if (pre[0]?.paymentModes?.includes("Cheque")) {
															pre[0]?.paymentModes?.splice(
																pre[0]?.paymentModes?.findIndex((e) => e === "Cheque"),
																1
															);
															if (
																!pre[0]?.paymentModes?.includes("Cheque") &&
																!pre[0]?.paymentModes?.includes("Card")
															) {
																pre[0].minOnlineAmt = 0;
															}
														} else {
															pre[0]?.paymentModes.push("Cheque");
															if (!pre[0]?.paymentModes?.includes("Razorpay")) {
																pre[0]?.paymentModes.push("Razorpay");
															}
														}
														return [...pre];
													});
												}}
												checked={ProjectData[0]?.paymentModes?.includes("Cheque") ? true : false}
											/>
											<span className={cssClasses.checkmark}></span>
										</label>
									</div>
									<p className={cssClasses.toggleLabel}>Cheque</p>
								</div>
								{ProjectData[0]?.paymentModes?.includes("Cheque") && (
									<div>
										<CustomInput
											value={ProjectData[0]?.minOnlineAmt}
											inputType={"number"}
											placeholder={"Enter minimum online payment amount"}
											handleChange={(e) => {
												setSettingsHelperText((pre) => {
													pre.sustenancePaymentMethod = "";
													return { ...pre };
												});
												setProjectData((pre) => {
													pre[0].minOnlineAmt = e;
													return [...pre];
												});
											}}
										/>
									</div>
								)}
							</div>
						</div>
						<FormHelperText
							sx={{
								fontSize: "1.4rem !important",
								fontFamily: "Inter-Medium !important",
								lineHeight: "1.8rem !important",
								color: "#d32f2f",
							}}
						>
							{settingsHelperText?.sustenancePaymentMethod}
						</FormHelperText>
						<div>
							<div
								style={{
									fontFamily: "Inter-Medium",
									fontSize: "1.6rem",
									lineHeight: "2rem",
								}}
							>
								PAN Verification:
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "2rem",
									marginTop: "1rem",
								}}
							>
								<p className={cssClasses.toggleLabel}>For Site Visit:</p>
								<CustomSwitch
									checked={ProjectData[0]?.panVerificationForSiteVisit}
									onChange={(event) => {
										setProjectData((pre) => {
											pre[0].panVerificationForSiteVisit = event.target.checked;
											return [...pre];
										});
									}}
								/>
							</div>
						</div>
						<div>
							<div
								style={{
									fontFamily: "Inter-Medium",
									fontSize: "1.6rem",
									lineHeight: "2rem",
									marginTop: "2rem",
								}}
							>
								Select Project Bank:
							</div>
							<div
								style={{
									width: "80%",
									marginTop: "1rem",
								}}
							>
								{/* <p className={cssClasses.toggleLabel}>OCR Bank :</p> */}
								{!ProjectData[0]?.salesParentProjectId && <DropDown
									disable={ProjectData[0]?.OCRLedger ? true : false}
									list={projectBanks}
									mandatory={true}
									label={"VJ OCR Bank"}
									placeHolder={"VJ OCR Bank"}
									selectedValue={ProjectData[0]?.OCRBank?.BankAccountNo}
									onChangeSelect={(e) => {
										console.log(e);
										setProjectData((prev) => {
											prev[0].OCRBank = projectBanks?.find((ele) => ele?.BankAccountNo === e);
											return [...prev];
										});
									}}
								/>}
							</div>
							<div
								style={{
									width: "80%",
									marginTop: "2rem",
									marginBottom: "1rem",
								}}
							>
								{/* <p className={cssClasses.toggleLabel}>OCR Bank :</p> */}
								{!ProjectData[0]?.salesParentProjectId && <DropDown
									disable={ProjectData[0]?.GSTLedger ? true : false}
									list={projectBanks}
									mandatory={true}
									label={"VJ GST Bank"}
									placeHolder={"VJ GST Bank"}
									selectedValue={ProjectData[0]?.GSTBank?.BankAccountNo}
									onChangeSelect={(e) => {
										console.log(e);
										setProjectData((prev) => {
											prev[0].GSTBank = projectBanks?.find((ele) => ele?.BankAccountNo === e);
											return [...prev];
										});
									}}
								/>}
							</div>
							{/* JD bank fields only for JD projects */}
							{ProjectData[0]?.isVJ === false && (<>
							<div
								style={{
									width: "80%",
									marginTop: "1rem",
								}}
							>
								{/* <p className={cssClasses.toggleLabel}>OCR Bank :</p> */}
								<DropDown
									disable={ProjectData[0].OCRLedgerJd ? true : false}
									list={projectJdBanks}
									mandatory={true}
									label={"JD OCR Bank"}
									placeHolder={"JD OCR Bank"}
									selectedValue={ProjectData[0].OCRBankJd?.value ?? ""}
									onChangeSelect={(e) => {
										console.log(e);
										setProjectData((pre) => {
											pre[0].OCRBankJd = projectJdBanks.find((ele) => {
												return ele.value === e;
											});
											return [...pre];
										});
									}}
								/>
							</div>
							<div
								style={{
									width: "80%",
									marginTop: "2rem",
									marginBottom: "1rem",
								}}
							>
								{/* <p className={cssClasses.toggleLabel}>OCR Bank :</p> */}
								<DropDown
									disable={ProjectData[0].GSTLedgerJd ? true : false}
									list={projectJdBanks}
									mandatory={true}
									label={"JD GST Bank"}
									placeHolder={"JD GST Bank"}
									selectedValue={ProjectData[0].GSTBankJd?.value ?? ""}
									onChangeSelect={(e) => {
										console.log(e);
										setProjectData((pre) => {
											pre[0].GSTBankJd = projectJdBanks.find((ele) => {
												return ele.value === e;
											});
											return [...pre];
										});
									}}
								/>
							</div>
							</>)}
						</div>
						<div className={cssClasses.mainTabPanelWrapper}>
							<div style={{ paddingBottom: "2rem" }} className={cssClasses.header}>
								<p
									style={{
										fontFamily: "Inter-Medium",
										fontSize: "1.6rem",
										lineHeight: "2rem",
										marginTop: "3rem",
									}}
								>
									Live Inventory Display Config:
								</p>
							</div>
							<div
								style={{
									paddingBottom: "2rem",
									borderBottom: "1px solid #DADCE0",
								}}
							>
								{ProjectData[0]?.unitTypeDisplay?.map((m, i) => {
									console.log("m => ", m);
									return (
										<div>
											<div
												style={{
													display: "flex",
													flexDirection: "row",
													gap: "2rem",
													alignItems: "center",
												}}
											>
												<div
													style={{
														display: "flex",
														flexDirection: "row",
														gap: "2rem",
														alignItems: "center",
													}}
												>
													<p
														style={{
															fontFamily: "Inter-Medium",
															fontSize: "1.6rem",
															lineHeight: "2rem",
														}}
														className={cssClasses.toggleLabel1}
													>
														{m.unitType}
													</p>
												</div>
												<div
													style={{
														display: "flex",
														flexDirection: "row",
														gap: "2rem",
														alignItems: "center",
													}}
												>
													<p className={cssClasses.toggleLabel}>Display:</p>
													<CustomToggle
														checked={ProjectData[0]?.unitTypeDisplay[i]?.display}
														setChecked={() => {
															setProjectData((pre) => {
																if (pre[0]?.unitTypeDisplay[i]?.display) {
																	pre[0].unitTypeDisplay[i].color = "";
																}
																pre[0].unitTypeDisplay[i].display = !pre[0]?.unitTypeDisplay[i]?.display;
																return { ...pre };
															});
														}}
													/>
												</div>
											</div>

											<div style={{ paddingTop: "2rem", marginLeft: "2rem" }}>
												{m?.unitStatusDisplay?.map((p, index) => (
													<div
														style={{
															display: "flex",

															gap: "3rem",
															marginBottom: "2rem",
															alignItems: "center",
														}}
													>
														<div
															style={{
																display: "flex",
																alignItems: "center",
																gap: "2rem",
															}}
														>
															{/* <p className={cssClasses.toggleLabel}>Unit Status:</p> */}
															<p style={{ fontFamily: "Inter-Medium" }} className={cssClasses.toggleLabel}>
																{p.unitStatus}
															</p>
														</div>
														<div
															style={{
																display: "flex",
																gap: "2rem",
																alignItems: "center",
															}}
														>
															<p className={cssClasses.toggleLabel}>Display:</p>
															<CustomToggle
																checked={m?.unitStatusDisplay[index].display}
																setChecked={() => {
																	setProjectData((pre) => {
																		pre[0].unitTypeDisplay[i].unitStatusDisplay[index].display =
																			!pre[0]?.unitTypeDisplay[i]?.unitStatusDisplay[index]?.display;
																		return { ...pre };
																	});
																}}
															/>
														</div>
														{m?.unitStatusDisplay[index].display && (
															<>
																<div
																	style={{
																		display: "flex",
																		gap: "2rem",
																		alignItems: "center",
																	}}
																>
																	<p className={cssClasses.toggleLabel}>Color:</p>
																	<MuiColorInput
																		className={classes.inputStyle}
																		value={p.color}
																		onChange={(e) => {
																			setProjectData((pre) => {
																				pre[0].unitTypeDisplay[i].unitStatusDisplay[index].color = e;
																				return { ...pre };
																			});
																			console.log(
																				"m?.unitStatusDisplay[index].color",
																				m?.unitStatusDisplay[index].color
																			);
																		}}
																	/>
																</div>
																<div
																	style={{
																		display: "flex",
																		gap: "2rem",
																		alignItems: "center",
																	}}
																>
																	<p className={cssClasses.toggleLabel}> Text Color:</p>
																	<MuiColorInput
																		className={classes.inputStyle}
																		value={p?.textColor}
																		onChange={(e) => {
																			setProjectData((pre) => {
																				pre[0].unitTypeDisplay[i].unitStatusDisplay[index].textColor = e;
																				return { ...pre };
																			});
																		}}
																	/>
																</div>
															</>
														)}
													</div>
												))}
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
					<div>
						<div>
							<Button
								style={{
									fontSize: "1.6rem",
									lineHeight: "2.4rem",
									color: "#FFF",
									backgroundColor: "#155EEF",
									borderRadius: "0.8rem",
								}}
								padding={"0.8rem 2.6rem"}
								btnName={"Save Changes"}
								// btnIcon={<PlusIcon />}
								// iconPosition={'left'}
								disable={
									settingsHelperText.shortCode !== ""
									// ||
									// settingsHelperText.ocr !== '' ||
									// settingsHelperText.gst !== '' ||
									// settingsHelperText.sdr !== ''
								}
								clicked={saveProjectSettings}
							/>
						</div>
					</div>
				</div>
			)}

			{tabValue === "Booking Configuration" && (
				<Fragment>
					<Box className={cssClasses.SubContainer}>
						<Box className={cssClasses.DivContainer}>
							<Box className={cssClasses.ProjectTitle}> Booking Configuration List</Box>
						</Box>
					</Box>

					<Box height={"100%"} overflow={"auto"}>
						{NoBookingInventoryFound === false && (
							<Box className={cssClasses.MainDiv}>
								<Box className={cssClasses.FlexRow22}>
									{uniqBy(BookingAmountDetails, "wingId")?.map((el, index) => (
										<>
											<Box className={cssClasses.flexColumn}>
												<Box className={cssClasses.Title}>
													{/* Wing Name - {el.wingName} */}
													Wing Name - {el.displayName ? el.displayName : el.wingName}
												</Box>
												<Divider />
												{el?.typeOptions?.map((elm, typeIndex) => (
													<Box className={cssClasses.FlexRow22} mt={2}>
														<Box width={"25rem"}>
															<CustomInput
																disabled={true}
																label={"Unit Type"}
																placeholder={elm.UnitTypeName}
																inputType={"number"}
															/>
														</Box>
														<Box>
															<CustomInput
																handleChange={(value) => {
																	setBookingAmountDetails((pre) => {
																		pre[index].typeOptions[typeIndex].ocrValue = parseInt(value);
																		return [...pre];
																	});

																	if (value !== "") {
																		setBookingAmountDetails((pre) => {
																			pre[index].typeOptions[typeIndex].TotalValue =
																				(parseInt(elm.sdrValue) ? parseInt(elm.sdrValue) : 0) +
																				parseInt(value) +
																				(parseInt(elm.gstValue) ? parseInt(elm.gstValue) : 0);
																			console.log("pre", pre);
																			return { ...pre };
																		});
																	} else {
																		setBookingAmountDetails((pre) => {
																			pre[index].typeOptions[typeIndex].TotalValue = 0;
																			return { ...pre };
																		});
																	}
																	console.log("book1", BookingAmountDetails);
																	setBookingAmountDetails([...BookingAmountDetails]);
																}}
																label={"OCR"}
																value={elm?.ocrValue}
																placeholder={"OCR"}
																inputType={"number"}
																// helperText={settingsHelperText.ocr}
																mandatory={true}
															/>
														</Box>

														<Box>
															<CustomInput
																handleChange={(value) => {
																	setBookingAmountDetails((pre) => {
																		pre[index].typeOptions[typeIndex].gstValue = parseInt(value);
																		return [...pre];
																	});

																	if (value !== "") {
																		setBookingAmountDetails((pre) => {
																			pre[index].typeOptions[typeIndex].TotalValue =
																				(parseFloat(elm.sdrValue) ? parseFloat(elm.sdrValue) : 0) +
																				parseFloat(value) +
																				(parseFloat(elm.ocrValue) ? parseFloat(elm.ocrValue) : 0);
																			console.log("pre", pre);
																			return { ...pre };
																		});
																	} else {
																		setBookingAmountDetails((pre) => {
																			pre[index].typeOptions[typeIndex].TotalValue = 0;
																			return { ...pre };
																		});
																	}
																	console.log("book2", BookingAmountDetails);
																	setBookingAmountDetails([...BookingAmountDetails]);
																}}
																label={"GST"}
																value={elm?.gstValue}
																placeholder={"GST"}
																inputType={"number"}
																mandatory={true}
															// helperText={settingsHelperText.gst}
															/>
														</Box>

														<Box>
															<CustomInput
																handleChange={(value) => {
																	setBookingAmountDetails((pre) => {
																		pre[index].typeOptions[typeIndex].sdrValue = parseInt(value);
																		return { ...pre };
																	});
																	if (value !== "") {
																		setBookingAmountDetails((pre) => {
																			pre[index].typeOptions[typeIndex].TotalValue =
																				(parseFloat(elm.ocrValue) ? parseFloat(elm.ocrValue) : 0) +
																				parseFloat(value) +
																				(parseFloat(elm.gstValue) ? parseFloat(elm.gstValue) : 0);
																			return { ...pre };
																		});
																	} else {
																		setBookingAmountDetails((pre) => {
																			pre[index].typeOptions[typeIndex].TotalValue = 0;
																			return { ...pre };
																		});
																	}
																	setBookingAmountDetails([...BookingAmountDetails]);
																}}
																label={"SDR"}
																mandatory={true}
																value={elm.sdrValue}
																placeholder={"SDR"}
																inputType={"number"}
															// helperText={settingsHelperText.sdr}
															/>
														</Box>

														<Box>
															<CustomInput
																label={"Total"}
																disabled={true}
																value={elm.TotalValue}
																placeholder={"Total"}
																inputType={"number"}
																mandatory={true}
															/>
														</Box>
													</Box>
												))}
											</Box>
										</>
									))}
								</Box>
							</Box>
						)}

						{NoBookingInventoryFound === true && (
							<Box mt={4}>
								<Box className={cssClasses.noDataMsg}>
									<Box className={cssClasses.emptyIcon}>
										<img src={LaunchesIcon} alt="No Wings" />
									</Box>
									<Box className={cssClasses.emptyTitle}>No Wings or Unit Type to show as Inventory Not selected</Box>
								</Box>
							</Box>
						)}
					</Box>

					{NoBookingInventoryFound === false && (
						<Box width={"fit-Content"} ml={"auto"} mt={"auto"}>
							<Button
								style={{
									fontSize: "1.6rem",
									lineHeight: "2.4rem",
									color: "#FFF",
									backgroundColor: "#155EEF",
									borderRadius: "0.8rem",
								}}
								padding={"0.8rem 2.6rem"}
								btnName={"Save Changes"}
								// btnIcon={<PlusIcon />}
								// iconPosition={'left'}
								// disable={}
								clicked={SaveBookingAmountValues}
							/>
						</Box>
					)}
				</Fragment>
			)}
			{tabValue === "Additional Configuration" && <AdditionalConfiguration projectId={projectId} />}
			{tabValue === "Wing Settings" && (
				<Fragment>
					<Box className={cssClasses.SubContainer}>
						<Box className={cssClasses.DivContainer}>
							<Box className={cssClasses.ProjectTitle}> Wing Settings</Box>
						</Box>
					</Box>

					<Box height={"100%"} overflow={"auto"}>
						<WingSettings
							allWings={ProjectData?.[0]?.isVJ === false ? jdWingSettingsWings : AllWings}
							getWings={getProjectDetails}
						/>
					</Box>
				</Fragment>
			)}
			{tabValue === "Digital Cost-Sheet" && (
				<Fragment>
					<Box className={cssClasses.SubContainer}>
						<Box className={cssClasses.DivContainer}>
							<Box className={cssClasses.ProjectTitle}> Digital Cost-Sheet</Box>
						</Box>
					</Box>

					<Box height={"100%"} overflow={"auto"}>
						<DigitalCostSheet projectData={ProjectData} />
					</Box>
				</Fragment>
			)}
			{tabValue === "Email Template" && <EmailTemplate projectId={projectId} />}
			{tabValue === "Deemed Cancellation Config" && (
				<DeemedCancellationConfigSection projectId={projectId} allWings={AllWings} />
			)}
			{tabValue === "Template Mapping" && <TemplateMapping projectId={projectId} />}
			{tabValue === "JD Projects" && (
				<Box padding={"2rem"} maxWidth={"60rem"}>
					<Box sx={{ fontFamily: "Inter-Medium", fontSize: "1.6rem", fontWeight: 600, marginBottom: "1.5rem", color: "#101828" }}>
						JD Projects
					</Box>

					{/* Search */}
					<input
						placeholder="Search by project name or BU ID"
						value={jdSearchText}
						onChange={(e) => {
							const val = e.target.value;
							setJdSearchText(val);
							setJdBURows(
								val === ""
									? jdBURowsAll
									: jdBURowsAll.filter((r) =>
										r.projectName?.toLowerCase().includes(val.toLowerCase()) ||
										r.buId?.toString().includes(val)
									)
							);
						}}
						style={{
							width: "100%", padding: "0.8rem 1.2rem", fontSize: "1.4rem",
							border: "1px solid #D0D5DD", borderRadius: "0.8rem",
							fontFamily: "Inter-Regular", marginBottom: "1.2rem",
							outline: "none", boxSizing: "border-box",
						}}
					/>

					{/* Unified list */}
					<Box sx={{ border: "1px solid #EAECF0", borderRadius: "0.8rem", overflow: "hidden", marginBottom: "1.5rem" }}>
						{jdBURows.length === 0 ? (
							<Box sx={{ padding: "2rem", textAlign: "center", color: "#667085", fontSize: "1.3rem", fontFamily: "Inter-Regular" }}>
								No JD BUs found for this project
							</Box>
						) : (
							jdBURows.map((row) => {
								const isLinked = jdProjects.some((p) => p.buId === row.buId);
								return (
									<Box
										key={row.buId}
										onClick={() => { if (!isLinked) setSelectedJdBu(row); }}
										sx={{
											display: "flex", alignItems: "center", gap: "1.2rem",
											padding: "1.2rem 1.6rem", cursor: isLinked ? "default" : "pointer",
											borderBottom: "1px solid #EAECF0",
											background: isLinked ? "#F9FAFB" : selectedJdBu?.buId === row.buId ? "#F0F9FF" : "#fff",
											"&:last-child": { borderBottom: "none" },
											"&:hover": { background: isLinked ? "#F9FAFB" : selectedJdBu?.buId === row.buId ? "#F0F9FF" : "#F9FAFB" },
										}}
									>
										<Radio
											checked={isLinked || selectedJdBu?.buId === row.buId}
											disabled={isLinked}
											onChange={() => { if (!isLinked) setSelectedJdBu(row); }}
											size="small"
											sx={{ padding: 0 }}
										/>
										<Box flex={1}>
											<Box sx={{ fontFamily: "Inter-Medium", fontSize: "1.4rem", color: isLinked ? "#667085" : "#101828" }}>
												{row.projectName}
											</Box>
											<Box sx={{ fontFamily: "Inter-Regular", fontSize: "1.2rem", color: "#667085" }}>
												BU ID: {row.buId}&nbsp;|&nbsp;{row.city}
											</Box>
										</Box>
										{isLinked && (
											<Box sx={{ fontSize: "1.2rem", fontFamily: "Inter-Medium", color: "#027A48", background: "#ECFDF3", borderRadius: "1.6rem", padding: "0.2rem 1rem" }}>
												Linked
											</Box>
										)}
									</Box>
								);
							})
						)}
					</Box>

					<Box display={"flex"} justifyContent={"flex-end"}>
						<Button
							style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
							clicked={saveJdProject}
							btnName={"Save"}
							disable={!selectedJdBu}
						/>
					</Box>

					{/* Bank config for each linked JD project */}
					{jdProjects.length > 0 && (
						<Box marginTop={"3rem"}>
							<Box sx={{ fontFamily: "Inter-Medium", fontSize: "1.5rem", fontWeight: 600, marginBottom: "1.5rem", color: "#101828" }}>
								Bank Configuration
							</Box>
							{jdProjects.map((jdProj) => {
								const banks = jdProj.banks ?? [];
								const sel = jdBankSelections[jdProj.projectId] ?? {};
								return (
									<Box key={jdProj.projectId} sx={{ border: "1px solid #EAECF0", borderRadius: "0.8rem", padding: "1.6rem", marginBottom: "1.2rem" }}>
										<Box sx={{ fontFamily: "Inter-Medium", fontSize: "1.4rem", color: "#101828", marginBottom: "0.4rem" }}>
											{jdProj.projectName}
										</Box>
										<Box sx={{ fontFamily: "Inter-Regular", fontSize: "1.2rem", color: "#667085", marginBottom: "1.4rem" }}>
											BU ID: {jdProj.buId} | Banks loaded: {jdProj.banks?.length ?? 0}
										</Box>

										{banks.length === 0 ? (
											<Box sx={{ fontSize: "1.3rem", color: "#B42318", fontFamily: "Inter-Regular" }}>
												Bank mapping not available for this BU
											</Box>
										) : (
											<Box display={"flex"} gap={"2rem"} flexWrap={"wrap"} alignItems={"flex-end"}>
												<Box flex={1} minWidth={"24rem"}>
													<DropDown
														label={"OCR Bank"}
														list={banks}
														selectedValue={sel.OCRBank?.value ?? ""}
														onChangeSelect={(val) => setJdBankSelections((prev) => ({
															...prev,
															[jdProj.projectId]: { ...prev[jdProj.projectId], OCRBank: banks.find((b) => b.value === val) ?? null },
														}))}
														disable={!!jdProj.OCRLedger}
													/>
												</Box>
												<Box flex={1} minWidth={"24rem"}>
													<DropDown
														label={"GST Bank"}
														list={banks}
														selectedValue={sel.GSTBank?.value ?? ""}
														onChangeSelect={(val) => setJdBankSelections((prev) => ({
															...prev,
															[jdProj.projectId]: { ...prev[jdProj.projectId], GSTBank: banks.find((b) => b.value === val) ?? null },
														}))}
														disable={!!jdProj.GSTLedger}
													/>
												</Box>
												<Box>
													<Button
														style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
														clicked={() => saveJdBankConfig(jdProj)}
														btnName={"Save Banks"}
														disable={!!jdProj.OCRLedger && !!jdProj.GSTLedger}
													/>
												</Box>
											</Box>
										)}

										{/* Ledger status */}
										<Box display={"flex"} gap={"1rem"} marginTop={"1rem"}>
											<Box sx={{ fontSize: "1.2rem", fontFamily: "Inter-Medium", color: jdProj.OCRLedger ? "#027A48" : "#B42318", background: jdProj.OCRLedger ? "#ECFDF3" : "#FEF3F2", borderRadius: "1.6rem", padding: "0.2rem 1rem" }}>
												OCR Ledger: {jdProj.OCRLedger ? "Created" : "Pending"}
											</Box>
											<Box sx={{ fontSize: "1.2rem", fontFamily: "Inter-Medium", color: jdProj.GSTLedger ? "#027A48" : "#B42318", background: jdProj.GSTLedger ? "#ECFDF3" : "#FEF3F2", borderRadius: "1.6rem", padding: "0.2rem 1rem" }}>
												GST Ledger: {jdProj.GSTLedger ? "Created" : "Pending"}
											</Box>
										</Box>
									</Box>
								);
							})}
						</Box>
					)}
				</Box>
			)}

			<ConfirmationAlert
				open={openConfirmationAlert}
				close={() => {
					setOpenConfirmationAlert(false);
				}}
				icon={<Info width={"4.8rem"} height={"4.8rem"} />}
				title={displayDeleteTitle}
				subTitle={displayDeleteSubTitle}
				confirm={(value) => {
					// console.log(value);
					if (value === "confirmed") {
						// console.log({ floorPlanData });
						let count = 0;
						let flag = false;
						floorPlanData.Inventory.forEach((el) => {
							count = count + 1;
							flag = true;
							updateInventoryForFloorPlans(projectId, floorPlanData.wingId, el.floorNo, null)
								.then((resp) => { })
								.catch((err) => {
									flag = false;
									console.log(err);
									if (err.message.includes('update or delete on table "FloorPlans" violates foreign key constraint')) {
										errorTost("This FloorPlans is already used in allotment.Cannot delete it now");
									} else {
										errorTost(err.message);
									}
								});
						});
						if (count === floorPlanData.Inventory.length && flag) {
							deleteUploadedImage(floorPlanData.floorPlanImgUrl)
								.then((resp) => {
									console.log(" delete image successfully", resp);
									deleteFloorPlan(floorPlanData.floorPlanId)
										.then((resp) => {
											console.log("floor plan deleted");
											successTost(`${floorPlanData.name} Floor Plan deleted successfully`);
											getAllFloorPlans();
										})
										.catch((err) => {
											console.log(err);
											errorTost("Error while deleting floor plan");
										});
								})
								.catch((err) => {
									console.log(err);
								});
						}
						setOpenConfirmationAlert(false);
					} else if (value === "rejected") {
						setOpenConfirmationAlert(false);
					}
				}}
				buttonTitle={"No"}
				returnRespButton={"Yes"}
			/>
		</Box>
	);
}

export default ProjectDetails;

function AdditionalConfiguration({ projectId }) {
	const [projectDetails, setProjectDetails] = useState(null);
	// const [wingsArray, setWingsArray] = useState([]);

	const [paymentPlans, setPaymentPlans] = useState(null);
	const [selectedPlan, setSelectedPlan] = useState("");
	const [NoAdditionalConfigFound, setNoAdditionalConfigFound] = useState(false);
	const [selectedWingIndex, setSelectedWingIndex] = useState(0);
	const [AdditionalConfigDetails, setAdditionalConfigDetails] = useState([
		{
			wingId: "",
			wingName: "",
			typeOptions: [
				{
					UnitTypeName: "",
					UnitTypeId: "",
					maintenanceAmount: "",
					mnglGasPipeInfraCharges: "",
					// legalCharges: "",
					// registrationCharges: "",
					paymentPlan: "",
					pageOneComment: "",
					// pageTwoComment:'',
					flag: false,
				},
			],
		},
	]);

	useEffect(() => {
		if (projectId) {
			setSelectedWingIndex(0);
			getProjectDetailsFromServer();
		}
	}, [projectId]);

	useEffect(() => {
	}, [AdditionalConfigDetails]);

	useEffect(() => {
		if (projectDetails && projectDetails?.buId) {
			getAllPlansByProjectFromServer();
		}
	}, [projectDetails]);

	function getProjectDetailsFromServer() {
		presentLoader();
		getProjectForPaymentPlan(projectId)
			.then((resp) => {
				if (resp) {
					setProjectDetails(resp);
					if (resp.Wings && resp.Wings.length > 0) {
						const inventoryFetch =
							resp.isVJ === false
								? getJdInventoryByProject(resp.buId)
								: getProjectInventory(projectId);

						inventoryFetch
							.then((rawInventory) => {
								let response44 = rawInventory;
								if (resp.isVJ === false) {
									response44 = rawInventory
										.map((item) => {
											const resolvedWing =
												resp.Wings?.find((w) => w.wingId === item.jdWingId) ||
												null;
											return {
												wingId: resolvedWing,
												unitId: {
													...item,
													wingId: resolvedWing,
													displayUnitType: item.displayUnitType ?? "",
													inventoryTypeId: item.inventoryTypeId ?? null,
												},
												projectId: item.projectId,
											};
										})
										.filter((item) => item.wingId !== null);
								}
								const Wings = uniqBy(response44, "wingId.wingId");
								const ForAdditionalConfig = groupBy(response44, "wingId.wingId");

								getAdditionalConfig(projectId)
									.then((response98) => {
										// FIXED (performance): building copyForAdditionalConfig only needs one pass
										// per wing — each wing's slice of the data is independent, so this loop is fine.
										let copyForAdditionalConfig = {};
										Object.keys(ForAdditionalConfig).forEach((ele, i) => {
											copyForAdditionalConfig[ele] = {
												wingId: ForAdditionalConfig[ele].find((e) => {
													return e.wingId.wingId === ele;
												}),
												DisplayUnitTypes: uniqBy(ForAdditionalConfig[ele], "unitId.displayUnitType"),
											};

											for (const myele of copyForAdditionalConfig[ele].DisplayUnitTypes) {
												let index = copyForAdditionalConfig[ele].DisplayUnitTypes.findIndex((e) => {
													return e.unitId.displayUnitType === myele.unitId.displayUnitType;
												});
												copyForAdditionalConfig[ele].DisplayUnitTypes[index].inventoryTypes = uniqBy(
													response44.filter((ele1) => {
														return (
															ele1.wingId.wingId ===
															copyForAdditionalConfig[ele].DisplayUnitTypes[index].wingId.wingId &&
															ele1.unitId.displayUnitType ===
															copyForAdditionalConfig[ele].DisplayUnitTypes[index].unitId.displayUnitType
														);
													}),
													"unitId.inventoryTypeId.inventoryTypeId"
												);
											}
										});

										// FIXED (performance): this whole block — regrouping response98 and building
										// the final per-wing list — used to be recomputed once PER WING inside the loop
										// above (redoing the same full-project work N times for N wings, and saving to
										// the screen N times too). It doesn't depend on any single wing, so it now runs
										// exactly once, after every wing's config has been gathered above.
										const AdditionalConfigObj = groupBy(response98, "wingId.wingId");
										Object.keys(AdditionalConfigObj).forEach((elem, i) => {
											AdditionalConfigObj[elem] = {
												wingId: AdditionalConfigObj[elem].find((e) => {
													return e.wingId.wingId === elem;
												}),
												DisplayUnitTypes: uniqBy(AdditionalConfigObj[elem], "displayUnitType"),
											};
											for (const ele_ of AdditionalConfigObj[elem].DisplayUnitTypes) {
												let index = AdditionalConfigObj[elem].DisplayUnitTypes.findIndex((e) => {
													return e.displayUnitType === ele_.displayUnitType;
												});
												AdditionalConfigObj[elem].DisplayUnitTypes[index].inventoryTypes = response98.filter(
													(element) => {
														return (
															element.wingId.wingId ===
															AdditionalConfigObj[elem].DisplayUnitTypes[index].wingId.wingId &&
															element.displayUnitType ===
															AdditionalConfigObj[elem].DisplayUnitTypes[index].displayUnitType
														);
													}
												);
											}
										});

											let FinalArr = [];
											const uniqueWings = [
												...new Set([Object.keys(AdditionalConfigObj), Object.keys(copyForAdditionalConfig)].flat()),
											];

											uniqueWings.forEach((uniqueWingKeyItem, i) => {
												let _ConfigObj = {
													wingId: uniqueWingKeyItem,
													wingName: "",
													typeOptions: [],
												};

												if (
													AdditionalConfigObj[uniqueWingKeyItem] &&
													AdditionalConfigObj[uniqueWingKeyItem]?.DisplayUnitTypes?.length > 0
												) {
													_ConfigObj.wingName = AdditionalConfigObj?.[uniqueWingKeyItem][i]?.wingId?.wingId?.wingName;
													AdditionalConfigObj?.[uniqueWingKeyItem].DisplayUnitTypes.forEach((_item1) => {
														_ConfigObj.typeOptions.push({
															DisplayUnitTypeName: _item1?.displayUnitType,
															AllInventoryTypes: _item1?.inventoryTypes,
															maintenanceAmount: _item1?.maintenanceAmount,
															mnglGasPipeInfraCharges: _item1?.mnglGasPipeInfraCharges,
															flag: _item1.id ? true : false,
															// legalCharges: _item1?.legalCharges,
															// registrationCharges: _item1?.registrationCharges,
															paymentPlan: _item1?.paymentPlan,
															pageOneComment: _item1?.pageOneComment,
														});
													});
												}

												if (
													copyForAdditionalConfig[uniqueWingKeyItem] &&
													copyForAdditionalConfig[uniqueWingKeyItem]?.DisplayUnitTypes?.length > 0
												) {
													_ConfigObj.wingName = copyForAdditionalConfig?.[uniqueWingKeyItem]?.wingId?.wingId?.wingName;
													copyForAdditionalConfig?.[uniqueWingKeyItem].DisplayUnitTypes?.forEach((_item2) => {
														if (
															!_ConfigObj.typeOptions.find(
																(tp) => tp.DisplayUnitTypeName === _item2?.unitId.displayUnitType
															)?.flag
														) {
															_ConfigObj.typeOptions.push({
																DisplayUnitTypeName: _item2?.unitId
																	.displayUnitType
																	? _item2?.unitId.displayUnitType
																	: _item2?.unitId?.inventoryTypeId?.type,
																AllInventoryTypes: _item2?.inventoryTypes,
																maintenanceAmount: "",
																mnglGasPipeInfraCharges: "",
																// legalCharges: "",
																// registrationCharges: "",
																paymentPlan: "",
																pageOneComment: "",
															});
														}
													});
												}
												FinalArr.push(_ConfigObj);
											});
											const FilterArr = FinalArr.filter((f) => f.wingName);
											setAdditionalConfigDetails(FilterArr);
											dismissLoader();

										if (Object.keys(ForAdditionalConfig).length === 0) {
											setNoAdditionalConfigFound(true);
											dismissLoader();
										}
									})
									.catch((err) => {
										console.error("Additional-Config-err", err);
										dismissLoader();
									});
							})
							.catch((err) => {
								console.log("getProjectInventory", err);
								dismissLoader();
							});
					}
				}
				dismissLoader();
			})
			.catch((err) => {
				console.error("project-details-err", err);
				dismissLoader();
			});
	}

	async function getAllPlansByProjectFromServer() {
		try {
			presentLoader();
			const baseUrl = projectDetails?.isVJ === false
				? process.env.REACT_APP_JDPROJECTS_URL
				: process.env.REACT_APP_PROJECTS_URL;
			const getAllPlansByProjectResponse = await axios.get(
				`${baseUrl}paymentPlan?buId=${projectDetails?.buId}`
			);
			if (getAllPlansByProjectResponse?.data && getAllPlansByProjectResponse?.data?.result) {
				setPaymentPlans([...getAllPlansByProjectResponse.data.result]);
				dismissLoader();
			} else {
				throw getAllPlansByProjectResponse;
			}
		} catch (error) {
			console.log("getAllPlansByProjectResponse error => ", error);
			if (error?.error?.message) {
				errorTost(error?.error?.message);
			} else {
				errorTost("Something went wrong! Try again");
			}
			dismissLoader();
		}
	}

	async function updateAdditionsValues() {
		// Saves only the wing currently open in the sub-tab, not every wing in the project.
		let allAdditionalConfig = [];
		const wingsToSave = uniqBy(AdditionalConfigDetails, "wingId").filter(
			(_, i) => i === selectedWingIndex,
		);
		wingsToSave.forEach((wing, i) => {
			wing.typeOptions.forEach((displayUnitType, index) => {
				displayUnitType.AllInventoryTypes.forEach((unitType, typeIndex) => {
					let ConfigObj = {
						projectId: projectId,
						wingId: wing?.wingId,
						displayUnitType: displayUnitType.DisplayUnitTypeName,
						inventoryTypeId: displayUnitType.flag
							? unitType.inventoryTypeId.inventoryTypeId
							: unitType.unitId.inventoryTypeId.inventoryTypeId,
						maintenanceAmount: displayUnitType.maintenanceAmount,
						// legalCharges: displayUnitType.legalCharges,
						// registrationCharges: displayUnitType.registrationCharges,
						mnglGasPipeInfraCharges: displayUnitType.mnglGasPipeInfraCharges,
						paymentPlan: displayUnitType.paymentPlan,
						pageOneComment: displayUnitType.pageOneComment,
					};
					allAdditionalConfig.push(ConfigObj);
				});
			});
		});

		for (let index = 0; index < allAdditionalConfig.length; index++) {
			const element = allAdditionalConfig[index];
			CheckAdditionalConfig(element.projectId, element.wingId, element.displayUnitType, element.inventoryTypeId)
				.then((response99) => {
					if (response99?.length === 0) {
						if (
							element.maintenanceAmount !== "" &&
							!isNaN(parseFloat(element.maintenanceAmount)) &&
							// element.legalCharges !== "" &&
							// !isNaN(parseFloat(element.legalCharges)) &&
							// element.registrationCharges !== "" &&
							// !isNaN(parseFloat(element.registrationCharges)) &&
							element.mnglGasPipeInfraCharges !== "" &&
							!isNaN(parseFloat(element.mnglGasPipeInfraCharges)) &&
							element.paymentPlan !== "" &&
							element.pageOneComment !== ""
						) {
							addAdditionalConfig(element)
								.then((res) => {
									console.log("added successfully", res);
									if (index === allAdditionalConfig.length - 1) {
										successTost("Additional Configuration added successfully!");
										getProjectDetailsFromServer();
									}
								})
								.catch((err) => {
									console.error("err-adding-to-table-of-additional-config", err);
								});
						} else if (
							element.maintenanceAmount === "" ||
							// element.legalCharges === "" ||
							// element.registrationCharges === "" ||
							element.mnglGasPipeInfraCharges === "" ||
							element.paymentPlan === "" ||
							element.pageOneComment === ""
						) {
							if (index === allAdditionalConfig.length - 1) {
								errorTost("All Fields are mandatory! Please fill all the fields!");
							}
						} else if (
							isNaN(parseFloat(element.maintenanceAmount)) ||
							// isNaN(parseFloat(element.legalCharges)) ||
							// isNaN(parseFloat(element.registrationCharges)) ||
							isNaN(parseFloat(element.mnglGasPipeInfraCharges)) ||
							element.paymentPlan === "" ||
							element.pageOneComment === ""
						) {
							if (index === allAdditionalConfig.length - 1) {
								errorTost("All Fields are mandatory! Please fill all the fields!");
							}
						}
					} else {
						UpdateAdditionalConfig(element.projectId, element.wingId, element.displayUnitType, element.inventoryTypeId, element)
							.then((response78) => {
								console.log("Updated-values", response78);
								if (index === allAdditionalConfig.length - 1) {
									successTost("Additional Configuration updated successfully");
									getProjectDetailsFromServer();
								}
							})
							.catch((err) => {
								console.error("err-for-updating-Additional-config", err);
							});
					}
				})
				.catch((err) => {
					console.error("err-for-checking", err);
				});
		}
	}

	return (
		<Fragment>
			<Box className={cssClasses.SubContainer}>
				<Box className={cssClasses.DivContainer}>
					<Box className={cssClasses.ProjectTitle}>Welcome PDF Configuration</Box>
				</Box>
			</Box>

			{!NoAdditionalConfigFound && uniqBy(AdditionalConfigDetails, "wingId").length > 1 && (
				<Box margin={"2rem 0 0"}>
					<Tabs
						value={selectedWingIndex}
						onChange={(event, newValue) => setSelectedWingIndex(newValue)}
						variant="scrollable"
						scrollButtons="auto"
						aria-label="wing selection tabs"
						sx={[
							{
								borderBottom: "1px solid #EAECF0 !important",
							},
						]}
					>
						{uniqBy(AdditionalConfigDetails, "wingId").map((wingItem, index) => (
							<Tab
								key={wingItem.wingId}
								label={wingItem.displayName ? wingItem.displayName : wingItem.wingName}
								sx={{ fontSize: "1.6rem", fontFamily: "Inter-Medium" }}
							/>
						))}
					</Tabs>
				</Box>
			)}

			<Box height={"100%"} overflow={"auto"}>
				<Box className={cssClasses.MainDiv} flexDirection={"column !important"}>
					<Box className={cssClasses.FlexRow22} flexDirection={"column !important"}>
						{!NoAdditionalConfigFound && (
							<>
								{uniqBy(AdditionalConfigDetails, "wingId")?.map((wingItem, index) =>
									index !== selectedWingIndex ? null : (
									<Box className={cssClasses.flexColumn} flex={1}>
										{wingItem?.typeOptions?.map((ele, typeIndex) => (
											<>
												<Box className={cssClasses.FlexRow22} mb={2} mt={2}>
													<Box width={"25rem"}>
														<Box>
															<CustomInput
																disabled={true}
																label={"Unit Type"}
																placeholder={ele.DisplayUnitTypeName}
																inputType={"number"}
															/>
														</Box>
														<p
															style={{
																color: "red",
																fontSize: "1.2rem",
																marginTop: "0.5rem",
															}}
														>
															{ele?.DisplayUnitTypeName === null || undefined || "" ? "Unit type cannot be empty" : ""}
														</p>
													</Box>

													<Box width={"27rem"}>
														<CustomInput
															handleChange={(value) => {
																setAdditionalConfigDetails((pre) => {
																	pre[index].typeOptions[typeIndex].maintenanceAmount = parseInt(value);
																	return [...pre];
																});
																setAdditionalConfigDetails([...AdditionalConfigDetails]);
															}}
															label={"Maintenance Amount"}
															value={ele.maintenanceAmount}
															placeholder={"Enter maintenance amount"}
															inputType={"number"}
															mandatory={true}
														/>
													</Box>
													{/* <Box width={"25rem"}>
														<CustomInput
															handleChange={(value) => {
																setAdditionalConfigDetails((pre) => {
																	pre[index].typeOptions[typeIndex].legalCharges = parseInt(value);
																	return [...pre];
																});
																setAdditionalConfigDetails([...AdditionalConfigDetails]);
															}}
															label={"Legal Charges"}
															value={ele.legalCharges}
															placeholder={"Enter legal charges"}
															inputType={"number"}
															mandatory={true}
														/>
													</Box> */}
													{/* <Box width={"26rem"}>
														<CustomInput
															handleChange={(value) => {
																setAdditionalConfigDetails((pre) => {
																	pre[index].typeOptions[typeIndex].registrationCharges = parseInt(value);
																	return [...pre];
																});
																setAdditionalConfigDetails([...AdditionalConfigDetails]);
															}}
															label={"Registration Charges"}
															value={ele.registrationCharges}
															placeholder={"Enter registration charges"}
															inputType={"number"}
															mandatory={true}
														/>
													</Box> */}
													<Box width={"35rem"}>
														<CustomInput
															handleChange={(value) => {
																setAdditionalConfigDetails((pre) => {
																	pre[index].typeOptions[typeIndex].mnglGasPipeInfraCharges = parseInt(value);
																	return [...pre];
																});
																setAdditionalConfigDetails([...AdditionalConfigDetails]);
															}}
															label={"MNGL Gas Pipe Infra Charges"}
															value={ele?.mnglGasPipeInfraCharges}
															placeholder={"Enter MNGL gas pipe infra charges"}
															inputType={"number"}
															mandatory={true}
														/>
													</Box>
													<Box className={cssClasses.additionalInputContainer}>
														<Typography sx={{ ...labelStyle }}>
															{" "}
															Payment plan <span style={{ color: "red" }}>*</span>{" "}
														</Typography>

														<DropDown
															list={
																paymentPlans
																	? paymentPlans?.map((m) => ({
																		label: m?.Description,
																		value: m?.Id,
																	}))
																	: [{ label: "Select Plan", value: "" }]
															}
															selectedValue={ele.paymentPlan?.Id || ""}
															onChangeSelect={(_value_id) => {
																let _paymentPlan = paymentPlans.find((f) => f.Id === _value_id);
																console.log("_paymentPlan => ", _paymentPlan);

																if (_value_id) {
																	setAdditionalConfigDetails((pre) => {
																		pre[index].typeOptions[typeIndex].paymentPlan = _paymentPlan;
																		return [...pre];
																	});
																	setAdditionalConfigDetails([...AdditionalConfigDetails]);
																}
															}}
															disable={paymentPlans?.length === 0}

														//  helperText={ele?.paymentPlanHelperText}
														/>
														{paymentPlans?.length === 0 && (
															<div style={{ marginTop: '0.5rem' }}>
																{' '}
																<span
																	style={{ color: 'red', fontSize: '1.2rem' }}
																>
																	Payment plans list is not available. Hence
																	this configuration cannot be added.
																</span>
															</div>
														)}
													</Box>

													<Box className={cssClasses.additionalInputContainer} flex={"100% !important"}>
														<Typography sx={{ ...labelStyle }}>
															{" "}
															Instructions and T&C <span style={{ color: "red" }}>*</span>
														</Typography>
														<CKEditor
															editor={ClassicEditor}
															className={cssClasses.ck}
															config={{
																// plugins: ['Table', 'Heading', 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
																toolbar: [
																	"paragraph",
																	"heading1",
																	"heading2",
																	"heading3",
																	"heading4",
																	"heading5",
																	"heading6",
																	"alignment",
																	"heading",
																	"|",
																	"bold",
																	"italic",
																	"link",
																	"bulletedList",
																	"numberedList",
																	"blockQuote",
																	"undo",
																	"redo",
																	"Table",
																	"TableProperties",
																],
															}}
															data={ele.pageOneComment}
															onReady={(editor) => {
																// You can store the "editor" and use when it is needed.
															}}
															onChange={(event, editor) => {
																const data = editor.getData();
																if (data !== "") {
																	setAdditionalConfigDetails((pre) => {
																		pre[index].typeOptions[typeIndex].pageOneComment = data;
																		return [...pre];
																	});
																}
															}}
															onBlur={(event, editor) => {
																// console.log("Blur.", editor);
															}}
															onFocus={(event, editor) => {
																// console.log("Focus.", editor);
															}}
														/>
														{/* { } */}
													</Box>
												</Box>
												<Divider />
											</>
										))}
									</Box>
								))}
							</>
						)}

						{NoAdditionalConfigFound && (
							<Box>
								<Box className={cssClasses.noDataMsg}>
									<Box className={cssClasses.emptyIcon}>
										<img src={LaunchesIcon} alt="No Wings" />
									</Box>
									<Box className={cssClasses.emptyTitle}>No Wings Found.</Box>
								</Box>
							</Box>
						)}
					</Box>
				</Box>
			</Box>

			{!NoAdditionalConfigFound && (
				<Box width={"fit-Content"} ml={"auto"} mt={"auto"}>
					<Button
						style={{
							fontSize: "1.6rem",
							lineHeight: "2.4rem",
							color: "#FFF",
							backgroundColor: "#155EEF",
							borderRadius: "0.8rem",
						}}
						padding={"0.8rem 2.6rem"}
						btnName={"Save Changes"}
						// btnIcon={<PlusIcon />}
						// iconPosition={'left'}
						// disable={
						//   !AdditionalConfigDetails?.some(o1 => {
						//     let o2 = projectDetails?.Wings?.find(f => f.wingId === o1.wingId);
						//     return !Boolean(o1.maintenanceAmount === o2.maintenanceAmount &&
						//         o1.mnglGasPipeInfraCharges === o2.mnglGasPipeInfraCharges &&
						//         o1.legalCharges === o2.legalCharges &&
						//         o1.registrationCharges === o2.registrationCharges &&
						//         o1?.paymentPlan?.Id === o2?.paymentPlan?.Id &&
						//         o1.pageOneComment === o2.pageOneComment &&
						//         o1.pageTwoComment === o2.pageTwoComment)
						//   })
						// }
						disable={uniqBy(AdditionalConfigDetails, "wingId")[selectedWingIndex]?.typeOptions?.find(
							(f) => f.DisplayUnitTypeName === null || undefined || "",
						)}
						clicked={updateAdditionsValues}
					/>
				</Box>
			)}
		</Fragment>
	);
}

function EmailTemplate({ projectId }) {
	const [bookingEmailTemplate, setBookingEmailTemplate] = useState("");
	const [applicationEmailTemplate, setApplicationEmailTemplate] = useState("");
	const [docUrl, setDocUrl] = useState([]);
	const [olddocData,setOldDocData] = useState([])
	const [projectName, setProjectName] = useState("");

	const [bookingEmailTemplateHelperText, setBookingEmailTemplateHelperText] = useState("");
	const [applicationEmailTemplateHelperText, setApplicationEmailTemplateHelperText] = useState("");
	const [docUrlHelperText, setDocUrlHelperText] = useState("");

	useEffect(() => {
		if (projectId) {
			getProjectDetailsFromServer();
		}
	}, [projectId]);

	async function getProjectDetailsFromServer() {
		presentLoader();
		try {
			const projectDetailsResponse = await supabase.from("Projects").select("*").eq("projectId", projectId).maybeSingle();
			if (projectDetailsResponse?.data) {
				setProjectName(projectDetailsResponse?.data?.projectName);
				setBookingEmailTemplate(projectDetailsResponse?.data?.bookingEmailTemplate || '');
				setApplicationEmailTemplate(projectDetailsResponse?.data?.applicationEmailTemplate || '');
				// setBookingEmailTemplate(projectDetailsResponse?.data?.bookingEmailTemplate || defaultEmail);
				// setApplicationEmailTemplate(projectDetailsResponse?.data?.applicationEmailTemplate || defaultEmail);
				const { data, error } = await supabase.storage
					.from('projectagreements')
					.list(projectDetailsResponse?.data?.projectName, {
						limit: 100,
						offset: 0,
					});

				const _url = supabase.storage
					.from('projectagreements')
					.getPublicUrl(projectDetailsResponse?.data?.projectName)
					.data.publicURL;
				console.log(data, error, _url);
				if (data.length > 0) {
					let oldDoc = [];
					data.map((file, i) => {
						Object.assign(file, { url: `${_url}/${file.name}`, oldDoc: true });
						oldDoc.push(file);
					});
					setDocUrl(oldDoc);
          			setOldDocData(oldDoc)
					console.log(oldDoc);
				}
			} else {
				throw projectDetailsResponse?.error;
			}
			dismissLoader();
		} catch (error) {
			console.error(error);
			if (error?.message) {
				errorTost(error?.message);
			} else {
				errorTost("Something went wrong! Try again");
			}
			dismissLoader();
		}
	}

	async function updateEmailValues() {
		let flag = true;

		if (!bookingEmailTemplate) {
			setBookingEmailTemplateHelperText("Please enter email template.");
			flag = false;
		}
		if (!applicationEmailTemplate) {
			setApplicationEmailTemplateHelperText("Please enter email template.");
			flag = false;
		}
		if (docUrl.length === 0) {
			setDocUrlHelperText("Please upload documents.");
			flag = false;
		}

		if (!flag) {
			errorTost("Please enter valid inputs.");
			return;
		}

		try {
			presentLoader();
			const postBody = {
				bookingEmailTemplate: bookingEmailTemplate,
				applicationEmailTemplate: applicationEmailTemplate,
			};
			console.log(postBody);
			console.log("~~~");

			let _urlArray = [];
			let uploadArray = []

			docUrl?.forEach(v => {
				const selectedData = olddocData?.find(i => v?.id === i?.id)
				if (!selectedData) {
				  uploadArray.push(v)
				}
			  })
			for (const fileItem of uploadArray) {
				if (typeof fileItem === "object") {
					const UploadEmailDocResponse = await UploadEmailDoc(fileItem, `${projectName}/${fileItem.name}`);
					console.log("UploadEmailDocResponse -> ", UploadEmailDocResponse);
					if (UploadEmailDocResponse.success) {
						_urlArray.push(UploadEmailDocResponse.url);
					} else {
						errorTost(UploadEmailDocResponse.error);
					}
				}
			}
			if (_urlArray.length === uploadArray.length) {
				let updateResponse = await supabase.from("Projects").update(postBody).select("*").eq("projectId", projectId).maybeSingle();
				console.log("updateResponse => ", updateResponse);
				if (updateResponse?.data) {
					successTost("Changes saved successfully.");
					getProjectDetailsFromServer();
				} else {
					throw updateResponse.error;
				}
			} else {
				dismissLoader();
			}
		} catch (error) {
			console.error(error);
			if (error?.message) {
				errorTost(error?.message);
			} else {
				errorTost("Something went wrong! Try again");
			}
			dismissLoader();
		}
	}

	//Add Document Functionality
	function selectFiles() {
		let htmlElement = document.createElement("input");
		htmlElement.type = "file";
		htmlElement.accept = "application/pdf";
		htmlElement.multiple = true;
		htmlElement.click();
		htmlElement.onchange = onChangeSelectImage;
	}

	function onChangeSelectImage(e) {
		let _files = Object.keys(e.target.files).map((m) => e.target.files[m]);
		console.log(
			"files.size",
			_files.some((s) => s.size > 52428800)
		);
		if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
			// dev code
			if (!_files.some((s) => s.size > 52428800)) {
				if (!_files.some((s) => !s.type.includes("pdf"))) {
					let data = [...docUrl, ..._files];
					console.log(data);
					setDocUrl(data);
				} else {
					errorTost("Please Select only pdf files.");
				}
			} else {
				errorTost("Cannot upload as file size is larger than 50MB!");
			}
		} else {
			// production code
			if (!_files.some((s) => s.size > 5368709120)) {
				if (!_files.some((s) => !s.type.includes("pdf"))) {
					let data = [...docUrl, ..._files];
					console.log(data);
					setDocUrl(data);
				} else {
					errorTost("Please Select only pdf files.");
				}
			} else {
				errorTost("Cannot upload as file size is larger than 5GB!");
			}
		}
	}

	function DownloadDoc(docItem) {
		if (typeof docItem === "object") {
			presentLoader();
			var fr = new FileReader();
			fr.readAsDataURL(docItem);
			var blob = new Blob([docItem], { type: "application/pdf" });
			var objectURL = window.URL.createObjectURL(blob);
			var link = document.createElement("a");
			link.href = objectURL;
			link.download = `${docItem.name}`;
			document.body.appendChild(link);
			link.click();
			link.remove();
			successTost("Downloaded SuccessFully!");
			dismissLoader();
		} else {
			presentLoader();
			new JsFileDownloader({
				url: process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + docItem.split("/").splice(-3).join("/"),
			})
				.then(function () {
					dismissLoader();
					successTost("Downloaded SuccessFully!");
					// Called when download ended
				})
				.catch(function (error) {
					console.log(error);
					errorTost("Something went wrong!");
					// Called when an error occurred
				});
		}
	}

	async function DeleteDoc(docItem, documentIndex) {
		presentLoader();
		const { data, error } = await deleteUploadedEmailDoc(projectName, docItem);

		if (data) {
			dismissLoader();
			let payload = [...docUrl];
			payload.splice(documentIndex, 1);
			setDocUrl(payload);
			successTost(`${docItem?.name} deleted successfully!`);
		} else {
			dismissLoader();
			errorTost(error.message);
		}
	}
	return (
		<Fragment>
			<Box className={cssClasses.SubContainer}>
				<Box className={cssClasses.DivContainer}>
					<Box className={cssClasses.ProjectTitle}>Welcome PDF Configuration</Box>
				</Box>
			</Box>

			<Box height={"100%"} overflow={"auto"}>
				<Box className={cssClasses.MainDiv} flexDirection={"column !important"}>
					<Box className={cssClasses.FlexRow22} flexDirection={"column !important"}>
						<Box className={cssClasses.flexColumn} flex={1}>
							<Box className={cssClasses.FlexRow22} mt={2}>
								<Box className={cssClasses.additionalInputContainer} flex={"100% !important"}>
									<Typography sx={{ ...labelStyle }}> Booking Email Template </Typography>
									<Box className={`ck-height-apply `}>
										<CKEditor
											editor={ClassicEditor}
											config={{
												//    plugins: [Heading, 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
												toolbar: [
													"paragraph",
													"heading1",
													"heading2",
													"heading3",
													"heading4",
													"heading5",
													"heading6",
													"alignment",
													"heading",
													"|",
													"bold",
													"italic",
													"link",
													"bulletedList",
													"numberedList",
													"blockQuote",
													"undo",
													"redo",
												],
											}}
											data={bookingEmailTemplate}
											onReady={(editor) => {
												// You can store the "editor" and use when it is needed.
												// console.log("Editor is ready to use!", editor);
											}}
											onChange={(event, editor) => {
												const data = editor.getData();

												if (data) {
													setBookingEmailTemplateHelperText("");
												} else {
													setBookingEmailTemplateHelperText("Please Enter valid value.");
												}
												setBookingEmailTemplate(data);
											}}
											onBlur={(event, editor) => {
												// console.log("Blur.", editor);
											}}
											onFocus={(event, editor) => {
												// console.log("Focus.", editor);
											}}
										/>
										{bookingEmailTemplateHelperText && (
											<Typography sx={{ ...helperText }}> {bookingEmailTemplateHelperText} </Typography>
										)}
									</Box>
								</Box>

								<Box className={cssClasses.additionalInputContainer} flex={"100% !important"}>
									<Typography sx={{ ...labelStyle }}> Application Email Template </Typography>
									<Box className={`ck-height-apply `}>
										<CKEditor
											editor={ClassicEditor}
											className={cssClasses.ckEditorStyle}
											config={{
												//    plugins: [Heading, 'Paragraph', 'Bold', 'Italic', 'Essentials','List' ],
												toolbar: [
													"paragraph",
													"heading1",
													"heading2",
													"heading3",
													"heading4",
													"heading5",
													"heading6",
													"alignment",
													"heading",
													"|",
													"bold",
													"italic",
													"link",
													"bulletedList",
													"numberedList",
													"blockQuote",
													"undo",
													"redo",
												],
											}}
											data={applicationEmailTemplate}
											onReady={(editor) => {
												// You can store the "editor" and use when it is needed.
												// console.log("Editor is ready to use!", editor);
											}}
											onChange={(event, editor) => {
												const data = editor.getData();

												if (data) {
													setApplicationEmailTemplateHelperText("");
												} else {
													setApplicationEmailTemplateHelperText("Please Enter valid value.");
												}
												setApplicationEmailTemplate(data);
											}}
											onBlur={(event, editor) => {
												// console.log("Blur.", editor);
											}}
											onFocus={(event, editor) => {
												// console.log("Focus.", editor);
											}}
										/>
										{applicationEmailTemplateHelperText && (
											<Typography sx={{ ...helperText }}> {applicationEmailTemplateHelperText} </Typography>
										)}
									</Box>
								</Box>
								<Box>
									<Box className={cssClasses.inputWrapper}>
										<div className={cssClasses.documentLabelContainer}>
											<Typography sx={{ ...labelStyle }}> Add Documents * </Typography>{" "}
											<span className={cssClasses.documentSizeText}>
												File must be less than{" "}
												<span className={cssClasses.documentSize}>
													{!process.env.NODE_ENV || process.env.NODE_ENV === "development" ? "50 MB" : "5 GB"}
												</span>{" "}
												.
											</span>
										</div>
										<Box className={cssClasses.uploadDocumentWrapper}>
											{docUrl?.map((documentItem, documentIndex) => (
												<Box key={`document_${documentIndex}`} className={cssClasses.uploadDocumentCard}>
													<img src={DocumentPDFIcon} alt="Pdf" width={"40rem"} height={"40rem"} />
													<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
														<p>{typeof documentItem === "string" ? documentItem?.split("/").pop() : documentItem.name}</p>
													</div>

													<div style={{ display: "flex", flexDirection: "row", gap: "2rem", marginTop: "1rem" }}>
														<div
															onClick={() => DownloadDoc(documentItem)}
															id="PDF"
															className={cssClasses.uploadLabel}
															style={{ cursor: "pointer", textDecorationLine: "underline" }}
														>
															<p>Download</p>
														</div>
														<div
															onClick={() => DeleteDoc(documentItem, documentIndex)}
															className={cssClasses.uploadLabel}
															style={{ cursor: "pointer", textDecorationLine: "underline" }}
														>
															<p>Delete</p>
														</div>
													</div>
												</Box>
											))}
											<Box className={cssClasses.uploadDocumentCard}>
												<div
													className={cssClasses.uploadLabel}
													style={{ cursor: "pointer", textDecorationLine: "underline" }}
												>
													<p onClick={selectFiles}>
														<AddIcon style={{ width: "45px", height: "35px" }} />
													</p>
												</div>
											</Box>
										</Box>
										{docUrlHelperText && (
											<p style={{ color: "#d32f2f", fontSize: "1.4rem", marginLeft: "1rem" }}>{docUrlHelperText}</p>
										)}
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>

			<Box width={"fit-Content"} ml={"auto"} mt={"auto"}>
				<Button
					style={{
						fontSize: "1.6rem",
						lineHeight: "2.4rem",
						color: "#FFF",
						backgroundColor: "#155EEF",
						borderRadius: "0.8rem",
					}}
					padding={"0.8rem 2.6rem"}
					btnName={"Save Changes"}
					// btnIcon={<PlusIcon />}
					// iconPosition={'left'}
					disable={!Boolean(bookingEmailTemplate && applicationEmailTemplate)}
					clicked={updateEmailValues}
				/>
			</Box>
		</Fragment>
	);
}

const labelStyle = {
	fontFamily: "Inter-Medium",
	fontStyle: "normal",
	fontWeight: 500,
	fontSize: "1.4rem",
	lineHeight: "2rem",
	color: "#344054",
	marginBottom: "0.6rem",
};
const helperText = {
	fontSize: "1.4rem !important",
	margin: "0rem 0 0 0 !important",
	fontFamily: "Inter-Medium !important",
	lineHeight: "1.8rem !important",
	paddingTop: "0.5rem !important ",
	color: "#d32f2f",
};

const defaultEmail = `
  <div dir="ltr">
    <div>
      <div dir="ltr" data-smartmail="gmail_signature">
        <div dir="ltr">
          <div>
            <div>
              <span style="color:black;font-family:&quot;Trebuchet MS&quot;,sans-serif;font-size:16px">Dear Sir / Madam,</span>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gmail_quote">
      <div dir="ltr">
        <div class="gmail_quote">
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Greetings from Vilas Javdekar Developers.</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">It gives us an immense pleasure to welcome you to our VJ Parivaar!</span></strong></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Hearty congratulations and thank you for showing trust on Vilas Javdekar Developers.</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">We would like to share some valuable information with you which will help you in our entire journey.<strong>&nbsp;</strong>Meanwhile, request you to complete the payment part and rest of the documentary compliances. Kindly go through this email thoroughly. &nbsp;</span></p>
          <table style="border:none;border-collapse:collapse">
            <tbody>
              <tr>
                <td style="width:478.8pt;border:1pt solid black;padding:0cm 5.4pt;vertical-align:top">
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;<strong>Important&nbsp;Attachments&nbsp;and link&nbsp;with this email&nbsp;-</strong></span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">1</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">. <strong>Welcome&nbsp;Booklet</strong> which will give you a sneak peek into Vilas Javdekar Developers. &nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">2</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">. <strong>Cost Sheet</strong> - please check your detailed cost sheet with bifurcations and bank account details.&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">3</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">. <strong>Agreement Confirmation Form Link ( Mandatory )</strong></span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">4</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">. <strong>VJ Finserv Services Link&nbsp;</strong>( Applicable only if wish to opt for the services )&nbsp;</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
          <table style="border:none;border-collapse:collapse">
            <tbody>
              <tr>
                <td style="width:478.8pt;border:1pt solid black;padding:0cm 5.4pt;vertical-align:top">
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></strong></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Simple Steps to follow for Registration &amp; execution of Agreement :-&nbsp;</span></strong></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Step 1</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;- Get your home loan sanctioned from Bank / HFC (check VJ preferred Banks / bankers details in Booklet)</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Step 2</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;- Transfer funds as per cost sheet in the specified accounts Or you can submit chqs. at <strong><span style="background:yellow">VJ&nbsp;</span>CRM office.&nbsp;</strong> ( Prefer Online transfer )</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Step 3</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;- Fill Agreement Confirmation Link duly.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:11.2pt;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><a href="https://form.jotform.com/vilasjavdekardevelopers/agreement-confirmation-form---vj" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://form.jotform.com/vilasjavdekardevelopers/agreement-confirmation-form---vj&amp;source=gmail&amp;ust=1684912143721000&amp;usg=AOvVaw06IWFDbLvSBpuiS150iUGL"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:#1155cc">Click Here ----&gt;&nbsp;</span></a><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span><a href="https://form.jotform.com/vilasjavdekardevelopers/agreement-confirmation-form---vj" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://form.jotform.com/vilasjavdekardevelopers/agreement-confirmation-form---vj&amp;source=gmail&amp;ust=1684912143721000&amp;usg=AOvVaw06IWFDbLvSBpuiS150iUGL"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:#1155cc">https://form.jotform.<wbr>com/vilasjavdekardevelopers/<wbr>agreement-confirmation-form---<wbr>vj</span></a></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;<strong>Step 4</strong> - Post Successful completion of the above steps, you can be eligible for parking space selection if applicable with your investment.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;<strong>Step 5</strong> - Post your confirmation on the Agreement Draft, we will schedule the date of Registration at SRO office or E-registration and venue and time details will be informed by us through an email.&nbsp;</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
          <table style="border:none;border-collapse:collapse">
            <tbody>
              <tr>
                <td style="width:478.8pt;border:1pt solid black;padding:0cm 5.4pt;vertical-align:top">
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">Choose your parking while sitting at your Home (If applicable only :-)&nbsp;</span></strong></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">Step 1&nbsp;</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">– Post successful submission of Agreement confirmation form through link (Step no 3 as mentioned above), CRM will scrutinize&nbsp;and&nbsp;verify&nbsp;payments and documents.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">Step 2-</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">&nbsp;If all is okay then will share Parking Layouts and details with availability.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">Step 3&nbsp;</span></strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">- Based on the offered package, you can select your parking choice. Revision in the cost will be applicable if any upgradation in the choice of parking. Refer cost details in the cost sheet and connect with your Relationship manager.&nbsp;</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">&nbsp;</span></p>
          <table style="border:none;border-collapse:collapse">
            <tbody>
              <tr>
                <td style="width:478.8pt;border:1pt solid black;padding:0cm 5.4pt;vertical-align:top">
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></strong></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">IMPORTANT POINTERS TO BE NOTED -</span></strong></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">1.&nbsp;You need to pay Stamp duty and Registration charges through Link provided by email. We will be paying Stamp duty and registration charges as per details provided by you to us. In any event of breach of contract / cancellation, customer will be responsible to bear the losses and shall be solely responsible for any refund and follow up with Govt. if applicable.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">2. <strong>For E-registration, your mobile number must link with your Adhar card Number.</strong> E-registration offer shall be confirmed post validation of factors like, Location, Home loan Bank / HFC, Govt. Rules, VJ Policies etc.)</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">3</span><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">. All receipts of the payment will be handed over post registration with the original Agreement copy.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">4.&nbsp;C</span><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:#333333">oncession of 1% over the prevailing stamp duty rate on property transactions can be availed if registration is executed in Women applicants name only. Kindly inform us through email if you wish to avail the benefit, we shall share revised cost sheet. This is applicable only for Residential property.&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:#333333">5.&nbsp;</span><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">Customers need to file TDS while login to the Income Tax Portal&nbsp;within a stipulated time frame post execution of the agreement (If consideration value is more than 50 Lacks ). Advise to take your CA’s help in TDS filing.&nbsp;You may connect the following external consultants for filing TDS. (This is chargeable service )</span></p>
                  <table style="border:none;width:265.0pt;border-collapse:collapse">
                    <tbody>
                      <tr>
                        <td style="width:122.0pt;border:solid windowtext 1.0pt;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><strong><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">Name&nbsp;</span></strong></p>
                        </td>
                        <td style="width:143.0pt;border:solid windowtext 1.0pt;border-left:none;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><strong><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">Kunal Nathani&nbsp;</span></strong></p>
                        </td>
                      </tr>
                      <tr>
                        <td style="border:solid windowtext 1.0pt;border-top:none;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">CA Registration Number&nbsp;</span></p>
                        </td>
                        <td style="border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">182152</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td style="border:solid windowtext 1.0pt;border-top:none;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">Email ID&nbsp;</span></p>
                        </td>
                        <td style="border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><a href="mailto:jca.kunalnathani@gmail.com" target="_blank"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:#1155cc">jca.kunalnathani@gmail.com</span></a></p>
                        </td>
                      </tr>
                      <tr>
                        <td style="border:solid windowtext 1.0pt;border-top:none;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">Contact no (+91)</span></p>
                        </td>
                        <td style="border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:.75pt .75pt 0cm .75pt;height:15.0pt">
                          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;text-align:center"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif;color:black">9921181161</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
          <table style="border:none;border-collapse:collapse">
            <tbody>
              <tr>
                <td style="width:478.8pt;border:1pt solid black;padding:0cm 5.4pt;vertical-align:top">
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">VJ Finserv Services –</span></strong></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">At VJ, with our philosophy of putting people-first, we strive to make every aspect of home buying easier and hassle free. With VJ Finserv, we offer expert assistance that cater to different needs at different stages.</span></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Click to know more about services with the price details.</span><a href="https://form.jotform.com/vilasjavdekardevelopers/vj-finserv-services" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://form.jotform.com/vilasjavdekardevelopers/vj-finserv-services&amp;source=gmail&amp;ust=1684912143721000&amp;usg=AOvVaw2IS8wWiUNfaY8mdvEFmn5L"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif">&nbsp;https://form.jotform.<wbr>com/vilasjavdekardevelopers/<wbr>vj-finserv-services</span></a></p>
                  <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">*Note, these services are not mandatory and are at extra cost.</span></strong></p>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Feel free to get in touch with us if you have any queries regarding any information mentioned in the same.</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Be Safe and Take care !&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">Best time to Assist on call / in person at <span style="background:yellow">VJ CRM office )</span> - 10.30 AM to 6 PM (Monday to Saturday)</span></strong></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">East Office &nbsp; –&nbsp;</span></strong><span style="font-family:&quot;Verdana&quot;,sans-serif;color:black;background:white">VJ Yashwin Orizzonte Office, Kharadi, Pune.&nbsp;</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:11.2pt;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-family:&quot;Verdana&quot;,sans-serif;color:black;background:white">Google Map Link :&nbsp;</span><a href="https://goo.gl/maps/2kAZYze2GLKiwT4d9" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://goo.gl/maps/2kAZYze2GLKiwT4d9&amp;source=gmail&amp;ust=1684912143721000&amp;usg=AOvVaw2KpvEshlzqG0sBtshd8tam"><span style="font-family:&quot;Verdana&quot;,sans-serif;background:white">https://goo.gl/maps/<wbr>2kAZYze2GLKiwT4d9</span></a></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><strong><span style="font-size:16px;font-family:&quot;Trebuchet MS&quot;,sans-serif;color:black">West office -&nbsp;</span></strong><span style="font-family:&quot;Verdana&quot;,sans-serif;color:black;background:white">Vilas Javdekar Developers , 5TH floor, "CENTRO" - Palash Plus CHS, &nbsp;Opp EURO School, Wakad, PUNE – 57.</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;background:white"><span style="font-family:&quot;Trebuchet MS&quot;,sans-serif;color:#222222">Google MAP Location of Vj's Wakad office -</span></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;line-height:107%;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif;background:white"><a href="https://www.google.co.in/maps/place/Palash+Plus+Apartments,+Kalewadi+-+Wakad+Rd,+Vishnu+Dev+Nagar,+Wakad,+Pimpri-Chinchwad,+Maharashtra+411057/@18.5998437,73.7692003,17z/data=!3m1!4b1!4m5!3m4!1s0x3bc2b96cd4323175:0xecc0f94190c74e57!8m2!3d18.5998386!4d73.771389?hl=en" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://www.google.co.in/maps/place/Palash%2BPlus%2BApartments,%2BKalewadi%2B-%2BWakad%2BRd,%2BVishnu%2BDev%2BNagar,%2BWakad,%2BPimpri-Chinchwad,%2BMaharashtra%2B411057/@18.5998437,73.7692003,17z/data%3D!3m1!4b1!4m5!3m4!1s0x3bc2b96cd4323175:0xecc0f94190c74e57!8m2!3d18.5998386!4d73.771389?hl%3Den&amp;source=gmail&amp;ust=1684912143721000&amp;usg=AOvVaw2GKGBhx247vi9264YX-Trd"><span style="font-family:&quot;Trebuchet MS&quot;,sans-serif">https://www.google.co.in/maps/<wbr>place/Palash+Plus+Apartments,+<wbr>Kalewadi+-+Wakad+Rd,+Vishnu+<wbr>Dev+Nagar,+Wakad,+Pimpri-<wbr>Chinchwad,+Maharashtra+411057/<wbr>@18.5998437,73.7692003,17z/<wbr>data=!3m1!4b1!4m5!3m4!<wbr>1s0x3bc2b96cd4323175:<wbr>0xecc0f94190c74e57!8m2!3d18.<wbr>5998386!4d73.771389?hl=en<br>&nbsp;</span></a></p>
          <p style="margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:&quot;Calibri&quot;,sans-serif"><span style="font-size:16px;font-family:&quot;Times New Roman&quot;,serif">&nbsp;</span></p>
        </div>
      </div>
    </div>
  </div>
`;
